import {
  Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormHelperText, Grid,
  IconButton, InputAdornment, Radio, RadioGroup, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Tooltip, Typography, CircularProgress
} from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import './commonBilling.css'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from '../../../../Utility/Constants';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Colors } from '../../../../Styles/Colors';
import { DateTimePicker, LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { clearCachevalue, getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { AmountFormat, checkTransationMandatory, convertDateTime, debounce, formatDate, formatDateAndTime, formatDateAndTimeMeth2 } from '../../../../Components/CommonFunctions/CommonFunctions';
import { useHistory } from 'react-router-dom';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import { BillSuccessPoPUp, ConfirmPopup, ReasonPopup, RefundReceivePopup } from '../../../../Components/Common Components/CommonComponents';
import Loader from '../../../../Components/Loader';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { DateTime } from 'luxon';
import { DataGrid } from '@mui/x-data-grid';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CommentIcon from '@mui/icons-material/Comment';
import CloseIcon from '@mui/icons-material/Close';

const COMMON_STYLES = {
  HEIGHT: '4.5dvh',
  FONT_SIZE_XS: '0.7rem',
  FONT_SIZE_SM: '0.8rem',
  FONT_SIZE_MD: '0.85rem',
  FONT_SIZE_L: '0.9rem',
  FONT_WEIGHT: 600
}
const IpFinalSettlement = (props) => {
  let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
  const showPharmacy = loggedInUserInfo?.show_pharmacy_advance;
  const patientData = JSON.parse(getCachevalue("IppatientData"))
  const [billingList, setBillingList] = useState([])
  const [dupBillList, setDupBillList] = useState('[]')
  const [billing, setBilling] = useState({
    pharmacy_bills: [],
    ot_bills: [],
    billDocSugg: [],
    tempPackSugg: [],
    serviceSugg: [],
    selected_bill_doc: null,
    selected_bill_doc_id: null,
    selected_service: null,
    selected_temp_pack: null,
    service_data: {
      rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
      doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
      hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
      interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
      service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
      edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
      end_time: '', doc_discount_amt: '', doc_discount_percent: '',
      hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
      concession_percent: '', gst_percent: 0, hours: '', minutes: '',
      concession_comments: '', service_details_id: '', doctor_id: '',
      review_days: '', review_count: '', charge_id: '', doctor_name: '',
      gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
      taxable_amount: '', sub_total_amount: '', round_off: '',
      received_amount: '', net_amount: '', concession_percent_w_r: '',
      doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
      doctor_percent_w_r: '', hospital_percent_w_r: '',
      module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
      service_head_id: null, doctor_name: '', doctor_id: '', concession_percent_w_r: '',
    },
    overall_data: {
      sub_total: '', overall_discount_amt: '',
      round_off: '', payable_amt: '', taxable_amount: '',
      gst_amount: '', sgst_amount: '', cgst_amount: '', net_amount: '',
      overall_discount_percent: '', overall_discount_percent_w_r: '',
      concession_applicable: '',
    },
    isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
    cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
    upi_no: '', cheque_amt: '', cheque_no: '',
    isEdit: false, selectedIndex: null, startTimeOpen: false, endTimeOpen: false,
    checkAll: true, checkOP: true, checkLab: true, checkPharmacy: true,
    checkRadiology: true, checkCanteen: true,
    patientData: {}, paymentDetails: {}, is_Insurance_credit: false, final_amount: 0, round_off: 0, final_amount_without_roundoff: 0, total_amount: 0, total_concession_amount: 0, total_gst_amount: 0,
    pharmacy_net_amount: 0, ip_net_amount: 0,
    selected_insurance_amt: "", advance_deducted: "", pay_from_advance: false, credit_type: "",
    selected_insuance_company: "", selected_policy_number: "", selected_corporate_amt: "", insurance_id:'',
    selected_corporate_company: "", selected_employee_number: "", selected_corporate_amt: "", selected_patient_amt: "", refund_clicked: false,
    bill_id: null, pending_orders: [], openPendingPop: false,
    applyFinalConcession: false, edit_orders: false, selectedOverall: false, overAllconcessionPercentage: '', overallConcessionAmount: '', fromFinalConcession: false,
    postBillClicked: false, include_pharmacy_bills: showPharmacy ? false : true, include_ot_bills: true, openCancelPopup: false,
    wardList: [], selectedWard: null, overallConcessionAlert: false, selectedSubIndex: null, selectedServiceIndex: null,  co_payment_amount : "",
    credit_due_date: null, creditDueOpen: false, primary_Credit: '', generateFinalBillClicked: false, total_advance_adjusted : ""
  })
  let RoomChargeGST = JSON.parse(localGetItem('gst_room_charge'))
  const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
  const [popupValues, setPopupValues] = useState({})
  const [openPopup, setOpenPopup] = useState(null)
  const [selectedRadio, setSelectedRadio] = useState('input')
  const [PatientDetails, setPatientDetails] = useState({});
  const [InsuranceList, setInsuranceList] = useState([]);
  const [CorporateList, setCorporateList] = useState([]);
  const [GivenAmount, setGivenAmount] = useState(0);
  const [pendindOrder, setPendingOrder] = useState(null)
  const [isLoader, setIsLoader] = useState(false);
  const [FinalBillPosted, setFinalBillPosted] = useState(false);
  const [annualFeeAlert, setAnnualFeeAlert] = useState(false)
  const [requestState, setRequestState] = useState({
    fromPendingList: false,
    fromApprover: false,
    fromCancel: false,
    status: '',
    selectedApprover: '',
    selectedApproverId: null,
    discount_remarks: '',
    approverList: [],
    pending_list_id: null,
    isDelete: false,
    rejected_remarks: '',
    hasConcession: false,
    pendingCancel: false,
    modifyBill: false
  })

  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })
  let history = useHistory()
  const [historyData, setHistoryData] = useState({})
  const [eBill, seteBill] = useState({
    smsDis: '',
    isEbill: false,
    isSMSText: '',
    WhatsappDis: '',
    isWhatsApp: false,
    isWhatsappText: '',
  })
  const [allowSms, setAllowSms] = useState(false);
  const [allowWhatsapp, setAllowWhatsapp] = useState(false);
  const [billsummaryID, setbillsummaryID] = useState(null)
  const [receiptID, setreceiptID] = useState(null)
  const [searchKey, setsearchKey] = useState('');
  const [ServiceCount, setServiceCount] = useState(false);
  const [successPopup, setSuccessPopup] = useState({
    SuccessInvoice_ID: null,
    isCredit: false,
    bill_receipt_id: null,
    successText: '',
  })
  const [billnumbers, setBillnumbers] = useState(null)
  const STYLES = {
    FONT_SIZE_LOW_2: "0.8rem",
    FONT_SIZE_LOW_3: "0.7rem",
    FONT_WEIGHT: "bold"
  };

  const InvestigationList = localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : []

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
      transmit: false,
      saveLoad: false
    })
    setBilling((prev) => ({ ...prev, postBillClicked: false }))
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
    setBilling((prev) => ({ ...prev, postBillClicked: false }))
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const clearRightData = (RightClear = false) => {
    setBilling((prev) => ({
      ...prev,
      service_data: {
        rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
        doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
        hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
        interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
        service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
        edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
        end_time: '', doc_discount_amt: '', doc_discount_percent: '',
        hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
        concession_percent: '', gst_percent: 0, hours: '', minutes: '',
        concession_comments: '', service_details_id: '', doctor_id: '',
        review_days: '', review_count: '', charge_id: '', doctor_name: '',
        gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
        taxable_amount: '', sub_total_amount: '', round_off: '',
        received_amount: '', net_amount: '', concession_percent_w_r: '',
        doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
        doctor_percent_w_r: '', hospital_percent_w_r: '',
        module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
        service_head_id: null, doctor_name: '', doctor_id: ''
      },
      selected_service: null,
      refund_clicked: false,
      isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
      cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
      upi_no: '', cheque_amt: '', cheque_no: '',
      isEdit: false, selectedIndex: null, startTimeOpen: false, endTimeOpen: false,
      checkAll: true, checkOP: true, checkLab: true, checkPharmacy: true,
      checkRadiology: true, checkCanteen: true,
      is_Insurance_credit: false, final_amount: 0, round_off: 0, final_amount_without_roundoff: 0, pharmacy_net_amount: 0, ip_net_amount: 0, total_amount: 0, total_concession_amount: 0, total_gst_amount: 0,
      selected_insurance_amt: "", advance_deducted: "", pay_from_advance: false, credit_type: "",
      selected_insuance_company: "", selected_policy_number: "", selected_corporate_amt: "", insurance_id: '',
      selected_corporate_company: "", selected_employee_number: "", selected_corporate_amt: "", selected_patient_amt: "", refund_clicked: false,
      bill_id: null,
      applyFinalConcession: RightClear, edit_orders: false, selectedOverall: false, overAllconcessionPercentage: '', overallConcessionAmount: '', postBillClicked: false, fromFinalConcession: false, generateFinalBillClicked: false
    }))
    setDupBillList('[]');
    setTimeout(() => onClearServiceData(), 50);
    getPatientDetails(PatientDetails?.ip_admission_id)
  }

  const ReasonPopupClose = () => {
    setBilling((prev) => ({ ...prev, refund_clicked: false }))
  }

  const LoaderFunction = (key) => {
    setIsLoader(key);
  };


  const postRefund = (datas) => {
    try {
      LoaderFunction(true);
      let payment = []
      if (datas?.isCash) {
        payment.push(1)
      }
      if (datas?.isUPI) {
        payment.push(3)
      }
      if (datas?.isBankTranfer) {
        payment.push(5)
      }
      let data = {
        "patient_id": PatientDetails?.patient_id || null,
        "ip_admission_id": PatientDetails?.ip_admission_id || null,
        "advance_amount": 0,
        "is_refund": true,
        "refund_amount": +datas?.RefundableAmt || 0,
        "cash_amount": +datas?.CashAmount || 0,
        "card_amount": 0,
        "upi_amount": +datas?.UPIAmount || 0,
        "bank_amount": +datas?.BankTfrAmount || 0,
        "cheque_amount": 0,
        "payment_mode": payment,
        "card_ref_no": "",
        "upi_ref_no": datas?.UPINumber || "",
        "bank_ref_no": datas?.BankTfrNumber || "",
        "cheque_ref_no": ""
      }

      RestAPIService.create(data, Serviceurls.CASH_COUNTER_ADVANCE_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            LoaderFunction(false);
            successMessage(response.data.message);
            getPatientDetails(PatientDetails?.ip_admission_id || null)
            setBilling((prev) => ({
              ...prev,
              refund_clicked: false
            }))
            clearRightData()
          }
        }).catch((error) => {
          LoaderFunction(false);
          if (error?.response?.data?.message) {
            errorMessage(error.response.data.message);
          } else {
            errorMessage(error.message);
          }
        });
    }
    catch (error) {
      errorMessage(error.message)
    }
  }

  // API INTEGRATION STARTS =====>

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (history?.location?.state?.Patient_details) {
      let historyData = history?.location?.state?.Patient_details
      setHistoryData(historyData)
      if (history?.location?.state?.Patient_details?.approver_id) {
        getPatientDetails(historyData?.ip_admission_id)
      }
      else {
        getPatientDetails(historyData?.id)
      }
    }
    if (history?.location?.state?.fromPendingList) {
      setRequestState((prevstate) => ({
        ...prevstate,
        fromPendingList: true,
      }))
    }
    if (history?.location?.state?.fromCancel) {
      setRequestState((prevstate) => ({
        ...prevstate,
        fromCancel: true,
        status: "Cancelled"
      }))
    }
    if (history?.location?.state?.fromApprover) {
      setRequestState((prevstate) => ({
        ...prevstate,
        fromApprover: true,
      }))
    }
    if (history?.location?.state?.Patient_details?.approver_id) {
      setRequestState((prevstate) => ({
        ...prevstate,
        selectedApproverId: history?.location?.state?.Patient_details?.approver_id || null,
        discount_remarks: history?.location?.state?.Patient_details?.remarks || '',
        pending_list_id: history?.location?.state?.Patient_details?.id || null,
        status: history?.location?.state?.Patient_details?.request_status || null,
      }))
      setBilling((prev) => ({ ...prev, applyFinalConcession: true }))
    }
    let smsConfig = JSON.parse(localGetItem("smsConfig"))
    const UserData = JSON.parse(localGetItem('loggedInUserInfo'))
    let allowSms = smsConfig?.ip_bill_sms ? smsConfig?.ip_bill_sms : false
    let allowWhatsapp = UserData?.whatsapp_config?.ip_invoice ? UserData?.whatsapp_config?.ip_invoice : false
    setAllowSms(allowSms)
    setAllowWhatsapp(allowWhatsapp)
    getInsuranceList()
    getCorporateDetails()
    getApporverListData()
    getTemplateList(history?.location?.state?.Patient_details?.patient_id)
  }, [])

  useEffect(() => {
    setGivenAmount((
      (+billing?.selected_insurance_amt || 0) +
      (+billing?.cash_amt || 0) +
      (+billing?.card_amt || 0) +
      (+billing?.upi_amt || 0) +
      (+billing?.bank_amt || 0) +
      (+billing?.cheque_amt || 0) +
      (+billing?.selected_corporate_amt || 0) +
      (+billing?.selected_patient_amt || 0) +
      (+billing?.advance_deducted || 0)))
    let TotalAmount = (+billing?.cash_amt || 0) + (+billing?.card_amt || 0) + (+billing?.bank_amt || 0) + (+billing?.upi_amt || 0) + (+billing?.cheque_amt || 0) + (+billing?.advance_deducted || 0)
    if (TotalAmount < +billing?.co_payment_amount) {
      setBilling((prev) => ({
        ...prev,
        co_payment_amount: ""
      }))
    }
  }, [
    billing?.final_amount,
    billing?.selected_insurance_amt,
    billing?.cash_amt, billing?.card_amt, billing?.upi_amt, billing?.bank_amt, billing?.cheque_amt,
    billing?.selected_corporate_amt,
    billing?.selected_patient_amt,
    billing?.advance_deducted])

  useEffect(() => {
    if (billing?.postBillClicked) {
      if (billing?.applyFinalConcession) {
        postBillingData()
      } else {
        postBillingData(billing?.generateFinalBillClicked ? false : true)
      }
    }
  }, [billing?.postBillClicked])

  useEffect(() => {
    if (requestState?.triggerPostBill) {
      setBilling((prev) => ({
        ...prev,
        postBillClicked: true
      }));
      setRequestState((prev) => ({
        ...prev,
        triggerPostBill: false
      }));
    }
  }, [billingList]);

  useEffect(() => {
    if (billingList?.length) {
      let totalConcession = billingList.reduce((acc, item) => {
        if (item.package_type === 'Package' || item.package_type === 'Assorted') {
          if (item.billing_display === 'Assorted Package Name' || item.billing_display === 'Package Name') {
            acc += +item?.concession_amt || 0;
          } else if (item.billing_display === 'Assorted Service Head') {
            item?.package_line?.forEach(pack => {
              acc += +pack?.concession_amt || 0;
            });
          } else if (item.billing_display === 'Service Head' || item.billing_display === 'Service Name') {
            item?.package_line?.forEach(pack => {
              pack?.service_data?.forEach(service => {
                acc += +service?.concession_amt || 0;
              });
            });
          }
        } else {
          if (item?.membership_discount_percentage) {
            acc += 0
          } else {
            acc += +item?.concession_amt || 0;
          }
        }
        return acc;
      }, 0);
      let hasConcession = totalConcession > 0;
      setRequestState((prev) => ({ ...prev, hasConcession: hasConcession }))
    }
  }, [billingList])

  useEffect(() => {
    getServiceListData()
  }, [billing?.selectedWard, billing.selected_bill_doc])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (ServiceCount && searchKey?.length >= 3) {
        getServiceListData(searchKey);
      } else if (ServiceCount && !searchKey) {
        setBilling((prev) => ({ ...prev, serviceSugg: [] }))
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey, ServiceCount]);

  useEffect(() => {
    if (PatientDetails?.ip_admission_id) {
      getIpOrderListData(PatientDetails?.ip_admission_id)
    }
  }, [billing?.include_ot_bills, billing?.include_pharmacy_bills])

  useEffect(() => {
    const FetchingAccess = localGetItem("auto_fetch_bill_amount_to_payment");
    if (!billing.isCash) {
      setBilling((prev) => ({
        ...prev,
        cash_amt: "",
        cash_collected: "",
        balance_amt: "",
      }));
    }
    if (!billing.isCard) {
      setBilling((prev) => ({
        ...prev,
        card_amt: "",
        card_no: "",
      }));
    }
    if (!billing.isUPI) {
      setBilling((prev) => ({
        ...prev,
        upi_amt: "",
        upi_no: "",
      }));
    }
    if (!billing.isCheque) {
      setBilling((prev) => ({
        ...prev,
        cheque_amt: "",
        cheque_no: "",
      }));
    }
    if (!billing.isBank) {
      setBilling((prev) => ({
        ...prev,
        bank_amt: "",
        bank_no: "",
      }));
    }
    if (FetchingAccess === "true") {
      setBilling((prev) => ({
        ...prev,
        cash_amt: prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? prev.pay_from_advance ? (prev.final_amount - prev.advance_deducted) : prev.final_amount : prev.cash_amt,
        card_amt: !prev.isCash && prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? prev.pay_from_advance ? (prev.final_amount - prev.advance_deducted) : prev.final_amount : prev.card_amt,
        upi_amt: !prev.isCash && !prev.isCard && prev.isUPI && !prev.isBank && !prev.isCheque ? prev.pay_from_advance ? (prev.final_amount - prev.advance_deducted) : prev.final_amount : prev.upi_amt,
        bank_amt: !prev.isCash && !prev.isCard && !prev.isUPI && prev.isBank && !prev.isCheque ? prev.pay_from_advance ? (prev.final_amount - prev.advance_deducted) : prev.final_amount : prev.bank_amt,
        cheque_amt: !prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && prev.isCheque ? prev.pay_from_advance ? (prev.final_amount - prev.advance_deducted) : prev.final_amount : prev.cheque_amt,
      }));
    }
  }, [billing?.isCash, billing?.isCard, billing?.isUPI, billing?.isBank, billing?.isCheque]);

  const getApporverListData = () => {
    try {
      RestAPIService.getAll(Serviceurls.NEW_BILLING_APPROVER_LIST + '?module=' + 'fo')
        .then((response) => {
          if (response?.data?.status === 'success') {
            setRequestState((prev) => ({ ...prev, approverList: response?.data?.data.filter(user => user.is_frontoffice) || [] }))
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error?.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getDoctorList = (DocId) => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
        .then((response) => {
          if (response?.data?.status === 'success') {
            setBilling((prev) => ({
              ...prev,
              billDocSugg: response?.data?.data,
              selected_bill_doc: response?.data?.data?.find((list) => list?.doctor_id === DocId)
            }))
            getWardList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getWardList = () => {
    try {
      RestAPIService.getAll(Serviceurls.WARD_CONFIG)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let selectedWard = response?.data?.data?.find(ward => ward?.id === (history?.location?.state?.Patient_details?.ward_id));
            setBilling((prev) => ({ ...prev, wardList: response?.data?.data, selectedWard: selectedWard }))
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }


  const getInsuranceList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
        .then((response) => {
          if (response?.data?.status === 'success') {
            setInsuranceList(response?.data?.data || [])
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getCorporateDetails = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
        .then((response) => {
          if (response?.data?.status === 'success') {
            setCorporateList(response?.data?.data || [])
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getPatientDetails = (id) => {
    let historyData = history?.location?.state?.Patient_details
    try {
      LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.IP_PATIENT_DETAILS_NEW + `?admission_id=${id}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            setPatientDetails(response?.data?.data[0] || null)
            setBilling((prev) => ({
              ...prev,
              credit_type: response?.data?.data[0]?.credit_type === "Insurance credit" ? "insurance" : response?.data?.data[0]?.credit_type === "Corporate credit" ? "corporate" : response?.data?.data[0]?.credit_type === "Patient credit" ? "patient" : "",
              is_Insurance_credit: response?.data?.data[0]?.credit_type === "Insurance credit",
              advance_deducted: !historyData?.is_final_bill_generated ? '' : response?.data?.data[0]?.advance_amount ? +response?.data?.data[0]?.advance_amount : "",
              pay_from_advance: !historyData?.is_final_bill_generated ? false : response?.data?.data[0]?.advance_amount ? true : false,
              selected_bill_doc: response?.data?.data[0]?.doctor_name,
              selected_bill_doc_id: response?.data?.data[0]?.doctor_id,
              selected_insuance_company: (response?.data?.data[0]?.insurance_name || ""),
              selected_policy_number: (response?.data?.data[0]?.policy_no || ""),
              selected_corporate_company: (response?.data?.data[0]?.employer_name || ""),
              selected_employee_number: (response?.data?.data[0]?.id_no || ""),
              insurance_id: (response?.data?.data[0]?.insurance_id || ""),
              primary_Credit: response?.data?.data[0]?.credit_type === "Insurance credit" ? "Insurance credit" : response?.data?.data[0]?.credit_type === "Corporate credit" ? "Corporate credit" : response?.data?.data[0]?.credit_type === "Patient credit" ? "Patient credit" : "",
            }))
            getDoctorList(response?.data?.data[0]?.doctor_id)
            getIpOrderListData(response?.data?.data[0]?.ip_admission_id, response?.data?.data[0])
          }
        }).catch((error) => {
          LoaderFunction(false);
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      LoaderFunction(false);
      errorMessage(error.message)
    }
  }

  const getPatientBillDetailedPrint = () => {
    try {
      LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.IP_DETAILED_PRINT_FO + "?ip_admission_id=" + historyData?.id + "&export_type=pdf").
        then((response) => {
          LoaderFunction(false);
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          LoaderFunction(false);
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      LoaderFunction(false);
      errorMessage(error.message)
    }
  }

  const getServiceListData = (searchKey = '') => {
    try {
      let moduleType = 'IP'
      let patientType = "Old Patient"
      let doctor_id = billing.selected_bill_doc?.doctor_id ? billing.selected_bill_doc?.doctor_id : billing.selected_bill_doc_id
      if (billing?.selectedWard?.id && doctor_id) {
        RestAPIService.getAll(
          Serviceurls.NEW_BILLING_OP_SERVICE_GET +
          '?patient_type=' + patientType +
          '&module_type=' + moduleType +
          '&ward_id=' + (billing?.selectedWard?.id || "") +
          '&doctor_id=' + doctor_id +
          '&patient_id=' + (PatientDetails?.patient_id || "") +
          (historyData?.ip_admission_id ? `&ip_admission_id=${historyData?.ip_admission_id}` : "") +
          '&search_key=' + searchKey
        ).then((response) => {
          if (response?.data?.status === 'success') {
            setBilling((prev) => ({ ...prev, serviceSugg: response?.data?.data }))
            if (!ServiceCount) {
              setServiceCount(response.data.service_length > 1000 ? true : false)
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getTemplateList = (patinetID) => {
    try {
       RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_LIST + `?module_type=ip&patient_id=${PatientDetails?.patient_id || patinetID}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            setBilling((prev) => ({ ...prev, tempPackSugg: response?.data?.data }))
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getTemplateData = (value) => {
    try {
      let patientType = "Old Patient"
      let template_id = value?.template_id ? value?.template_id : ''
      let package_id = value?.package_id ? value?.package_id : ''
      let assorted_id = value?.assorted_package_id ? value?.assorted_package_id : ''
      let doctor_id = billing.selected_bill_doc?.doctor_id ? billing.selected_bill_doc?.doctor_id : billing.selected_bill_doc_id
      RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_GET
        + '?template_id=' + template_id +
        '&package_id=' + package_id +
        '&doctor_id=' + doctor_id +
        '&patient_type=' + patientType +
        '&assorted_id=' + assorted_id +
        '&from_billing=true' +
        '&patient_id=' + PatientDetails?.patient_id
      ).then((response) => {
        if (response?.data?.status === 'success') {
          let packageName = response?.data?.data?.package_name
          let packData = response?.data?.data
          if (packData?.package_type === 'Package' || packData?.package_type === 'Assorted') {
            let billList = setPackageListData(packData)
            let IpOrdersTotal = Math.round(
              billList.reduce((sum, pkg) => {
                return sum + pkg.package_line.reduce((lineSum, line) => {
                  return lineSum + line.service_data.reduce((dataSum, service) => {
                    return dataSum + (Number(service?.service_with_gst_total_amt) || 0);
                  }, 0);
                }, 0);
              }, 0)
            );
            let OtherBillsTotal = Math.round((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let IpOrdersTotal_without_roundoff = billList.reduce((sum, pkg) => {
              return sum + pkg.package_line.reduce((lineSum, line) => {
                return lineSum + line.service_data.reduce((dataSum, service) => {
                  return dataSum + (Number(service?.service_with_gst_total_amt) || 0);
                }, 0);
              }, 0);
            }, 0);
            let OtherBillsTotal_without_roundoff = ((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let RoundOff = +(Math.round((((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) - (((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) || 0
            setDupBillList(JSON.stringify([...billingList, ...billList]));
            setBilling((prev) => ({
              ...prev,
              final_amount_without_roundoff: ((IpOrdersTotal) || 0) + ((OtherBillsTotal) || 0),
              // pharmacy_net_amount: (OtherBillsTotal || 0),
              // ip_net_amount: (IpOrdersTotal || 0),
              round_off: +parseFloat(RoundOff.toFixed(2)),
              final_amount: ((IpOrdersTotal) || 0) + ((OtherBillsTotal) || 0),
            }))
            setBillingList((prev) => [...prev, ...billList]);
          } else {
            let data = response?.data?.data?.package_line ? response?.data?.data?.package_line : response?.data?.data?.package_line
            let billList = setBillingListData(data)
            let IpOrdersTotal = Math.round(billList.reduce((sum, item) => sum + item?.service_with_gst_total_amt, 0))
            let OtherBillsTotal = Math.round((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let IpOrdersTotal_without_roundoff = (billList.reduce((sum, item) => sum + item?.service_with_gst_total_amt, 0))
            let OtherBillsTotal_without_roundoff = ((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let RoundOff = +(Math.round((((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) - (((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) || 0

            setDupBillList(JSON.stringify([...billingList, ...billList]));
            setBilling((prev) => ({
              ...prev,
              final_amount_without_roundoff: ((IpOrdersTotal) || 0) + ((OtherBillsTotal) || 0),
              // pharmacy_net_amount: (OtherBillsTotal || 0),
              // ip_net_amount: (IpOrdersTotal || 0),
              round_off: +parseFloat(RoundOff.toFixed(2)),
              final_amount: ((IpOrdersTotal) || 0) + ((OtherBillsTotal) || 0),
            }))
            setBillingList((prev) => [...prev, ...billList]);
          }
        }
      }).catch((error) => {
        if (error?.response?.data?.message) {
          errorMessage(error?.response?.data?.message)
        } else {
          errorMessage(error.message)
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const discountZero = (billList = billingList, status = "") => {
    if (history?.location?.state?.fromCancel || requestState?.fromCancel || status === "Rejected") {
      setBilling((prev) => ({
        ...prev,
        total_concession_amount: 0,
        selectedOverall: false,
        overall_data: {
          ...billing?.overall_data, ...{
            overall_discount_percent: "",
            overall_discount_percent_w_r: "",
            overall_discount_amt: "",
          }
        }
      }))
      let splitData = splitUp("", billList)
      setBillingList(splitData?.result);

      // Postpone setting postBillClicked until billingList updates
      if (status === "Rejected") {
        setRequestState((prev) => ({
          ...prev,
          triggerPostBill: true // <- set a flag
        }));
      }
    }
  }

  const getIpOrderListData = (AdmId = PatientDetails?.ip_admission_id, PatientData = null, FromReset = false) => {
    let historyData = history?.location?.state?.Patient_details
    try {
      LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.NEW_BILLING_FINAL_SETTLE_GET + `?ip_admission_id=${AdmId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let billList = setBillingListData((response?.data?.data || []), response?.data?.bill_id, true)
            let bill_numbers = response?.data?.bill_numbers ? response?.data?.bill_numbers : null
            let totalAmt = 0; let totalConcessionAmt = 0; let totalGstAmt = 0; let IpOrdersTotal = 0; let IpOrdersTotal_without_roundoff = 0; let TotalAdvAdjusted = 0;
            billList?.forEach(item => {
              let IsAdjusted = item?.is_advance_adjusted ?? false
              if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
                if (item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') {
                  totalAmt += item?.total_amt
                  totalConcessionAmt += item?.concession_amt
                  totalGstAmt += item?.gst_amount
                  TotalAdvAdjusted += item?.advance_adjusted_amount
                  IpOrdersTotal += item?.is_advance_adjusted ? 0 : item?.service_with_gst_total_amt
                  IpOrdersTotal_without_roundoff += item?.is_advance_adjusted ? 0 : item?.service_with_gst_total_amt
                } else if (item?.billing_display === 'Assorted Service Head') {
                  item?.package_line?.forEach(pack => {
                    totalAmt += pack?.total_amt
                    totalConcessionAmt += pack?.concession_amt
                    totalGstAmt += pack?.gst_amount
                    TotalAdvAdjusted += pack?.advance_adjusted_amount
                    IpOrdersTotal += pack?.is_advance_adjusted ? 0 : pack?.service_with_gst_total_amt
                    IpOrdersTotal_without_roundoff += pack?.is_advance_adjusted ? 0 : pack?.service_with_gst_total_amt
                  })
                } else if (item?.billing_display === 'Service Name' || item?.billing_display === 'Service Head') {
                  item?.package_line?.forEach(pack => {
                    pack?.service_data?.forEach(service => {
                      totalAmt += service?.total_amt
                      totalConcessionAmt += service?.concession_amt
                      totalGstAmt += service?.gst_amount
                      TotalAdvAdjusted += service?.advance_adjusted_amount
                      IpOrdersTotal += service?.is_advance_adjusted ? 0 : service?.service_with_gst_total_amt
                      IpOrdersTotal_without_roundoff += service?.is_advance_adjusted ? 0 : service?.service_with_gst_total_amt
                    })
                  })
                }
              } else {
                totalAmt += (item?.total_amt)
                totalConcessionAmt += item?.concession_amt
                totalGstAmt += item?.gst_amount
                TotalAdvAdjusted += item?.advance_adjusted_amount
                IpOrdersTotal += IsAdjusted ? 0 : item?.service_with_gst_total_amt
                IpOrdersTotal_without_roundoff += IsAdjusted ? 0 : item?.service_with_gst_total_amt
              }
            })

            // let IpOrdersTotal = Math.round(billList.reduce((sum, item) => sum + item?.service_with_gst_total_amt, 0))
            let OtherBillsNetTotal = Math.round((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let OtherBillsTotal = Math.round((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            // let IpOrdersTotal_without_roundoff = (billList.reduce((sum, item) => sum + item?.service_with_gst_total_amt, 0))
            let OtherBillsTotal_without_roundoff = ((billing?.include_pharmacy_bills ? response?.data?.pharmacy_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0) + (billing?.include_ot_bills ? response?.data?.ot_bills?.reduce((sum, item) => sum + item?.outstanding_amount, 0) : 0))
            let RoundOff = +(Math.round((((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) - (((IpOrdersTotal_without_roundoff) || 0) + ((OtherBillsTotal_without_roundoff) || 0))) || 0
            let FinalAmount = (Math.round(IpOrdersTotal) || 0) + ((OtherBillsTotal) || 0)


            setBillnumbers(bill_numbers);
            setDupBillList(JSON.stringify(billList));
            setBilling((prev) => ({
              ...prev,
              pharmacy_bills: (response?.data?.pharmacy_bills || []),
              ot_bills: (response?.data?.ot_bills || []),
              bill_id: (response?.data?.bill_id || null),
              round_off: +parseFloat(RoundOff.toFixed(2)),
              pharmacy_net_amount: (OtherBillsNetTotal || 0),
              ip_net_amount: (Math.round(IpOrdersTotal) || 0),
              total_advance_adjusted: (TotalAdvAdjusted || 0),
              final_amount: FinalAmount,
              // total_amount: billList.reduce((sum, item) => sum + (+item?.total_amt || 0), 0),
              total_amount: totalAmt + OtherBillsNetTotal,
              // total_concession_amount: billList.reduce((sum, item) => sum + (+item?.concession_amt || 0), 0),
              total_concession_amount: totalConcessionAmt,
              // total_gst_amount: billList.reduce((sum, item) => sum + (+item?.gst_amount || 0), 0),
              total_gst_amount: totalGstAmt,
              applyFinalConcession: FromReset ? false : prev?.applyFinalConcession,
              edit_orders: FromReset ? false : prev?.edit_orders,
              pending_orders: (response?.data?.pending_orders || []),
              advance_deducted: !historyData?.is_final_bill_generated ? '' : FinalAmount < +PatientData?.advance_amount ? FinalAmount : +PatientData?.advance_amount,
              pay_from_advance: !historyData?.is_final_bill_generated ? false : (FinalAmount && +PatientData?.advance_amount) ? true : false,
              selectedOverall: (response?.data?.discount_amount ? true : false),
              tempDisAmt: (+response?.data?.discount_amount || 0),
              tempDisPer: (+response?.data?.overall_concession_percentage || 0),
              fromFinalConcession: FromReset ? false : prev?.fromFinalConcession,
              overall_data: {
                ...billing?.overall_data, ...{
                  overall_discount_percent: (+response?.data?.overall_concession_percentage || ""),
                  overall_discount_percent_w_r: (+(+response?.data?.overall_concession_percentage || 0)?.toFixed(2) ? +(+response?.data?.overall_concession_percentage || 0)?.toFixed(2) : ""),
                  overall_discount_amt: (+(+response?.data?.discount_amount || 0)?.toFixed(2) ? +(+response?.data?.discount_amount || 0)?.toFixed(2) : ""),
                }
              }
            }))
            setBillingList(billList);
            billingCalculation(billList)
            discountZero(billList)
            LoaderFunction(false);
          }
        }).catch((error) => {
          LoaderFunction(false);
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message)
          } else {
            errorMessage(error.message)
          }
        })
    } catch (error) {
      LoaderFunction(false);
      errorMessage(error.message)
    }
  }

  const setPackageListData = (packageData, BillId = null) => {
    try {
      let newBillList = []
      let packageLine = packageData?.package_line
      let transformedPackageLine = [];
      if (packageLine?.length) {
        for (let i = 0; i < packageLine?.length; i++) {
          let pack = packageLine[i]
          let serviceLine = pack.service_data
          let transformedServiceData = [];
          if (serviceLine?.length) {
            for (let j = 0; j < serviceLine?.length; j++) {
              const element = serviceLine[j]
              const ratePetUnit = element?.service_rate_per_unit || element?.rate_per_unit || ((!isNaN(element.unit)) ? (element?.service_charge / element?.unit) : element?.service_charge) || 0
              const totalAmt = element.service_charge || element?.sub_total_amount || element?.total_amount
              const totalWithDiscount = element.service_charge || element?.total_amount
              const docAmt = element?.new_doctor_fee || element.doctor_share_amount
              const oldDocAmt = BillId ? element?.old_doctor_fee : (element?.new_doctor_fee || element.doctor_share_amount)
              const hosAmt = element?.new_hospital_fee || element.hospital_share_amount
              const oldHosAmt = BillId ? element?.old_hospital_fee : element?.new_hospital_fee || element.hospital_share_amount
              const docId = element?.bill_doctor_id || element.doctor_id
              const chargeId = element?.charge_id || element?.service_charge_id

              const disDocAmt = oldDocAmt - docAmt
              const disHosAmt = oldHosAmt - hosAmt
              const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
              const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

              let discountTotal = element?.discount_amount ? (+totalAmt) - (+element?.discount_amount) : totalAmt
              let incGst = CommonValidation.calculateTotalWithGST(discountTotal, (+element?.gst_percent || 0))
              let tltGstdiff = incGst - discountTotal
              let sgstCgst = +tltGstdiff / 2

              let conTlt = 0;
              if (element?.edit_discount) {
                if (element?.is_hospital) {
                  conTlt += hosAmt
                } else {
                  conTlt += ratePetUnit
                }
              }

              transformedServiceData?.push({
                rate_per_unit: ratePetUnit || 0,
                unit: element.unit || 1,
                unit_type: element.unit_type || 'Nos',
                total_amt: totalAmt || 0,
                doctor_amt: docAmt || '',
                doctor_percent: element.doctor_share_percent || '',
                old_doctor_amt: (BillId ? element?.old_doctor_fee : element?.new_doctor_fee) || element.doctor_share_amount || "",
                new_doctor_amt: (element?.new_doctor_fee) || element.doctor_share_amount || "",
                hospital_amt: hosAmt || '',
                hospital_percent: element.hospital_share_percent || '',
                old_hospital_amt: (BillId ? element?.old_hospital_fee : element?.new_hospital_fee) || element.hospital_share_amount || "",
                new_hospital_amt: element?.new_hospital_fee || element.hospital_share_amount || "",
                interval_time: element.interval_time || null,
                interval_amount: element.interval_amount || 0,
                service_name: element.service_name || '',
                service_head_name: element.service_head || element?.service_head_name || '',
                service_code: element.service_code || '',
                service_head_code: element.service_head_code || '',
                edit_unit: true,
                edit_amount: false,
                edit_discount: true,
                doctor_name: element?.bill_doctor_name || element.doctor_name || '',
                doctor_id: docId || null,
                start_time: element.start_time || null,
                end_time: element.end_time || null,
                gst_percent: element.gst_percent || 0,
                hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                service_details_id: element?.service_details_id || null,
                review_days: element?.review_days || '',
                review_count: element?.review_count || '',
                charge_id: chargeId || null,
                module_type: element?.module_type || '',
                doctor_percent_w_r: element?.doctor_share_percent?.toFixed(2),
                hospital_percent_w_r: element?.hospital_share_percent?.toFixed(2),
                start_date: new Date(),
                end_date: null,
                is_hospital: element?.is_hospital,
                old_time_taken: element?.service_old_unit_count || null,
                concession_amt: element?.discount_amount || 0,
                concession_percent: element?.discount_percentage || 0,
                concession_comments: element?.concession_comments || '',
                op_order_line_id: element?.op_order_line_id || null,
                bill_type: element?.bill_type || '',
                doc_discount_amt: disDocAmt || '',
                doc_discount_percent: disDocPer || '',
                doc_discount_percent_w_r: disDocPer || '',
                hos_discount_amt: disHosAmt || '',
                hos_discount_percent: disHosPer || '',
                hos_discount_percent_w_r: disHosPer || '',
                service_head_id: element?.service_head_id || null,
                op_order_line_id: element?.op_order_id || null,
                total_with_discount: discountTotal || null,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal || 0,
                sub_total_amount: element?.sub_total_amount || element.total_amount,
                old_time_taken: element?.service_old_unit_count || element?.service_unit,
                order_item_number: element?.order_item_number || "-",
                // ip_order_line_id: element?.ip_order_line_id || null,
                is_overall_concession: element?.is_overall_concession || false,
                ip_bill_line_id: element?.ip_bill_line_id || null,
                concession_applicable: +conTlt || 0,
                order_line_ids: element?.order_line_ids ?? [],
                package_detail_id: element?.package_detail_id ?? null,
                drug_config_id: element?.drug_config_id ?? null,
                drug_ms_id: element?.drug_ms_id ?? null,
                pharmacy_id: element?.pharmacy_id ?? null,
                sub_location_id: element?.sub_location_id ?? null,
                is_include_lab_rad: packageData?.is_include_lab_rad ?? false,
                is_sharable: element?.is_sharable ?? false,
                is_consultation: element?.is_consultation ?? false
              })
            }
          }
          transformedPackageLine?.push({
            ...pack,
            service_data: transformedServiceData?.length ? transformedServiceData : [],

            edit_discount: true,
            edit_amount: false,
            edit_unit: false,
            order_line_ids: [],
            rate_per_unit: pack?.package_head_amount,
            unit: 1,
            unit_type: 'Nos',
            concession_amt: 0,
            concession_percent: 0,
            concession_percent_w_r: 0,
            total_amt: +pack?.package_head_amount,
            total_with_discount: +pack?.package_head_amount,
            service_with_gst_total_amt: +pack?.package_head_amount,
            gst_amount: 0,
            sgst_amount: 0,
            cgst_amount: 0,
            igst_amount: +pack?.package_head_amount,
            taxable_amount: +pack?.package_head_amount,
            sub_total_amount: +pack?.package_head_amount,
            concession_applicable: +pack?.package_head_amount,
            service_name: pack?.package_head_type,
            service_head_name: pack?.package_service_head,
            service_code: pack?.package_code ?? '',
            service_head_code: pack?.package_code ?? '',
            package_type: pack?.package_type,
            billing_display: pack?.billing_display,
            is_sharable: pack?.is_sharable ?? false,
            is_consultation: pack?.is_consultation ?? false,
            bill_type: pack?.bill_type ?? '',
            is_overall_concession: pack?.is_overall_concession || false,
            order_line_ids: pack?.order_line_ids ?? [],
            drug_config_id: pack?.drug_config_id ?? null,
            drug_ms_id: pack?.drug_ms_id ?? null,
            pharmacy_id: pack?.pharmacy_id ?? null,
            sub_location_id: pack?.sub_location_id ?? null,
            module_type: pack?.module_type ?? '',
            is_include_lab_rad: packageData?.is_include_lab_rad ?? false
          })
        }
      }
      newBillList?.push({
        "package_name": packageData?.package_name,
        "package_code": packageData?.package_code,
        "module_type": packageData?.module_type,
        "package_id": packageData?.package_id,
        'billing_display': packageData?.billing_display,
        'package_type': packageData?.package_type,
        'package_amount': packageData?.package_amount,
        'package_line': transformedPackageLine?.length ? transformedPackageLine : [],
        edit_discount: true,
        edit_amount: false,
        edit_unit: false,
        order_line_ids: [],
        rate_per_unit: packageData?.package_amount,
        unit: 1,
        unit_type: 'Nos',
        concession_amt: 0,
        concession_percent: 0,
        concession_percent_w_r: 0,
        total_amt: +packageData?.package_amount,
        total_with_discount: +packageData?.package_amount,
        service_with_gst_total_amt: +packageData?.package_amount,
        gst_amount: 0,
        sgst_amount: 0,
        cgst_amount: 0,
        igst_amount: +packageData?.package_amount,
        taxable_amount: +packageData?.package_amount,
        sub_total_amount: +packageData?.package_amount,
        concession_applicable: +packageData?.package_amount,
        service_name: packageData?.package_name,
        service_head_name: packageData?.package_name,
        service_code: packageData?.package_code ?? '',
        service_head_code: packageData?.package_code ?? '',
        is_sharable: packageData?.is_sharable ?? false,
        is_consultation: packageData?.is_consultation ?? false,
        bill_type: packageData?.bill_type ?? '',
        is_overall_concession: packageData?.is_overall_concession || false,
        order_line_ids: packageData?.order_line_ids ?? [],
        drug_config_id: packageData?.drug_config_id ?? null,
        drug_ms_id: packageData?.drug_ms_id ?? null,
        pharmacy_id: packageData?.pharmacy_id ?? null,
        sub_location_id: packageData?.sub_location_id ?? null,
        module_type: packageData?.module_type ?? '',
        is_include_lab_rad: packageData?.is_include_lab_rad ?? false
      })
      return newBillList;
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const setBillingListData = (data = [], BillId = null) => {
    try {
      let newBillingList = [];
      for (let i = 0; i < data?.length; i++) {
        const element = data[i]
        let packageLine = element?.package_line
        let transformedPackageLine = [];
        if (data[i]?.package_type === 'Assorted' || data[i]?.package_type === 'Package') {
          for (let k = 0; k < packageLine?.length; k++) {
            const pack = packageLine[k]
            const serviceLine = pack.service_data
            let transformedServiceData = [];
            for (let j = 0; j < serviceLine?.length; j++) {
              const service = serviceLine[j]
              const ratePetUnit = service?.service_rate_per_unit || service?.rate_per_unit || service.service_charge || 0
              const totalAmt = service?.sub_total_amount || service?.total_amount || service.service_charge
              const totalWithDiscount = service.service_charge || service?.total_amount
              const docAmt = service?.new_doctor_fee || service.doctor_share_amount
              const oldDocAmt = BillId ? service?.old_doctor_fee : (service?.new_doctor_fee || service.doctor_share_amount)
              const hosAmt = service?.new_hospital_fee || service.hospital_share_amount
              const oldHosAmt = BillId ? service?.old_hospital_fee : service?.new_hospital_fee || service.hospital_share_amount
              const docId = service?.bill_doctor_id || service.doctor_id
              const chargeId = service?.charge_id || service?.service_charge_id

              const disDocAmt = oldDocAmt - docAmt
              const disHosAmt = oldHosAmt - hosAmt
              const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
              const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

              let discountTotal = service?.discount_amount ? (+totalAmt) - (+service?.discount_amount) : totalAmt
              let incGst = CommonValidation.calculateTotalWithGST(discountTotal, ((+discountTotal > +RoomChargeGST?.room_charge_gst_limit && service?.service_head_name === "Room Charges" && RoomChargeGST?.is_room_charge_gst_applicable) ? (+RoomChargeGST?.room_charge_gst_percent || 0) : 0))
              let tltGstdiff = incGst - discountTotal
              let sgstCgst = +tltGstdiff / 2

              let conTlt = 0;
              // if (service?.edit_discount) {
              if (service?.is_hospital) {
                conTlt += hosAmt
              } else {
                conTlt += ratePetUnit
              }
              // }
              transformedServiceData?.push({
                rate_per_unit: ratePetUnit || 0,
                unit: service.unit || 1,
                unit_type: service.unit_type || 'Nos',
                total_amt: totalAmt || 0,
                doctor_amt: docAmt || '',
                doctor_percent: service.doctor_share_percent || '',
                old_doctor_amt: (BillId ? service?.old_doctor_fee : service?.new_doctor_fee) || service.doctor_share_amount || "",
                new_doctor_amt: (service?.new_doctor_fee) || service.doctor_share_amount || "",
                hospital_amt: hosAmt || '',
                hospital_percent: service.hospital_share_percent || '',
                old_hospital_amt: (BillId ? service?.old_hospital_fee : service?.new_hospital_fee) || service.hospital_share_amount || "",
                new_hospital_amt: service?.new_hospital_fee || service.hospital_share_amount || "",
                interval_time: service.interval_time,
                interval_amount: service.interval_amount,
                service_name: service.service_name || '',
                service_head_name: service.service_head || service?.service_head_name || '',
                service_code: service.service_code || '',
                service_head_code: service.service_head_code || '',
                edit_unit: true,
                edit_amount: false,
                edit_discount: true,
                doctor_name: service?.bill_doctor_name || service.doctor_name || '',
                doctor_id: docId || null,
                start_time: service.start_time,
                end_time: service.end_time,
                gst_percent: (+discountTotal > +RoomChargeGST?.room_charge_gst_limit) ? (+RoomChargeGST?.room_charge_gst_percent || 0) : 0,
                hours: service.unit_type === 'Hrs' ? service.unit?.split(":")[0] : '',
                minutes: service.unit_type === 'Hrs' ? service.unit?.split(":")[1] : '',
                service_details_id: service?.service_details_id,
                review_days: service?.review_days || '',
                review_count: service?.review_count || '',
                charge_id: chargeId,
                module_type: service?.module_type || '',
                doctor_percent_w_r: service?.doctor_share_percent?.toFixed(2),
                hospital_percent_w_r: service?.hospital_share_percent?.toFixed(2),
                start_date: new Date(),
                end_date: null,
                is_hospital: service?.is_hospital,
                old_time_taken: service?.service_old_unit_count,
                concession_amt: service?.discount_amount || 0,
                concession_percent: service?.discount_percentage || 0,
                concession_percent_w_r: service?.discount_percentage || '',
                concession_comments: service?.concession_comments || '',
                op_order_line_id: service?.op_order_line_id,
                bill_type: service?.bill_type || '',
                doc_discount_amt: disDocAmt,
                doc_discount_percent: disDocPer,
                doc_discount_percent_w_r: disDocPer,
                hos_discount_amt: disHosAmt,
                hos_discount_percent: disHosPer,
                hos_discount_percent_w_r: disHosPer,
                service_head_id: service?.service_head_id,
                op_order_line_id: service?.op_order_id,
                total_with_discount: discountTotal,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal,
                sub_total_amount: service?.sub_total_amount || service.total_amount,
                old_time_taken: service?.service_old_unit_count || service?.service_unit,
                order_item_number: service?.order_item_number || "-",
                // ip_order_line_id: service?.ip_order_line_id || null,
                is_overall_concession: service?.is_overall_concession || false,
                ip_bill_line_id: service?.ip_bill_line_id || null,
                concession_applicable: +conTlt,
                order_line_ids: service?.order_line_ids ?? [],
                package_detail_id: service?.package_detail_id ?? null,
                drug_config_id: service?.drug_config_id ?? null,
                drug_ms_id: service?.drug_ms_id ?? null,
                pharmacy_id: service?.pharmacy_id ?? null,
                sub_location_id: service?.sub_location_id ?? null,
                id: service?.id ? service?.id : null,
                is_include_lab_rad: service?.is_include_lab_rad ?? false,
                is_sharable: service?.is_sharable ?? false,
                is_consultation: service?.is_consultation ?? false,
                is_created_order : service?.is_created_order ? true : false,
                advance_adjusted_amount : service?.advance_adjusted_amount || 0,
                is_advance_adjusted : service?.advance_adjusted_amount ? true : false,
                unique_code_sequence : service?.unique_code_sequence || null,
              })
            }
            transformedPackageLine?.push({
              ...pack,
              service_data: transformedServiceData,
              edit_discount: true,
              edit_amount: false,
              edit_unit: false,
              order_line_ids: pack?.service_data[0]?.order_line_ids ?? null,
              rate_per_unit: pack?.service_data[0]?.rate_per_unit ?? 0,
              unit: pack?.service_data[0]?.unit ?? 1,
              unit_type: pack?.service_data[0]?.unit_type ?? 'Nos',
              concession_amt: pack?.service_data[0]?.discount_amount ?? 0,
              concession_percent: pack?.service_data[0]?.discount_percentage ?? 0,
              concession_percent_w_r: pack?.service_data[0]?.discount_percentage ? +(+pack?.service_data[0]?.discount_percentage)?.toFixed(2) : '',
              total_amt: pack?.service_data[0]?.sub_total_amount ?? 0,
              total_with_discount: pack?.service_data[0]?.service_charge ?? 0,
              service_with_gst_total_amt: pack?.service_data[0]?.service_charge ?? 0,
              gst_amount: 0,
              sgst_amount: 0,
              cgst_amount: 0,
              igst_amount: pack?.service_data[0]?.igst_amount ?? 0,
              taxable_amount: pack?.service_data[0]?.taxable_amount ?? 0,
              sub_total_amount: pack?.service_data[0]?.sub_total_amount ?? 0,
              concession_applicable: pack?.service_data[0]?.rate_per_unit ?? 0,
              service_name: pack?.service_data[0]?.service_name ?? '',
              service_head_name: pack?.service_data[0]?.service_head ?? '',
              service_code: pack?.service_data[0]?.service_code ?? '',
              service_head_code: pack?.service_data[0]?.service_head_code ?? '',
              is_sharable: pack?.service_data[0]?.is_sharable ?? false,
              is_consultation: pack?.service_data[0]?.is_consultation ?? false,
              bill_type: pack?.service_data[0]?.bill_type ?? '',
              is_overall_concession: pack?.service_data[0]?.is_overall_concession || false,
              drug_config_id: pack?.service_data[0]?.drug_config_id || null,
              drug_ms_id: pack?.service_data[0]?.drug_ms_id || null,
              pharmacy_id: pack?.service_data[0]?.pharmacy_id || null,
              sub_location_id: pack?.service_data[0]?.sub_location_id || null,
              id: pack?.service_data[0]?.id ?? null,
              module_type: pack?.service_data[0]?.module_type ?? null,
              is_include_lab_rad: pack?.service_data[0]?.is_include_lab_rad ?? false,
              is_created_order : pack?.service_data[0]?.is_created_order ? true : false,
              advance_adjusted_amount : pack?.service_data[0]?.advance_adjusted_amount || 0,
              is_advance_adjusted : pack?.service_data[0]?.advance_adjusted_amount ? true : false,
              unique_code_sequence : pack?.service_data[0]?.unique_code_sequence || null,
            })
          }
          newBillingList?.push({
            "package_name": element?.package_name,
            "package_code": element?.package_code,
            "module_type": element?.module_type,
            "package_id": element?.package_id,
            'billing_display': element?.billing_display,
            'package_type': element?.package_type,
            'package_amount': element?.package_amount,
            'is_advance_adjusted': element?.is_advance_adjusted || false,
            'package_line': transformedPackageLine,
            edit_discount: true,
            edit_amount: false,
            edit_unit: false,
            order_line_ids: element?.package_line[0]?.service_data[0]?.order_line_ids ?? [],
            rate_per_unit: element?.package_line[0]?.service_data[0]?.rate_per_unit ?? 0,
            unit: element?.package_line[0]?.service_data[0]?.unit ?? 1,
            unit_type: element?.package_line[0]?.service_data[0]?.unit_type ?? 'Nos',
            concession_amt: element?.package_line[0]?.service_data[0]?.discount_amount ?? 0,
            concession_percent: element?.package_line[0]?.service_data[0]?.discount_percentage ?? 0,
            concession_percent_w_r: element?.package_line[0]?.service_data[0]?.discount_percentage ? +(+element?.package_line[0]?.service_data[0]?.discount_percentage)?.toFixed(2) : '',
            total_amt: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
            total_with_discount: element?.package_line[0]?.service_data[0]?.service_charge ?? 0,
            service_with_gst_total_amt: element?.package_line[0]?.service_data[0]?.service_charge ?? 0,
            gst_amount: 0,
            sgst_amount: 0,
            cgst_amount: 0,
            igst_amount: element?.package_line[0]?.service_data[0]?.igst_amount ?? 0,
            taxable_amount: element?.package_line[0]?.service_data[0]?.taxable_amount ?? 0,
            sub_total_amount: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
            concession_applicable: element?.package_line[0]?.service_data[0]?.rate_per_unit ?? 0,
            service_name: element?.package_line[0]?.service_data[0]?.service_name ?? '',
            service_head_name: element?.package_line[0]?.service_data[0]?.service_head ?? '',
            service_code: element?.package_line[0]?.service_data[0]?.service_code ?? '',
            service_head_code: element?.package_line[0]?.service_data[0]?.service_head_code ?? '',
            is_sharable: element?.package_line[0]?.service_data[0]?.is_sharable ?? false,
            is_consultation: element?.package_line[0]?.service_data[0]?.is_consultation ?? false,
            bill_type: element?.package_line[0]?.service_data[0]?.bill_type || '',
            is_overall_concession: element?.package_line[0]?.service_data[0]?.is_overall_concession || false,
            drug_config_id: element?.package_line[0]?.service_data[0]?.drug_config_id || null,
            drug_ms_id: element?.package_line[0]?.service_data[0]?.drug_ms_id || null,
            pharmacy_id: element?.package_line[0]?.service_data[0]?.pharmacy_id || null,
            sub_location_id: element?.package_line[0]?.service_data[0]?.sub_location_id || null,
            id: element?.package_line[0]?.service_data[0]?.id ?? null,
            module_type: element?.package_line[0]?.service_data[0]?.module_type ?? null,
            is_include_lab_rad: element?.package_line[0]?.service_data[0]?.is_include_lab_rad ?? false,
            is_created_order : element?.package_line[0]?.service_data[0]?.is_created_order ? true : false,
            advance_adjusted_amount : element?.advance_adjusted_amount || 0,
            is_advance_adjusted : element?.advance_adjusted_amount ? true : false,
            unique_code_sequence : element?.package_line[0]?.service_data[0]?.unique_code_sequence || null,
          })
        } else {
          const ratePetUnit = element?.service_rate_per_unit || element?.rate_per_unit || element?.service_charge || 0
          const totalAmt = element?.sub_total_amount || element?.total_amount || element.service_charge
          const totalWithDiscount = element.service_charge || element?.total_amount
          const docAmt = element?.new_doctor_fee || element.doctor_share_amount
          const oldDocAmt = BillId ? element?.old_doctor_fee : (element?.new_doctor_fee || element.doctor_share_amount)
          const hosAmt = element?.new_hospital_fee || element.hospital_share_amount
          const oldHosAmt = BillId ? element?.old_hospital_fee : element?.new_hospital_fee || element.hospital_share_amount
          const docId = element?.bill_doctor_id || element.doctor_id
          const chargeId = element?.charge_id || element?.service_charge_id

          const disDocAmt = oldDocAmt - docAmt
          const disHosAmt = oldHosAmt - hosAmt
          const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
          const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

          let discountTotal = element?.discount_amount ? (+totalAmt) - (+element?.discount_amount) : totalAmt
          let incGst = CommonValidation.calculateTotalWithGST((discountTotal), ((+discountTotal > +RoomChargeGST?.room_charge_gst_limit && element?.service_head_name === "Room Charges" && RoomChargeGST?.is_room_charge_gst_applicable) ? (+RoomChargeGST?.room_charge_gst_percent || 0) : 0))
          let tltGstdiff = incGst - discountTotal
          let sgstCgst = +tltGstdiff / 2 

          let conTlt = 0;
          if (element?.edit_discount) {
            if (element?.is_hospital) {
              conTlt += hosAmt
            } else {
              conTlt += ratePetUnit
            }
          }

          let ServiceObject = {
            rate_per_unit: ratePetUnit || 0,
            unit: element.unit || 1,
            unit_type: element.unit_type || 'Nos',
            total_amt: totalAmt || 0,
            doctor_amt: docAmt || '',
            doctor_percent: element.doctor_share_percent || '',
            old_doctor_amt: (BillId ? element?.old_doctor_fee : element?.new_doctor_fee) || element.doctor_share_amount || "",
            new_doctor_amt: (element?.new_doctor_fee) || element.doctor_share_amount || "",
            hospital_amt: hosAmt || '',
            hospital_percent: element.hospital_share_percent || '',
            old_hospital_amt: (BillId ? element?.old_hospital_fee : element?.new_hospital_fee) || element.hospital_share_amount || "",
            new_hospital_amt: element?.new_hospital_fee || element.hospital_share_amount || "",
            interval_time: element.interval_time,
            interval_amount: element.interval_amount,
            service_name: element.service_name || '',
            service_head_name: element.service_head || element?.service_head_name || '',
            service_code: element.service_code || '',
            service_head_code: element.service_head_code || '',
            edit_unit: element.edit_unit || false,
            edit_amount: element.edit_amount || false,
            edit_discount: element?.is_membership_discount_applied ? false : (element.edit_discount || false),
            doctor_name: element?.bill_doctor_name || element.doctor_name || '',
            doctor_id: docId || null,
            start_time: element.start_time,
            end_time: element.end_time,
            gst_percent: (+discountTotal > +RoomChargeGST?.room_charge_gst_limit) ? (+RoomChargeGST?.room_charge_gst_percent || 0) : 0,
            hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
            minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
            service_details_id: element?.service_details_id,
            review_days: element?.review_days || '',
            review_count: element?.review_count || '',
            charge_id: chargeId,
            module_type: element?.module_type || '',
            doctor_percent_w_r: element?.doctor_share_percent?.toFixed(2),
            hospital_percent_w_r: element?.hospital_share_percent?.toFixed(2),
            start_date: new Date(),
            end_date: null,
            is_hospital: element?.is_hospital,
            old_time_taken: element?.service_old_unit_count,
            concession_amt: element?.discount_amount || 0,
            concession_percent: element?.discount_percentage || 0,
            concession_comments: element?.concession_comments || '',
            concession_percent_w_r: +element?.discount_percentage?.toFixed(2) || 0,
            op_order_line_id: element?.op_order_line_id,
            bill_type: element?.bill_type || '',
            doc_discount_amt: disDocAmt,
            doc_discount_percent: disDocPer,
            doc_discount_percent_w_r: (+disDocPer)?.toFixed(2),
            hos_discount_amt: disHosAmt,
            hos_discount_percent: disHosPer,
            hos_discount_percent_w_r: (+disHosPer)?.toFixed(2),
            service_head_id: element?.service_head_id,
            op_order_line_id: element?.op_order_id,
            is_advance_adjusted: element?.is_advance_adjusted || false,
            total_with_discount: discountTotal,
            service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
            gst_amount: +CommonValidation.formatAmount(tltGstdiff),
            sgst_amount: +CommonValidation.formatAmount(sgstCgst),
            cgst_amount: +CommonValidation.formatAmount(sgstCgst),
            igst_amount: +CommonValidation.formatAmount(tltGstdiff),
            taxable_amount: discountTotal,
            sub_total_amount: element?.sub_total_amount || element.total_amount,
            old_time_taken: element?.service_old_unit_count || element?.service_unit,
            order_item_number: element?.order_item_number || "-",
            // ip_order_line_id: element?.ip_order_line_id || null,
            is_overall_concession: element?.is_overall_concession || false,
            ip_bill_line_id: element?.ip_bill_line_id || null,
            concession_applicable: +conTlt,
            order_line_ids: element?.order_line_ids ?? [],
            drug_config_id: element?.drug_config_id ?? null,
            drug_ms_id: element?.drug_ms_id ?? null,
            pharmacy_id: element?.pharmacy_id ?? null,
            sub_location_id: element?.sub_location_id ?? null,
            id: element?.id ?? null,
            is_include_lab_rad: element?.is_include_lab_rad ?? false,
            is_sharable: element?.is_sharable ?? false,
            is_consultation: element?.is_consultation ?? false,
            is_created_order: element?.is_created_order ? true : false,
            membership_discount_percentage: element?.is_membership_discount_applied ? (element?.discount_percentage || 0) : 0,
            advance_adjusted_amount : element?.advance_adjusted_amount || 0,
            is_advance_adjusted : element?.advance_adjusted_amount ? true : false,
            unique_code_sequence : element?.unique_code_sequence || null,
          }
          let MemberDiscount = element?.is_membership_discount_applied ? element?.discount_percentage : element?.membership_discount_percentage
          if (MemberDiscount) {
            ServiceObject.membership_discount_percentage = true
            if (element?.is_sharable) {
              const baseTotalAmt = totalAmt;
              const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(ServiceObject.doctor_percent, baseTotalAmt)
              const updatedOldHos = CommonValidation.getDiscountAmountWithRound(ServiceObject.hospital_percent, baseTotalAmt)
              const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
              const disHos = CommonValidation.getDiscountAmountWithRound(MemberDiscount, updatedOldHos)
              const conTlt = (+disDoc) + (+disHos)

              ServiceObject.total_amt = baseTotalAmt
              ServiceObject.old_doctor_amt = updatedOldDoc
              ServiceObject.old_hospital_amt = updatedOldHos
              ServiceObject.new_doctor_amt = updatedOldDoc - disDoc
              ServiceObject.new_hospital_amt = updatedOldHos - disHos
              ServiceObject.doctor_amt = updatedOldDoc - disDoc
              ServiceObject.hospital_amt = updatedOldHos - disHos
              ServiceObject.doc_discount_amt = disDoc
              ServiceObject.hos_discount_amt = disHos
              ServiceObject.hos_discount_percent = MemberDiscount
              ServiceObject.hos_discount_percent_w_r = MemberDiscount
              ServiceObject.concession_amt = CommonValidation.formatAmount(conTlt)
              ServiceObject.concession_percent = MemberDiscount
              ServiceObject.concession_percent_w_r = MemberDiscount
              ServiceObject.concession_comments = "Membership concession"
            } else {
              ServiceObject.concession_percent = MemberDiscount
              ServiceObject.concession_percent_w_r = MemberDiscount
              ServiceObject.total_with_discount = (totalAmt - CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt))
              ServiceObject.concession_amt = +CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt)
            }
          }
          newBillingList?.push(ServiceObject)
        }
      }
      return newBillingList;
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const postBillingData = (ForFinalBill = false) => {
    try {
      if (checkTransationMandatory() &&
        ((billing.card_amt !== "" && billing.card_no === "") ||
          (billing.upi_amt !== "" && billing.upi_no === "") ||
          (billing.cheque_amt !== "" && billing.cheque_no === "") ||
          (billing.bank_amt !== "" && billing.bank_no === ""))) {
        errorMessage('Please,Enter Reference Number')
      } else if ((billing.card_no !== "" && billing.card_no?.length < TXN_MSG_MAX_LEN) ||
        (billing.upi_no !== "" && billing.upi_no?.length < TXN_MSG_MAX_LEN) ||
        (billing.cheque_no !== "" && billing.cheque_no?.length < TXN_MSG_MAX_LEN) ||
        (billing.bank_no !== "" && billing.bank_no?.length < TXN_MSG_MAX_LEN)) {
        errorMessage(TXN_MSG_MAX)
      } else {
        LoaderFunction(true);
        let finalBillingListData = [];

        let SubTotal = 0
        let DiscountAmount = 0
        let appDiscountAmount = 0
        let TotalAmount = 0
        let TaxableAmount = 0
        let gstAmount = 0
        let cgstAmount = 0
        let sgstAmount = 0
        let igstAmount = 0
        let IPNetAmount = 0
        let PharmacyNetAmount = 0
        let PaidAmount = ((+billing?.cash_amt || 0) + (+billing?.card_amt || 0) + (+billing?.upi_amt || 0) + (+billing?.bank_amt || 0) + (+billing?.cheque_amt || 0) + (+billing?.advance_deducted || 0))

        for (let i = 0; i < billingList.length; i++) {
          const item = billingList[i];
          let object = {}
          if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
            switch (item?.billing_display) {
              case 'Package Name':
              case 'Assorted Package Name':
                let FinalObject = {
                  line_item_type: item?.package_type === 'Package' ? 'Package' : 'Assorted',
                  billing_display: item?.billing_display,
                  package_id: item?.package_type === 'Package' ? item?.package_id : null,
                  package_detail_id: item?.package_type === 'Assorted' ? null : item?.package_detail_id,
                  assorted_package_id: item?.package_type === 'Assorted' ? item?.package_id : null,
                  service_head_name: item?.billing_display === 'Package Name' ? 'Package' : 'Assorted Package',
                  service_head_code: '',
                  service_name: item?.package_name,
                  service_code: item?.package_code,
                  package_name: item?.package_type === 'Assorted' ? '' : item.package_name,
                  assorted_package_name: item?.package_type === 'Assorted' ? item.package_name : '',
                  is_sharable: item?.is_sharable ?? false,
                  is_consultation: item?.is_consultation ?? false,
                  order_line_ids: item?.order_line_ids ?? [],

                  bill_doctor_id: (item?.doctor_id) || null,
                  // ip_order_line_id: item?.ip_order_line_id || null,
                  order_line_ids: item?.order_line_ids ?? [],
                  service_head_id: item?.service_head_id || null,
                  service_details_id: item?.service_details_id || null,
                  service_charge_id: item?.charge_id || null,
                  gst_percent: +item?.gst_percent || 0,
                  unit: item?.unit || "",
                  unit_type: item?.unit_type || "",
                  interval_time: item?.interval_time || null,
                  interval_amount: +item?.interval_amount || 0,
                  doctor_share_percent: +item?.doctor_percent || 0,
                  hospital_share_percent: +item?.hospital_percent || 0,
                  old_doctor_fee: +item?.old_doctor_amt || 0,
                  old_hospital_fee: +item?.old_hospital_amt || 0,
                  new_doctor_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.old_doctor_amt || 0) : (+item?.new_doctor_amt || 0),
                  new_hospital_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.old_hospital_amt || 0) : (+item?.new_hospital_amt || 0),
                  rate_per_unit: +item?.rate_per_unit || 0,
                  start_time: item?.start_time || null,
                  end_time: item?.end_time || null,
                  total_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.total_amt || 0) : +item?.total_with_discount || 0,
                  sub_total_amount: +item?.total_amt || 0,
                  discount_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +item?.concession_amt || 0,
                  discount_percentage: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +item?.concession_percent || 0,
                  taxable_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.total_amt || 0) : +item?.total_with_discount || 0,
                  gst_amount: +item?.gst_amount || 0,
                  cgst_amount: +item?.cgst_amount || 0,
                  sgst_amount: +item?.sgst_amount || 0,
                  igst_amount: +item?.gst_amount || 0,
                  net_amount: +item?.service_with_gst_total_amt || 0,
                  is_overall_concession: item?.is_overall_concession || false,
                  // id: billing?.bill_id ? (item?.ip_bill_line_id || null) : null,
                  id: item?.package_line[0]?.service_data[0]?.ip_bill_line_id ?? null,
                  create_order: (item?.package_type === 'Assorted' || item?.package_type === 'Package') ? item?.is_include_lab_rad : (item?.order_line_ids ? false : (item?.module_type === "LAB" || item?.module_type === "RADIOLOGY")),
                  is_sharable: item?.is_sharable,
                  is_consultation: item?.is_consultation ?? false,
                  order_line_ids: item?.order_line_ids ?? [],
                  drug_config_id: item?.drug_config_id ?? null,
                  module_type: item?.module_type ?? '',
                  drug_ms_id: item?.drug_ms_id ?? null,
                  pharmacy_id: item?.pharmacy_id ?? null,
                  sub_location_id: item?.sub_location_id ?? null,
                  unique_code_sequence: item?.unique_code_sequence ?? null,
                  // is_include_lab_rad: item?.is_include_lab_rad ?? false,
                }
                if (ForFinalBill) {

                  let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
                  let card_amount_split = billing?.card_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
                  let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
                  let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
                  let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
                  let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0

                  let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split
                  FinalObject['is_advance_adjusted'] = item?.is_advance_adjusted ? true : false
                  FinalObject['cash_amount'] = item?.is_advance_adjusted ? 0 : cash_amount_split
                  FinalObject['card_amount'] = item?.is_advance_adjusted ? 0 : card_amount_split
                  FinalObject['upi_amount'] = item?.is_advance_adjusted ? 0 : upi_amount_split
                  FinalObject['bank_amount'] = item?.is_advance_adjusted ? 0 : bank_amount_split
                  FinalObject['cheque_amount'] = item?.is_advance_adjusted ? 0 : cheque_amount_split
                  FinalObject['advance_adjusted'] = item?.is_advance_adjusted ? true : (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
                  FinalObject['advance_deducted_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : advance_amount_split
                  FinalObject['received_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : servicePayment
                  FinalObject['payment_status'] = item?.is_advance_adjusted ? "paid" : servicePayment === 0 ? 'not paid' : servicePayment === +item?.service_with_gst_total_amt ? 'paid' : "partial"
                } else {
                  FinalObject['is_advance_adjusted'] = item?.is_advance_adjusted ? true : false
                  FinalObject['advance_adjusted'] = item?.is_advance_adjusted ? true : false
                  FinalObject['advance_deducted_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : 0
                  FinalObject['received_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : 0
                  FinalObject['payment_status'] = item?.is_advance_adjusted ? 'paid' : 'not paid'
                }
                finalBillingListData?.push(FinalObject)
                const val = (v) => (item?.is_include_lab_rad ? 0 : v || 0);
                SubTotal += val(+item?.sub_total_amount)
                if (item?.is_overall_concession) {
                  DiscountAmount += (+item?.concession_amt || 0)
                }
                TotalAmount += val(+item?.total_with_discount)
                TaxableAmount += val(+item?.taxable_amount)
                gstAmount += val(+item?.gst_amount)
                cgstAmount += val(+item?.cgst_amount)
                sgstAmount += val(+item?.sgst_amount)
                igstAmount += val(+item?.igst_amount)
                IPNetAmount += val(+item?.service_with_gst_total_amt)
                break;
              case 'Assorted Service Head':
                if (item?.package_line?.length) {
                  for (let j = 0; j < item?.package_line?.length; j++) {
                    let pack = item?.package_line[j]

                    let FinalObject = {
                      line_item_type: item?.package_type === 'Package' ? 'Package' : 'Assorted',
                      billing_display: item?.billing_display,
                      package_id: item?.package_type === 'Package' ? item?.package_id : null,
                      package_detail_id: item?.package_type === 'Assorted' ? null : item?.package_detail_id,
                      assorted_package_id: item?.package_type === 'Assorted' ? item?.package_id : null,
                      service_head_name: item?.package_name,
                      service_head_code: item?.package_code,
                      service_name: pack?.package_service_head,
                      service_code: pack?.package_service_code || '',
                      package_name: item?.package_type === 'Assorted' ? '' : item.package_name,
                      assorted_package_name: item?.package_type === 'Assorted' ? item.package_name : '',
                      assorted_package_head_id: pack?.package_head_id,

                      bill_doctor_id: (pack?.doctor_id) || null,
                      // ip_order_line_id: pack?.ip_order_line_id || null,
                      order_line_ids: pack?.order_line_ids ?? [],
                      service_head_id: pack?.service_head_id || null,
                      service_details_id: pack?.service_details_id || null,
                      service_charge_id: pack?.charge_id || null,
                      gst_percent: +pack?.gst_percent || 0,
                      unit: pack?.unit || "",
                      unit_type: pack?.unit_type || "",
                      interval_time: pack?.interval_time || null,
                      interval_amount: +pack?.interval_amount || 0,
                      doctor_share_percent: +pack?.doctor_percent || 0,
                      hospital_share_percent: +pack?.hospital_percent || 0,
                      old_doctor_fee: +pack?.old_doctor_amt || 0,
                      old_hospital_fee: +pack?.old_hospital_amt || 0,
                      new_doctor_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+pack?.old_doctor_amt || 0) : (+pack?.new_doctor_amt || 0),
                      new_hospital_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+pack?.old_hospital_amt || 0) : (+pack?.new_hospital_amt || 0),
                      rate_per_unit: +pack?.rate_per_unit || 0,
                      start_time: pack?.start_time || null,
                      end_time: pack?.end_time || null,
                      total_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+pack?.total_amt || 0) : +pack?.total_with_discount || 0,
                      sub_total_amount: +pack?.total_amt || 0,
                      discount_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (0) : +pack?.concession_amt || 0,
                      discount_percentage: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (0) : +pack?.concession_percent || 0,
                      taxable_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+pack?.total_amt || 0) : +pack?.total_with_discount || 0,
                      gst_amount: +pack?.gst_amount || 0,
                      cgst_amount: +pack?.cgst_amount || 0,
                      sgst_amount: +pack?.sgst_amount || 0,
                      igst_amount: +pack?.gst_amount || 0,
                      net_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+pack?.total_amt || 0) : +pack?.service_with_gst_total_amt || 0,
                      is_overall_concession: pack?.is_overall_concession || false,
                      // id: billing?.bill_id ? (pack?.ip_bill_line_id || null) : null,
                      id: pack?.service_data[0]?.ip_bill_line_id ?? null,
                      create_order: (item?.package_type === 'Assorted' || item?.package_type === 'Package') ? item?.is_include_lab_rad : (pack?.order_line_ids ? false : (pack?.module_type === "LAB" || pack?.module_type === "RADIOLOGY")),
                      is_sharable: pack?.is_sharable,
                      is_consultation: pack?.is_consultation ?? false,
                      order_line_ids: pack?.order_line_ids ?? [],
                      drug_config_id: pack?.drug_config_id ?? null,
                      module_type: pack?.module_type ?? '',
                      drug_ms_id: pack?.drug_ms_id ?? null,
                      pharmacy_id: pack?.pharmacy_id ?? null,
                      sub_location_id: pack?.sub_location_id ?? null,
                      unique_code_sequence: pack?.unique_code_sequence ?? null,
                      // is_include_lab_rad: item?.is_include_lab_rad ?? false,
                    }
                    if (ForFinalBill) {

                      let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
                      let card_amount_split = billing?.card_amt ? (+parseFloat(((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
                      let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
                      let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
                      let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
                      let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+pack?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0

                      let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split
                      
                      FinalObject['is_advance_adjusted'] = pack?.is_advance_adjusted ? true : false
                      FinalObject['cash_amount'] = pack?.is_advance_adjusted ? 0 : cash_amount_split
                      FinalObject['card_amount'] = pack?.is_advance_adjusted ? 0 : card_amount_split
                      FinalObject['upi_amount'] = pack?.is_advance_adjusted ? 0 : upi_amount_split
                      FinalObject['bank_amount'] = pack?.is_advance_adjusted ? 0 : bank_amount_split
                      FinalObject['cheque_amount'] = pack?.is_advance_adjusted ? 0 : cheque_amount_split
                      FinalObject['advance_adjusted'] = pack?.is_advance_adjusted ? true : (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
                      FinalObject['advance_deducted_amount'] = pack?.is_advance_adjusted ? pack?.advance_adjusted_amount : advance_amount_split
                      FinalObject['received_amount'] = pack?.is_advance_adjusted ? pack?.advance_adjusted_amount : servicePayment
                      FinalObject['payment_status'] = pack?.is_advance_adjusted ? "paid" : servicePayment === 0 ? 'not paid' : servicePayment === +item?.service_with_gst_total_amt ? 'paid' : "partial"
                    } else {
                      FinalObject['is_advance_adjusted'] = pack?.is_advance_adjusted ? true : false
                      FinalObject['advance_adjusted'] = pack?.is_advance_adjusted ? true : false
                      FinalObject['advance_deducted_amount'] = pack?.is_advance_adjusted ? pack?.advance_adjusted_amount : 0
                      FinalObject['received_amount'] = pack?.is_advance_adjusted ? pack?.advance_adjusted_amount : 0
                      FinalObject['payment_status'] = pack?.is_advance_adjusted ? 'paid' : 'not paid'
                    }
                    finalBillingListData?.push(FinalObject)
                    const val = (v) => (item?.is_include_lab_rad ? 0 : v || 0);
                    SubTotal += val(+pack?.sub_total_amount)
                    if (pack?.is_overall_concession) {
                      DiscountAmount += (+pack?.concession_amt || 0)
                    }
                    TotalAmount += val(+pack?.total_with_discount)
                    TaxableAmount += val(+pack?.taxable_amount)
                    gstAmount += val(+pack?.gst_amount)
                    cgstAmount += val(+pack?.cgst_amount)
                    sgstAmount += val(+pack?.sgst_amount)
                    igstAmount += val(+pack?.igst_amount)
                    IPNetAmount += val(+pack?.service_with_gst_total_amt)
                  }
                }
                break;
              case 'Service Head':
                if (item?.package_line?.length) {
                  for (let j = 0; j < item?.package_line?.length; j++) {
                    let pack = item?.package_line[j]
                    for (let k = 0; k < pack?.service_data?.length; k++) {
                      let ser = pack?.service_data[k]

                      let FinalObject = {
                        line_item_type: item?.package_type === 'Package' ? 'Package' : 'Assorted',
                        billing_display: item?.billing_display,
                        package_id: item?.package_type === 'Package' ? item?.package_id : null,
                        assorted_package_id: item?.package_type === 'Assorted' ? item?.package_id : null,
                        service_head_name: item?.package_type === 'Package' ? item?.package_name : pack?.package_service_head,
                        service_head_code: item?.package_type === 'Package' ? item?.package_code : '',
                        service_name: ser?.service_name,
                        service_code: ser?.service_head_code,
                        package_name: item?.package_type === 'Assorted' ? '' : item.package_name,
                        assorted_package_name: item?.package_type === 'Assorted' ? item.package_name : '',
                        assorted_package_head_id: pack?.package_head_id,
                        package_detail_id: item?.package_type === 'Assorted' ? null : ser?.package_detail_id,
                        id: ser?.ip_bill_line_id ?? null,

                        bill_doctor_id: (ser?.doctor_id) || null,
                        // ip_order_line_id: ser?.ip_order_line_id || null,
                        order_line_ids: ser?.order_line_ids ?? [],
                        service_head_id: ser?.service_head_id || null,
                        service_details_id: ser?.service_details_id || null,
                        service_charge_id: ser?.charge_id || null,
                        gst_percent: +ser?.gst_percent || 0,
                        unit: ser?.unit || "",
                        unit_type: ser?.unit_type || "",
                        interval_time: ser?.interval_time || null,
                        interval_amount: +ser?.interval_amount || 0,
                        doctor_share_percent: +ser?.doctor_percent || 0,
                        hospital_share_percent: +ser?.hospital_percent || 0,
                        old_doctor_fee: +ser?.old_doctor_amt || 0,
                        old_hospital_fee: +ser?.old_hospital_amt || 0,
                        new_doctor_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.old_doctor_amt || 0) : (+ser?.new_doctor_amt || 0),
                        new_hospital_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.old_hospital_amt || 0) : (+ser?.new_hospital_amt || 0),
                        rate_per_unit: +ser?.rate_per_unit || 0,
                        start_time: ser?.start_time || null,
                        end_time: ser?.end_time || null,
                        total_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt || 0) : +ser?.total_with_discount || 0,
                        sub_total_amount: +ser?.total_amt || 0,
                        discount_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +ser?.concession_amt || 0,
                        discount_percentage: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +ser?.concession_percent || 0,
                        gst_amount: +ser?.gst_amount || 0,
                        cgst_amount: +ser?.cgst_amount || 0,
                        sgst_amount: +ser?.sgst_amount || 0,
                        igst_amount: +ser?.gst_amount || 0,
                        net_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt || 0) : +ser?.service_with_gst_total_amt || 0,
                        is_overall_concession: ser?.is_overall_concession || false,
                        // id: billing?.bill_id ? (ser?.ip_bill_line_id || null) : null,
                        create_order: (item?.package_type === 'Assorted' || item?.package_type === 'Package') ? item?.is_include_lab_rad : (ser?.order_line_ids ? false : (ser?.module_type === "LAB" || ser?.module_type === "RADIOLOGY")),
                        is_sharable: ser?.is_sharable,
                        is_consultation: ser?.is_consultation ?? false,
                        order_line_ids: ser?.order_line_ids ?? [],
                        drug_config_id: ser?.drug_config_id ?? null,
                        module_type: ser?.module_type ?? '',
                        drug_ms_id: ser?.drug_ms_id ?? null,
                        pharmacy_id: ser?.pharmacy_id ?? null,
                        sub_location_id: ser?.sub_location_id ?? null,
                        unique_code_sequence: ser?.unique_code_sequence ?? null,
                        // is_include_lab_rad: item?.is_include_lab_rad ?? false,
                      }
                      if (ForFinalBill) {

                        let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
                        let card_amount_split = billing?.card_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
                        let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
                        let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
                        let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
                        let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0

                        let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split

                        FinalObject['is_advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['cash_amount'] = ser?.is_advance_adjusted ? 0 : cash_amount_split
                        FinalObject['card_amount'] = ser?.is_advance_adjusted ? 0 : card_amount_split
                        FinalObject['upi_amount'] = ser?.is_advance_adjusted ? 0 : upi_amount_split
                        FinalObject['bank_amount'] = ser?.is_advance_adjusted ? 0 : bank_amount_split
                        FinalObject['cheque_amount'] = ser?.is_advance_adjusted ? 0 : cheque_amount_split
                        FinalObject['advance_adjusted'] = ser?.is_advance_adjusted ? true : (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
                        FinalObject['advance_deducted_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : advance_amount_split
                        FinalObject['received_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : servicePayment
                        FinalObject['payment_status'] = ser?.is_advance_adjusted ? "paid" : servicePayment === 0 ? 'not paid' : servicePayment === +item?.service_with_gst_total_amt ? 'paid' : "partial"
                      } else {
                        FinalObject['is_advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['advance_deducted_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : 0
                        FinalObject['received_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : 0
                        FinalObject['payment_status'] = ser?.is_advance_adjusted ? 'paid' : 'not paid'
                      }
                      finalBillingListData?.push(FinalObject)
                      const val = (v) => (item?.is_include_lab_rad ? 0 : v || 0);
                      SubTotal += val(+ser?.sub_total_amount)
                      if (ser?.is_overall_concession) {
                        DiscountAmount += (+ser?.concession_amt || 0)
                      }
                      TotalAmount += val(+ser?.total_with_discount)
                      TaxableAmount += val(+ser?.taxable_amount)
                      gstAmount += val(+ser?.gst_amount)
                      cgstAmount += val(+ser?.cgst_amount)
                      sgstAmount += val(+ser?.sgst_amount)
                      igstAmount += val(+ser?.igst_amount)
                      IPNetAmount += val(+ser?.service_with_gst_total_amt)
                    }
                  }
                }
                break;
              case 'Service Name':
                if (item?.package_line?.length) {
                  for (let j = 0; j < item?.package_line?.length; j++) {
                    let pack = item?.package_line[j]
                    for (let k = 0; k < pack?.service_data?.length; k++) {
                      let ser = pack?.service_data[k]
                      let FinalObject = {
                        line_item_type: item?.package_type === 'Package' ? 'Package' : 'Assorted',
                        billing_display: item?.billing_display,
                        package_id: item?.package_type === 'Package' ? item?.package_id : null,
                        assorted_package_id: item?.package_type === 'Assorted' ? item?.package_id : null,
                        package_name: item?.package_type === 'Assorted' ? '' : item.package_name,
                        assorted_package_name: item?.package_type === 'Assorted' ? item.package_name : '',
                        assorted_package_head_id: pack?.package_head_id,
                        assorted_package_items_id: item?.package_type === 'Assorted' ? ser?.package_detail_id : null,
                        package_detail_id: item?.package_type === 'Assorted' ? null : ser?.package_detail_id,
                        id: ser?.ip_bill_line_id ?? null,
                        is_sharable: ser?.is_sharable ?? false,
                        is_consultation: ser?.is_consultation ?? false,
                        service_name: ser?.service_name ?? '',
                        service_head_name: ser?.service_head_name ?? '',
                        service_code: ser?.service_code ?? '',
                        service_head_code: ser?.service_head_code ?? '',

                        bill_doctor_id: (ser?.doctor_id) || null,
                        // ip_order_line_id: ser?.ip_order_line_id || null,
                        order_line_ids: ser?.order_line_ids ?? [],
                        service_head_id: ser?.service_head_id || null,
                        service_details_id: ser?.service_details_id || null,
                        service_charge_id: ser?.charge_id || null,
                        gst_percent: +ser?.gst_percent || 0,
                        unit: ser?.unit || "",
                        unit_type: ser?.unit_type || "",
                        interval_time: ser?.interval_time || null,
                        interval_amount: +ser?.interval_amount || 0,
                        doctor_share_percent: +ser?.doctor_percent || 0,
                        hospital_share_percent: +ser?.hospital_percent || 0,
                        old_doctor_fee: +ser?.old_doctor_amt || 0,
                        old_hospital_fee: +ser?.old_hospital_amt || 0,
                        new_doctor_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.old_doctor_amt || 0) : (+ser?.new_doctor_amt || 0),
                        new_hospital_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.old_hospital_amt || 0) : (+ser?.new_hospital_amt || 0),
                        rate_per_unit: +ser?.rate_per_unit || 0,
                        start_time: ser?.start_time || null,
                        end_time: ser?.end_time || null,
                        total_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt || 0) : +ser?.total_with_discount || 0,
                        sub_total_amount: +ser?.total_amt || 0,
                        discount_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +ser?.concession_amt || 0,
                        discount_percentage: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +ser?.concession_percent || 0,
                        gst_amount: +ser?.gst_amount || 0,
                        cgst_amount: +ser?.cgst_amount || 0,
                        sgst_amount: +ser?.sgst_amount || 0,
                        igst_amount: +ser?.gst_amount || 0,
                        net_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt || 0) : +ser?.service_with_gst_total_amt || 0,
                        is_overall_concession: ser?.is_overall_concession || false,
                        // id: billing?.bill_id ? (ser?.ip_bill_line_id || null) : null,

                        create_order: (item?.package_type === 'Assorted' || item?.package_type === 'Package') ? item?.is_include_lab_rad : (ser?.order_line_ids ? false : (ser?.module_type === "LAB" || ser?.module_type === "RADIOLOGY")),
                        is_sharable: ser?.is_sharable,
                        is_consultation: ser?.is_consultation ?? false,
                        order_line_ids: ser?.order_line_ids ?? [],
                        drug_config_id: ser?.drug_config_id ?? null,
                        module_type: ser?.module_type ?? '',
                        drug_ms_id: ser?.drug_ms_id ?? null,
                        pharmacy_id: ser?.pharmacy_id ?? null,
                        sub_location_id: ser?.sub_location_id ?? null,
                        unique_code_sequence: ser?.unique_code_sequence ?? null,
                        // is_include_lab_rad: item?.is_include_lab_rad ?? false,
                      }
                      if (ForFinalBill) {

                        let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
                        let card_amount_split = billing?.card_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
                        let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
                        let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
                        let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
                        let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+ser?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0

                        let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split

                        FinalObject['is_advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['cash_amount'] = ser?.is_advance_adjusted ? 0 : cash_amount_split
                        FinalObject['card_amount'] = ser?.is_advance_adjusted ? 0 : card_amount_split
                        FinalObject['upi_amount'] = ser?.is_advance_adjusted ? 0 : upi_amount_split
                        FinalObject['bank_amount'] = ser?.is_advance_adjusted ? 0 : bank_amount_split
                        FinalObject['cheque_amount'] = ser?.is_advance_adjusted ? 0 : cheque_amount_split
                        FinalObject['advance_adjusted'] = ser?.is_advance_adjusted ? true : (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
                        FinalObject['advance_deducted_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : advance_amount_split
                        FinalObject['received_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : servicePayment
                        FinalObject['payment_status'] = ser?.is_advance_adjusted ? 'paid' : servicePayment === 0 ? 'not paid' : servicePayment === +item?.service_with_gst_total_amt ? 'paid' : "partial"
                      } else {
                        FinalObject['is_advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['advance_adjusted'] = ser?.is_advance_adjusted ? true : false
                        FinalObject['advance_deducted_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : 0
                        FinalObject['received_amount'] = ser?.is_advance_adjusted ? ser?.advance_adjusted_amount : 0
                        FinalObject['payment_status'] = ser?.is_advance_adjusted ? 'paid' : 'not paid'
                      }
                      finalBillingListData?.push(FinalObject)
                      const val = (v) => (item?.is_include_lab_rad ? 0 : v || 0);
                      SubTotal += val(+ser?.sub_total_amount)
                      if (ser?.is_overall_concession) {
                        DiscountAmount += (+ser?.concession_amt || 0)
                      }
                      TotalAmount += val(requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt) : (+ser?.total_with_discount)
                      TaxableAmount += val(+ser?.taxable_amount)
                      gstAmount += val(+ser?.gst_amount)
                      cgstAmount += val(+ser?.cgst_amount)
                      sgstAmount += val(+ser?.sgst_amount)
                      igstAmount += val(+ser?.igst_amount)
                      IPNetAmount += val(requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+ser?.total_amt) : (+ser?.service_with_gst_total_amt)
                    }
                  }
                }
                break;
            }
          } else {
            object = {
              bill_doctor_id: (item?.doctor_id) || null,
              // ip_order_line_id: item?.ip_order_line_id || null,
              order_line_ids: item?.order_line_ids ?? [],
              service_head_id: item?.service_head_id || null,
              service_details_id: item?.service_details_id || null,
              service_charge_id: item?.charge_id || null,
              gst_percent: +item?.gst_percent || 0,
              unit: item?.unit || "",
              unit_type: item?.unit_type || "",
              interval_time: item?.interval_time || null,
              interval_amount: +item?.interval_amount || 0,
              doctor_share_percent: +item?.doctor_percent || 0,
              hospital_share_percent: +item?.hospital_percent || 0,
              old_doctor_fee: +item?.old_doctor_amt || 0,
              old_hospital_fee: +item?.old_hospital_amt || 0,
              new_doctor_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.old_doctor_amt || 0) : (+item?.new_doctor_amt || 0),
              new_hospital_fee: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.old_hospital_amt || 0) : (+item?.new_hospital_amt || 0),
              rate_per_unit: +item?.rate_per_unit || 0,
              start_time: item?.start_time || null,
              end_time: item?.end_time || null,
              total_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.total_amt || 0) : +item?.total_with_discount || 0,
              sub_total_amount: +item?.total_amt || 0,
              discount_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +item?.concession_amt || 0,
              discount_percentage: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : +item?.concession_percent || 0,
              taxable_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.total_amt || 0) : +item?.total_with_discount || 0,
              gst_amount: +item?.gst_amount || 0,
              cgst_amount: +item?.cgst_amount || 0,
              sgst_amount: +item?.sgst_amount || 0,
              igst_amount: +item?.gst_amount || 0,
              net_amount: (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? (+item?.total_amt || 0) : +item?.service_with_gst_total_amt || 0,
              service_code: item?.service_code || null,
              service_head_code: item?.service_head_code || null,
              service_head_name: item?.service_head_name || null,
              service_name: item?.service_name || null,
              is_overall_concession: item?.is_overall_concession || false,
              // id: billing?.bill_id ? (item?.ip_bill_line_id || null) : null
              id: item?.ip_bill_line_id ?? null,
              create_order: item?.order_line_ids ? false : (item?.module_type === "LAB" || item?.module_type === "RADIOLOGY"),
              is_sharable: item?.is_sharable,
              is_consultation: item?.is_consultation ?? false,
              line_item_type: "Individual",
              order_line_ids: item?.order_line_ids ?? [],
              module_type: item?.module_type ?? '',
              unique_code_sequence: item?.unique_code_sequence ?? null,
              is_membership_discount_applied : item?.membership_discount_percentage ? true : false,
            }
            if (ForFinalBill) {

              let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
              let card_amount_split = billing?.card_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
              let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
              let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
              let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
              let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+item?.service_with_gst_total_amt / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0

              let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split

              object['is_advance_adjusted'] = item?.is_advance_adjusted ? true : false
              object['cash_amount'] = item?.is_advance_adjusted ? 0 : cash_amount_split
              object['card_amount'] = item?.is_advance_adjusted ? 0 : card_amount_split
              object['upi_amount'] = item?.is_advance_adjusted ? 0 : upi_amount_split
              object['bank_amount'] = item?.is_advance_adjusted ? 0 : bank_amount_split
              object['cheque_amount'] = item?.is_advance_adjusted ? 0 : cheque_amount_split
              object['advance_adjusted'] = item?.is_advance_adjusted ? true : (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
              object['advance_deducted_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : advance_amount_split
              object['received_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : servicePayment
              object['payment_status'] = item?.is_advance_adjusted ? 'paid' : servicePayment === 0 ? 'not paid' : servicePayment === +item?.service_with_gst_total_amt ? 'paid' : "partial"
            } else {
              object['is_advance_adjusted'] = item?.is_advance_adjusted ? true : false
              object['advance_adjusted'] = item?.is_advance_adjusted ? true : false
              object['advance_deducted_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : 0
              object['received_amount'] = item?.is_advance_adjusted ? item?.advance_adjusted_amount : 0
              object['payment_status'] = item?.is_advance_adjusted ? 'paid' : 'not paid'
            }
            finalBillingListData?.push(object)
            const val = (v) => ((!item?.order_line_ids ? 0 : v) || 0);
            SubTotal += val(+item?.sub_total_amount)
            if (item?.is_overall_concession) {
              DiscountAmount += (+item?.concession_amt || 0)
            }
            TotalAmount += val(+item?.total_with_discount)
            TaxableAmount += val(+item?.taxable_amount)
            gstAmount += val(+item?.gst_amount)
            cgstAmount += val(+item?.cgst_amount)
            sgstAmount += val(+item?.sgst_amount)
            igstAmount += val(+item?.igst_amount)
            IPNetAmount += val(+item?.service_with_gst_total_amt)
          }
        }
        let date = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
        let Aptime = DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_SIMPLE);
        const invoice_date = date ? `${DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""

        let PharmacyBills = []

        if (billing?.include_pharmacy_bills) {
          billing?.pharmacy_bills?.forEach((bills) => {

            let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
            let card_amount_split = billing?.card_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
            let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
            let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
            let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
            let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+bills?.net_amount / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0
            let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split

            PharmacyNetAmount += (+bills?.net_amount || 0)

            PharmacyBills.push({
              "pharmacy_id": (bills?.pharmacy_id || null),
              "bill_id": (bills?.id || null),
              "received_amount": servicePayment,
              "cash_amount": cash_amount_split,
              "card_amount": card_amount_split,
              "upi_amount": upi_amount_split,
              "bank_amount": bank_amount_split,
              "cheque_amount": cheque_amount_split,
              "advance_deducted_amount": advance_amount_split,
              "payment_status": servicePayment === 0 ? 'not paid' : servicePayment === bills?.net_amount ? 'paid' : "partial"
            })
          })
        }

        let OTBills = []
        let OtNetAmount = 0

        if (billing?.ot_bills) {
          billing?.ot_bills?.forEach((bills) => {

            let cash_amount_split = billing?.cash_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.cash_amt)) || 0) : 0
            let card_amount_split = billing?.card_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.card_amt)) || 0) : 0
            let upi_amount_split = billing?.upi_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.upi_amt)) || 0) : 0
            let bank_amount_split = billing?.bank_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.bank_amt)) || 0) : 0
            let cheque_amount_split = billing?.cheque_amt ? (+parseFloat(((+bills?.net_amount / +billing?.final_amount) * +billing?.cheque_amt)) || 0) : 0
            let advance_amount_split = (billing?.pay_from_advance && billing?.advance_deducted) ? (+parseFloat((+bills?.net_amount / +billing?.final_amount) * +billing?.advance_deducted) || 0) : 0
            let servicePayment = cash_amount_split + card_amount_split + upi_amount_split + bank_amount_split + cheque_amount_split + advance_amount_split

            OtNetAmount += (+bills?.net_amount || 0)

            OTBills.push({
              "ot_details_id": (bills?.ot_details_id || null),
              "bill_id": (bills?.id || null),
              "received_amount": servicePayment,
              "cash_amount": cash_amount_split,
              "card_amount": card_amount_split,
              "upi_amount": upi_amount_split,
              "bank_amount": bank_amount_split,
              "cheque_amount": cheque_amount_split,
              "advance_deducted_amount": advance_amount_split,
              "payment_status": servicePayment === 0 ? 'not paid' : servicePayment === bills?.net_amount ? 'paid' : "partial"
            })
          })
        }

        let data = {
          "ip_admission_id": PatientDetails?.ip_admission_id || null,
          'invoice_date': invoice_date,
          'bill_type': (requestState?.status === 'Requested') ? 'Request' : 'Credit',
          'billed_from': 'FO',
          "patient_id": PatientDetails?.patient_id || null,
          'doctor_id': PatientDetails?.doctor_id || null,
          'sub_total_amount': +SubTotal || 0,
          'discount_amount': (requestState.status === 'Rejected' || requestState.status === 'Cancelled') ? 0 : (+DiscountAmount || 0),
          'total_amount': +TotalAmount || 0,
          'taxable_amount': +TaxableAmount || 0,
          'gst_amount': +gstAmount || 0,
          'cgst_amount': +cgstAmount || 0,
          'sgst_amount': +sgstAmount || 0,
          'igst_amount': +igstAmount || 0,
          'round_off': billing?.round_off,
          'net_amount': +Math.round(IPNetAmount) || 0,
          'pharmacy_net_amount': +Math.round(PharmacyNetAmount) || 0,
          'ot_net_amount': +Math.round(OtNetAmount) || 0,
          'overall_concession_percentage': (+billing?.overall_data?.overall_discount_percent || 0),
          'bill_id': billing?.bill_id || null,
          'bill_item_details': finalBillingListData,
          'is_requested': requestState?.status ? true : false,
          'request_status': requestState?.fromCancel ? "Cancelled" : requestState?.status,
          'approver_id': requestState?.selectedApproverId ? requestState?.selectedApproverId : null,
          'pending_list_id': requestState?.pending_list_id ? requestState?.pending_list_id : null,
          'discount_remarks': requestState?.discount_remarks ? requestState?.discount_remarks : '',
          'rejected_remarks': requestState?.rejected_remarks ? requestState?.rejected_remarks : '',
          "credit_due_date": (localGetItem('set_due_date_for_credit_billing') === 'true'&& billing?.credit_due_date) ? DateTime.fromJSDate(new Date(billing?.credit_due_date)).toFormat('yyyy-MM-dd') : null,
          'invoice_number': billnumbers?.invoice_number || null,
          'temp_invoice_number': billnumbers?.temp_invoice_number || null,
        }
        if (ForFinalBill) {
          let payment = []
          if (billing?.isCash) {
            payment.push(1)
          }
          if (billing?.isCard) {
            payment.push(2)
          }
          if (billing?.isUPI) {
            payment.push(3)
          }
          if (billing?.isCheque) {
            payment.push(4)
          }
          if (billing?.isBank) {
            payment.push(5)
          }

          let IP_Received = Math.round(finalBillingListData?.filter((list)=>(!list?.is_advance_adjusted ))?.reduce((sum, item) => sum + item?.received_amount, 0) || 0)
          let Pharma_received = Math.round(PharmacyBills?.reduce((sum, item) => sum + item?.received_amount, 0) || 0)
          let Ot_received = Math.round(OTBills?.reduce((sum, item) => sum + item?.received_amount, 0) || 0)

          let IP_Advance = (billing?.pay_from_advance && billing?.advance_deducted) ? Math.round(finalBillingListData?.filter((list)=>(!list?.is_advance_adjusted ))?.reduce((sum, item) => sum + item?.advance_deducted_amount, 0) || 0) : 0
          let Pharma_Advance = (billing?.pay_from_advance && billing?.advance_deducted) ? Math.round(PharmacyBills?.reduce((sum, item) => sum + item?.advance_deducted_amount, 0) || 0) : 0
          let Ot_Advance = (billing?.pay_from_advance && billing?.advance_deducted) ? Math.round(OTBills?.reduce((sum, item) => sum + item?.advance_deducted_amount, 0) || 0) : 0

          data['payment_status'] = PaidAmount === billing?.final_amount ? "paid" : PaidAmount === 0 ? "not paid" : "partial"
          data['payment_mode'] = payment
          data['receipt_for'] = "Bill"
          data['credit_type'] = (billing?.credit_type === "corporate") ? "Corporate credit" : (billing?.credit_type === "insurance") ? "Insurance credit" : (billing?.credit_type === "patient") ? "Patient credit" : (showPharmacy && !billing?.credit_type) ? billing?.primary_Credit : (JSON.parse(localGetItem('allow_patient_credit_bills')) || !historyData?.is_final_bill_generated) ? "Patient credit" : ''
          data['paid_in'] = PaidAmount === 0 ? null : "FRONT OFFICE"
          data['cash_amount'] = (+billing?.cash_amt || 0)
          data['card_amount'] = (+billing?.card_amt || 0)
          data['upi_amount'] = (+billing?.upi_amt || 0)
          data['bank_amount'] = (+billing?.bank_amt || 0)
          data['cheque_amount'] = (+billing?.cheque_amt || 0)
          data['co_payment_amount'] = billing?.credit_type === "insurance" ? (+billing?.co_payment_amount || 0) : 0
          data['card_ref_no'] = (billing?.card_no || "")
          data['upi_ref_no'] = (billing?.upi_no || "")
          data['bank_ref_no'] = (billing?.bank_no || "")
          data['cheque_ref_no'] = (billing?.card_no || "")
          data['advance_adjusted'] = (billing?.pay_from_advance && billing?.advance_deducted) ? true : false
          data['advance_deducted_amount'] = (IP_Advance + Pharma_Advance + Ot_Advance)
          data['ip_advance_deducted_amount'] = IP_Advance
          data['pharmacy_advance_deducted_amount'] = Pharma_Advance
          data['ot_advance_deducted_amount'] = Ot_Advance
          data['received_amount'] = IP_Received
          data['pharmacy_amount'] = Pharma_received
          data['ot_amount'] = Ot_received
          data['net_received_amount'] = (IP_Received + Pharma_received + Ot_received)
          data['is_final_bill_generated'] = true
          data['pharmacy_details'] = PharmacyBills
          data['employee_id'] = billing?.selected_employee_number ? billing?.selected_employee_number : ""
          data['employer_id'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.id : (billing.selected_corporate_company && CorporateList?.find((list) => list?.company_name === billing.selected_corporate_company)?.id) ? CorporateList?.find((list) => list?.company_name === billing.selected_corporate_company)?.id : ""
          data['employer_name'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.company_name : (billing.selected_corporate_company ? billing.selected_corporate_company : "")
          data['company_name'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.company_name : (billing.selected_corporate_company ? billing.selected_corporate_company : "")
          data['insurance_company_name'] = billing?.selected_insuance_company?.insurance_name ? billing?.selected_insuance_company?.insurance_name : billing.selected_insuance_company ? billing.selected_insuance_company : ""
          data['policy_number'] = billing.selected_policy_number ? billing.selected_policy_number : ""
          data['insurance_id'] = billing?.insurance_id ? billing?.insurance_id : null
          data['ot_details'] = OTBills
          data['total_order_advance_amt'] = (billing?.total_advance_adjusted || 0) // Order advance adjusted
        } else {
          data['payment_status'] = billing?.total_advance_adjusted ? ((billing?.final_amount === billing?.total_advance_adjusted) ? "paid" : "partial") :  'not paid'
          data['total_order_advance_amt'] = (billing?.total_advance_adjusted || 0) // Order advance adjusted
          data['advance_deducted_amount'] = 0
          data['ip_advance_deducted_amount'] = 0
          data['pharmacy_advance_deducted_amount'] = 0
          data['ot_advance_deducted_amount'] = 0
          if(historyData?.is_final_bill_generated){
            data['is_final_bill_generated'] = true
          }
          if (billing?.generateFinalBillClicked) {
            data['is_final_bill_generated'] = true
            data['co_payment_amount'] = 0
            data['credit_type'] = (billing?.credit_type === "corporate") ? "Corporate credit" : (billing?.credit_type === "insurance") ? "Insurance credit" : (billing?.credit_type === "patient") ? "Patient credit" : (showPharmacy && !billing?.credit_type) ? billing?.primary_Credit : "Patient credit"
            data['employee_id'] = billing?.selected_employee_number ? billing?.selected_employee_number : ""
            data['employer_id'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.id : (billing.selected_corporate_company && CorporateList?.find((list) => list?.company_name === billing.selected_corporate_company)?.id) ? CorporateList?.find((list) => list?.company_name === billing.selected_corporate_company)?.id : ""
            data['employer_name'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.company_name : (billing.selected_corporate_company ? billing.selected_corporate_company : "")
            data['company_name'] = billing?.selected_corporate_company?.company_name ? billing?.selected_corporate_company?.company_name : (billing.selected_corporate_company ? billing.selected_corporate_company : "")
            data['insurance_company_name'] = billing?.selected_insuance_company?.insurance_name ? billing?.selected_insuance_company?.insurance_name : billing.selected_insuance_company ? billing.selected_insuance_company : ""
            data['policy_number'] = billing.selected_policy_number ? billing.selected_policy_number : ""
            data['insurance_id'] = billing?.insurance_id ? billing?.insurance_id : null
            data['is_first_final_bill_generated'] = true
          }
        }
        if(ForFinalBill && !billing?.generateFinalBillClicked){
          data["is_final_settlement_done"] = true
        }

        const allowPatientCredit = (JSON.parse(localGetItem('allow_patient_credit_bills')) || !historyData?.is_final_bill_generated);
        // No type selected
        if (!data.credit_type && ForFinalBill && (billing?.selected_patient_amt || billing?.selected_corporate_amt || billing?.selected_insurance_amt)) {
          errorMessage("Please select the Credit Type");
          LoaderFunction(false);
          return
        }

        // If allowed, must be exactly "Patient credit"
        if (!allowPatientCredit && data.credit_type === "Patient credit" && (billing?.selected_patient_amt || billing?.selected_corporate_amt || billing?.selected_insurance_amt)) {
          errorMessage("Please select the Credit Type");
          LoaderFunction(false);
          return
        }
        if(!allowPatientCredit && data.credit_type === "Patient credit" ){
           data['credit_type'] = ""
        }
        RestAPIService.create(data, Serviceurls.NEW_BILLING_IP_SETTLEMENT)
          .then((response) => {
            if (response?.data?.status === 'success') {
              LoaderFunction(false);
              clearRightData()
              setRequestState((prev) => ({ ...prev, pendingCancel: false }))
              props.triggerNotifyCount(true)
              if (ForFinalBill) {
                successMessage(response?.data?.message)
                setPatientDetails((prev) => ({ ...prev, advance_amount: (response?.data?.data?.advance_amount || 0) }))
                setFinalBillPosted(true)
                setbillsummaryID(response?.data?.data?.bill_id || null)
                setreceiptID(response?.data?.data?.receipt_id || null)
              } else {
                if (billing?.generateFinalBillClicked) {
                  setSuccessPopup((prev) => ({
                    ...prev,
                    SuccessInvoice_ID: historyData?.id || null,
                    bill_receipt_id: null,
                    isCredit: false,
                    successText: response?.data?.message || '',
                  }))
                } else {
                  successMessage(response?.data?.message)
                }
              }
              if (requestState.fromApprover || requestState?.fromPendingList || (requestState?.status)) {
                history.push({ pathname: "/IPHome" })
              }
            }
          }).catch((error) => {
            LoaderFunction(false);
            if (error?.response?.data?.message) {
              errorMessage(error?.response?.data?.message)
            } else {
              errorMessage(error.message)
            }
          })
      }
    } catch (error) {
      LoaderFunction(false);
      errorMessage(error.message)
    }
  }
  // API INTEGRATION ENDS =====>

  const ClosePopUp = () => {
    try {
      setSuccessPopup((prev) => ({
        ...prev,
        SuccessInvoice_ID: null,
        bill_receipt_id: null,
        patientId: null,
        isCredit: false,
        successText: '',
      }))
      history.push({ pathname: "/IPHome" })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onSelectServiceHandler = (value) => {
    try {
      setBilling((prev) => {
        let serviceData = {}
        if ('emergency' in value) {
          serviceData = value?.emergency
        } else if ('holiday' in value) {
          serviceData = value?.holiday
        } else {
          serviceData = value
        }

        const sharedFields = {
          rate_per_unit: serviceData.service_charge,
          unit: serviceData.unit,
          unit_type: serviceData.unit_type,
          total_amt: serviceData.service_charge,
          total_with_discount: serviceData.service_charge,
          doctor_amt: serviceData.doctor_share_amount,
          doctor_percent: serviceData.doctor_share_percent,
          old_doctor_amt: serviceData.doctor_share_amount,
          new_doctor_amt: serviceData.doctor_share_amount,
          hospital_amt: serviceData.hospital_share_amount,
          hospital_percent: serviceData.hospital_share_percent,
          old_hospital_amt: serviceData.hospital_share_amount,
          new_hospital_amt: serviceData.hospital_share_amount,
          interval_time: serviceData.interval_time,
          interval_amount: serviceData.interval_amount,
          service_name: serviceData.service_name,
          service_head_name: serviceData.service_head,
          service_code: serviceData.service_code,
          service_head_code: serviceData.service_head_code,
          edit_unit: serviceData.edit_unit,
          edit_amount: serviceData.edit_amount,
          edit_discount: serviceData.edit_discount,
          doctor_name: serviceData.doctor_name,
          doctor_id: serviceData.doctor_id,
          start_time: serviceData.start_time,
          end_time: serviceData.end_time,
          gst_percent: serviceData.gst_percent || 0,
          hours: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[0] : '',
          minutes: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[1] : '',
          service_details_id: serviceData?.service_details_id,
          doctor_id: serviceData?.doctor_id,
          review_days: serviceData?.review_days,
          review_count: serviceData?.review_count,
          charge_id: serviceData?.charge_id,
          doctor_name: serviceData?.doctor_name,
          module_type: serviceData?.module_type,
          doctor_percent_w_r: serviceData?.doctor_share_percent.toFixed(2),
          hospital_percent_w_r: serviceData?.hospital_share_percent.toFixed(2),
          start_date: new Date(),
          end_date: null,
          is_hospital: serviceData?.is_hospital,
          service_head_id: serviceData?.service_head_id,
          old_time_taken: serviceData.unit_type === 'Hrs' ? serviceData?.unit : null,
          doc_discount_amt: '',
          doc_discount_percent: '',
          doc_discount_percent_w_r: '',
          hos_discount_amt: '',
          hos_discount_percent: '',
          hos_discount_percent_w_r: '',
          is_sharable: serviceData?.is_sharable
        };

        if (serviceData?.membership_discount_percentage) {
          sharedFields.membership_discount_percentage = true
          if (serviceData?.is_sharable) {
            const baseTotalAmt = serviceData.service_charge;
            const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(sharedFields.doctor_percent, baseTotalAmt)
            const updatedOldHos = CommonValidation.getDiscountAmountWithRound(sharedFields.hospital_percent, baseTotalAmt)
            const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
            const disHos = CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, updatedOldHos)
            const conTlt = (+disDoc) + (+disHos)

            sharedFields.total_amt = baseTotalAmt
            sharedFields.total_with_discount = baseTotalAmt - disHos
            sharedFields.old_doctor_amt = updatedOldDoc
            sharedFields.old_hospital_amt = updatedOldHos
            sharedFields.new_doctor_amt = updatedOldDoc - disDoc
            sharedFields.new_hospital_amt = updatedOldHos - disHos
            sharedFields.doctor_amt = updatedOldDoc - disDoc
            sharedFields.hospital_amt = updatedOldHos - disHos
            sharedFields.doc_discount_amt = disDoc
            sharedFields.hos_discount_amt = disHos
            sharedFields.hos_discount_percent = serviceData?.membership_discount_percentage
            sharedFields.hos_discount_percent_w_r = serviceData?.membership_discount_percentage
            sharedFields.concession_amt = CommonValidation.formatAmount(conTlt)
            sharedFields.concession_percent = serviceData?.membership_discount_percentage
            sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
            sharedFields.concession_comments = "Membership concession"
          } else {
            sharedFields.concession_percent = serviceData?.membership_discount_percentage
            sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
            sharedFields.total_with_discount = (sharedFields.total_amt - CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt))
            sharedFields.concession_amt = +CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt)
          }
        }

        return {
          ...prev,
          selected_service: serviceData,
          service_data: {
            ...prev.service_data,
            ...sharedFields,
          },
        };
      });

    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onClickUnitHandler = useCallback((type) => {
    try {
      setBilling((prev) => {
        const updatedServiceData = { ...prev.service_data };
        switch (type) {
          case 'increase':
            updatedServiceData.unit++;
            break;
          case 'decrease':
            updatedServiceData.unit = Math.max(0, updatedServiceData.unit - 1); // Prevent negative units
            break;
        }
        if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt) {
          const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
          const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
          const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
          const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
          const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
          const conTlt = (+disDoc) + (+disHos)

          updatedServiceData.total_amt = baseTotalAmt
          updatedServiceData.old_doctor_amt = updatedOldDoc
          updatedServiceData.old_hospital_amt = updatedOldHos
          updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
          updatedServiceData.new_hospital_amt = updatedOldHos - disHos
          updatedServiceData.doctor_amt = updatedOldDoc - disDoc
          updatedServiceData.hospital_amt = updatedOldHos - disHos
          updatedServiceData.doc_discount_amt = disDoc
          updatedServiceData.hos_discount_amt = disHos
          updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
          updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
          updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
        } else {
          let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
          updatedServiceData.total_amt = total;
          updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
        }

        return { ...prev, service_data: updatedServiceData };
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }, [billing.service_data])

  const withOutShareHandler = useCallback((e, key) => {
    try {
      const value = e.target.value
      setBilling((prev) => {
        const update = { ...prev.service_data };
        switch (key) {
          case 'rate_per_unit':
            let Hours = (update?.hours === "" ? "00" : (update?.hours)?.toString()?.length < 2 ? ("0" + update?.hours) : update?.hours) + ":" + (update?.minutes === "" ? "00" : (update?.minutes)?.toString()?.length < 2 ? ("0" + update?.minutes) : update?.minutes) + ":" + "00"
            let hourTotal = update.unit_type === 'Hrs' ? CalculateHourAmount(value, Hours, update.old_time_taken, update?.interval_time, update?.interval_amount) : 0
            const newRatePerUnit = update.unit_type === 'Hrs' ? value : +(value * update.unit)

            update.rate_per_unit = value;
            update.total_amt = update.unit_type === 'Hrs' ? hourTotal : (value * update.unit);
            update.concession_amt = newRatePerUnit ? +CommonValidation.getDiscountAmountWithRound(update.concession_percent, newRatePerUnit) : ''
            update.concession_percent = value ? update.concession_percent : ''
            update.concession_percent_w_r = value ? update.concession_percent_w_r : ''
            break;
          case 'concession_discount_amt':
            if (CommonValidation.DecimalNumber(value) && value >= 1 && value <= update.total_amt || value === '') {
              update.concession_amt = value
              update.concession_percent = CommonValidation.getDiscountPercentage(value, update.total_amt)
              update.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(value, update.total_amt)
            }
            break;
          case 'concession_discount_percent':
            if (CommonValidation.DecimalNumber(value) && value >= 1 && value <= 100 || value === '') {
              update.concession_percent = value
              update.concession_percent_w_r = value
              update.concession_amt = CommonValidation.getDiscountAmountWithRound(value, update.total_amt)
            }
            break;
          default: break;
        }
        return { ...prev, service_data: update }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }, [billing.service_data])

  const onEditHandler = (item, index = null, subIndex = null, mainIndex = null) => {
    try {
      setBilling((prev) => {
        prev.selected_service = item
        prev.selected_bill_doc = item?.doctor_id ? billing?.billDocSugg?.find((list) => list?.doctor_id === item?.doctor_id) : null
        prev.service_data = item
        prev.isEdit = true
        prev.selectedIndex = index
        prev.selectedSubIndex = subIndex
        prev.selectedServiceIndex = mainIndex
        return { ...prev }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onClearServiceData = () => {
    try {
      setBilling((prev) => ({
        ...prev,
        selected_bill_doc: billing.selected_bill_doc,
        selected_service: null,
        service_data: {
          rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
          doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
          hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
          interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
          service_code: '', service_head_code: '', edit_unit: '', edit_amount: '',
          edit_discount: '', doctor_name: '', doctor_id: '', start_time: '',
          end_time: '', doc_discount_amt: '', doc_discount_percent: '',
          hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
          concession_percent: '', gst_percent: 0, hours: '', minutes: '',
          concession_comments: '', service_details_id: '', doctor_id: '',
          review_days: '', review_count: '', charge_id: '', doctor_name: '',
          gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
          taxable_amount: '', sub_total_amount: '', round_off: '',
          received_amount: '', net_amount: '', concession_percent_w_r: '',
          doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
          doctor_percent_w_r: '', hospital_percent_w_r: '',
          module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
          service_head_id: null, concession_percent_w_r: ''
        },
        isEdit: false,
        selectedIndex: null, selectedServiceIndex: null, selectedSubIndex: null,
        selected_bill_doc_id: billing.selected_bill_doc_id || billing?.selected_bill_doc?.doctor_id
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const clearAllData = () => {
    try {
      setOpenPopup(null)
      setPopupValues({})
      setSelectedRadio('input')
      setBilling((prev) => ({
        ...prev,
        selected_bill_doc: null,
        selected_service: null,
        selected_temp_pack: null,
        selectedIndex: null,
        isEdit: null,
        isCash: false,
        isCard: false,
        isUPI: false,
        isBank: false,
        isCheque: false,
        cash_amt: '',
        card_amt: '',
        bank_amt: '',
        upi_amt: '',
        cheque_amt: '',
        card_no: '',
        upi_no: '',
        bank_no: '',
        cheque_no: '',
        serviceSugg: [],
        service_data: {
          rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
          doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
          hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
          interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
          service_code: '', service_head_code: '', edit_unit: '', edit_amount: '',
          edit_discount: '', doctor_name: '', doctor_id: '', start_time: '',
          end_time: '', doc_discount_amt: '', doc_discount_percent: '',
          hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
          concession_percent: '', gst_percent: 0, hours: '', minutes: '',
          concession_comments: '', service_details_id: '', doctor_id: '',
          review_days: '', review_count: '', charge_id: '', doctor_name: '',
          gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
          taxable_amount: '', sub_total_amount: '', round_off: '',
          received_amount: '', net_amount: '', concession_percent_w_r: '',
          doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
          doctor_percent_w_r: '', hospital_percent_w_r: '', concession_percent_w_r: '',
          module_type: '', start_date: new Date(), end_date: null, is_hospital: false
        },
        overall_data: {
          sub_total: '',
          taxable_amount: '',
          concession_applicable: '',
          overall_discount_amt: '',
          overall_discount_percent: '',
          overall_discount_percent_w_r: '',
          gst_amount: '',
          payable_amt: '',
        }
      }))
      setBillingList([]);
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onAddHandler = () => {
    try {
      let discountTotal = billing.service_data.total_amt - billing.service_data.concession_amt;
      let incGst = CommonValidation.calculateTotalWithGST(discountTotal, ((+discountTotal > +RoomChargeGST?.room_charge_gst_limit && (billing?.service_head_name === "Room Charges" || billing?.service_data?.service_head_name === "Room Charges") && RoomChargeGST?.is_room_charge_gst_applicable) ? (+RoomChargeGST?.room_charge_gst_percent || 0) : 0));
      let tltGstdiff = (incGst - discountTotal);
      let sgstCgst = (+tltGstdiff / 2);
      let service_list = {
        ...billing.service_data,
        total_with_discount: discountTotal,
        service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
        gst_amount: +CommonValidation.formatAmount(tltGstdiff),
        sgst_amount: +CommonValidation.formatAmount(sgstCgst),
        cgst_amount: +CommonValidation.formatAmount(sgstCgst),
        igst_amount: +CommonValidation.formatAmount(tltGstdiff),
        taxable_amount: discountTotal,
        sub_total_amount: billing.service_data.total_amt,
        concession_applicable: billing?.service_data?.edit_amount ? ((billing?.service_data?.concession_amt === '' || +billing?.service_data?.concession_amt === 0) ? (billing?.service_data?.is_hospital ? billing?.service_data?.new_hospital_amt : discountTotal) : 0) : 0,
        module_type: billing.service_data.module_type,
        unit: billing.service_data?.unit,
        service_head_id: billing.service_data?.service_head_id,
        doctor_id: billing.selected_bill_doc?.doctor_id || billing.selected_bill_doc_id,
        doctor_name: billing.selected_bill_doc?.doctor_name || billing.selected_bill_doc,
        gst_percent: billing.service_data.gst_percent
      };
      let checkData = checkDuplicate();
      setBillingList((prev) => {
        const updatedBillingList = [...prev];
        if (billing.isEdit) {
          if (billing.selectedSubIndex !== null && billing.selectedIndex !== null && billing.selectedServiceIndex === null) {
            updatedBillingList[billing.selectedIndex]['package_line'][billing.selectedSubIndex] = service_list
          } else if (billing.selectedSubIndex !== null && billing.selectedServiceIndex !== null && billing.selectedIndex !== null) {
            updatedBillingList[billing.selectedIndex]['package_line'][billing.selectedSubIndex]['service_data'][billing.selectedServiceIndex] = service_list
          } else {
            updatedBillingList[billing.selectedIndex] = service_list;
          }
        } else {
          updatedBillingList.push(service_list);
        }

        if (requestState.fromPendingList) {
          setDupBillList(JSON.stringify(updatedBillingList))
        }
        return updatedBillingList;
      });
      setTimeout(() => onClearServiceData(), 50);
    } catch (error) {
      errorMessage(error.message);
    }
  };

  const checkDuplicate = () => {
    try {
      let message = null;
      let billingListCopy = [...billingList]
      billingListCopy?.forEach((element, index) => {
        if (index !== billing.selectedIndex) {
          if ((element?.service_head_code === billing.selected_service?.service_head_code) &&
            (element?.service_code === billing.selected_service?.service_code)) {
            message = 'Service Already Exist'
          }
        }
      })
      return message;
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onPopupChangeHandler = useCallback((e, key) => {
    try {
      let value = e.target.value
      setPopupValues((prev) => {
        let updateState = {};
        switch (key) {
          case 'doctor_amt':
            if (CommonValidation.DecimalNumber(value) || value === '') {
              let totalAmt = (+value) + (+popupValues.hospital_amt)
              updateState.doctor_amt = value;
              updateState.new_doctor_amt = value;
              updateState.old_doctor_amt = value;
              updateState.total_amt = totalAmt
              updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.hospital_amt)) : totalAmt / popupValues.unit
              updateState.doctor_percent = +CommonValidation.getDiscountPercentage(value, totalAmt)
              updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt)
              updateState.hospital_percent = +CommonValidation.getDiscountPercentage(popupValues.hospital_amt, totalAmt)
              updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(popupValues.hospital_amt, totalAmt)
              updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, value)
            }
            break;
          case 'hospital_amt':
            if (CommonValidation.DecimalNumber(value) || value === '') {
              let totalAmt = (+value) + (+popupValues.doctor_amt)
              updateState.hospital_amt = value;
              updateState.new_hospital_amt = value;
              updateState.old_hospital_amt = value;
              updateState.total_amt = totalAmt
              updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.doctor_amt)) : totalAmt / popupValues.unit
              updateState.doctor_percent = +CommonValidation.getDiscountPercentage(popupValues.doctor_amt, totalAmt)
              updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(popupValues.doctor_amt, totalAmt)
              updateState.hospital_percent = +CommonValidation.getDiscountPercentage(value, totalAmt)
              updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt)
              updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, value)
            }
            break;
          case 'doctor_discount_amt':
            if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_doctor_amt || value === '') {
              updateState.doc_discount_amt = value
              updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - value);
              updateState.doc_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_doctor_amt)
              updateState.doc_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_doctor_amt)
              updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - value);
            }
            break;
          case 'hospital_discount_amt':
            if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_hospital_amt || value === '') {
              updateState.hos_discount_amt = value
              updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value);
              updateState.hos_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_hospital_amt)
              updateState.hos_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_hospital_amt)
              updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value);
            }
            break;
          case 'doctor_discount_percent':
            if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
              let disAmt = CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt)
              updateState.doc_discount_percent = value
              updateState.doc_discount_percent_w_r = value
              updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt)
              updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt);
              updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt);
            }
            break;
          case 'hospital_discount_percent':
            if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
              let disAmt = CommonValidation.getDiscountAmount(value, popupValues.old_hospital_amt)
              updateState.hos_discount_percent = value
              updateState.hos_discount_percent_w_r = value
              updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_hospital_amt)
              updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt);
              updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt);
            }
            break;
          case 'concession_comments':
            if (value?.length <= 500 || value === '') {
              updateState.concession_comments = value
            }
            break;
          case 'hours':
            if (CommonValidation.numberOnly(value) && value <= 23 || value === '') {
              updateState.hours = value
            }
            break;
          case 'minutes':
            if (CommonValidation.numberOnly(value) && value <= 59 || value === '') {
              updateState.minutes = value
            }
            break;
        }
        return { ...prev, ...updateState }
      })
    } catch (error) {
      errorMessage(error.message);
    }
  }, [popupValues])

  const popupTextBox = (key, values, multiline, row, labels, readOnly, width) => {
    try {
      return (
        <TextField
          autoComplete='off'
          size='small'
          sx={{ width: width || '13dvw' }}
          value={values}
          onChange={(e) => onPopupChangeHandler(e, key)}
          multiline={multiline}
          rows={row}
          label={labels}
          InputProps={{ readOnly: readOnly, emed_tid: key }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const convertTimeToDecimal = (time) => {
    let [hours, minutes] = time?.split(':').map(Number);
    return hours * 60 + minutes;
  }

  const CalculateHourAmount = (ratePerHour, changedTime, fixedTime, minTime, minAmount) => {
    let fixedTimes = convertTimeToDecimal(fixedTime);
    let changedTimes = convertTimeToDecimal(changedTime);
    let minTimes = convertTimeToDecimal(minTime ? minTime : '00:00')
    let changeAndFixedTime = changedTimes - fixedTimes
    let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0
    let timeCalculateTime = (time === 0 && minTimes === 0) ? 0 : Math.ceil(time / minTimes) === Infinity ? 0 : Math.ceil(time / minTimes)
    let totalCost = ((+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0)))

    return totalCost;
  }

  const onSavePopupHandler = (type) => {
    try {
      setBilling((prev) => {
        let updates = { ...prev.service_data }
        switch (type) {
          case 'rate':
            let total = 0;
            if (popupValues.unit_type === 'Nos') {
              total = popupValues.rate_per_unit * popupValues.unit
            } else {
              let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
              let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)
              total = hourTotal
            }
            let concession = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

            updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
            updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
            updates.doctor_percent = +popupValues.doctor_percent
            updates.hospital_percent = +popupValues.hospital_percent
            updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
            updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
            updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
            updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
            updates.total_amt = +CommonValidation.formatAmount(total)
            updates.rate_per_unit = +CommonValidation.formatAmount(popupValues.rate_per_unit)
            updates.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, popupValues.old_doctor_amt)
            updates.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, popupValues.old_hospital_amt)
            updates.concession_amt = +CommonValidation.formatAmount(concession)
            updates.concession_percent = +CommonValidation.getDiscountPercentage(concession, total)
            updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concession, total)
            updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
            updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
            updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
            updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
            break;
          case 'concession':
            let concessionAmt = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

            updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
            updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
            updates.doctor_percent = +popupValues.doctor_percent
            updates.hospital_percent = +popupValues.hospital_percent
            updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt)
            updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt)
            updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.new_doctor_amt)
            updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.new_hospital_amt)
            updates.total_amt = +CommonValidation.formatAmount(popupValues.total_amt)
            updates.concession_amt = +CommonValidation.formatAmount(concessionAmt)
            updates.concession_percent = +CommonValidation.getDiscountPercentage(concessionAmt, popupValues.total_amt)
            updates.doc_discount_amt = +CommonValidation.formatAmount(popupValues.doc_discount_amt)
            updates.doc_discount_percent = +popupValues.doc_discount_percent
            updates.hos_discount_amt = +CommonValidation.formatAmount(popupValues.hos_discount_amt)
            updates.hos_discount_percent = +popupValues.hos_discount_percent
            updates.concession_comments = +popupValues.concession_comments
            updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
            updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
            updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concessionAmt, popupValues.total_amt)
            updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
            updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
            break;
          case 'time':
            let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
            let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)

            updates.total_amt = hourTotal
            updates.unit = Hours.split(":")[0] + ":" + Hours.split(":")[1]
            updates.old_time_taken = popupValues.old_time_taken
            updates.interval_amount = popupValues.interval_amount
            updates.interval_time = popupValues.interval_time
            updates.rate_per_unit = popupValues.rate_per_unit
            updates.old_doctor_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal)
            updates.old_hospital_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal)
            let docDisc = CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, updates.old_doctor_amt)
            let hosDis = CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, updates.old_hospital_amt)
            updates.doc_discount_amt = +docDisc
            updates.hos_discount_amt = +hosDis
            updates.new_doctor_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal) || 0) - (+docDisc || 0)
            updates.new_hospital_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal) || 0) - (+hosDis || 0)
            updates.concession_amt = updates.doctor_amt && updates.hospital_amt ? (+docDisc) + (+hosDis) : CommonValidation.getDiscountAmountWithRound(popupValues.concession_percent, hourTotal)
            break;
        }
        return { ...prev, service_data: updates }
      })
      setSelectedRadio('input')
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onOpenPopupHandler = (type) => {
    setOpenPopup(type)
    setPopupValues((prev) => {
      let popupUpdates = {};
      switch (type) {
        case 'rate':
          popupUpdates.doctor_amt = billing?.service_data?.old_doctor_amt
          popupUpdates.doctor_percent = billing?.service_data?.doctor_percent
          popupUpdates.doctor_percent_w_r = billing?.service_data?.doctor_percent_w_r
          popupUpdates.hospital_amt = billing?.service_data?.old_hospital_amt
          popupUpdates.hospital_percent = billing?.service_data?.hospital_percent
          popupUpdates.hospital_percent_w_r = billing?.service_data?.hospital_percent_w_r
          popupUpdates.total_amt = billing?.service_data?.total_amt
          popupUpdates.rate_per_unit = billing.service_data.unit_type === 'Nos' ? billing?.service_data?.total_amt / billing?.service_data?.unit :
            billing.service_data.rate_per_unit
          popupUpdates.unit = billing?.service_data?.unit
          break
        case 'concession':
          popupUpdates.old_doctor_amt = billing?.service_data?.old_doctor_amt
          popupUpdates.old_hospital_amt = billing?.service_data?.old_hospital_amt
          popupUpdates.new_doctor_amt = billing?.service_data?.new_doctor_amt
          popupUpdates.new_hospital_amt = billing?.service_data?.new_hospital_amt
          popupUpdates.doctor_amt = billing?.service_data?.doctor_amt
          popupUpdates.hospital_amt = billing?.service_data?.hospital_amt
          popupUpdates.total_amt = billing?.service_data?.total_amt
          popupUpdates.rate_per_unit = billing?.service_data?.rate_per_unit
          break;
        case 'time':
          let hours = billing?.service_data?.unit?.split(":")[0] || ''
          let mins = billing?.service_data?.unit?.split(":")[1] || ''

          popupUpdates.hours = hours
          popupUpdates.minutes = mins
          popupUpdates.start_date = billing?.service_data?.start_date
          popupUpdates.end_date = billing?.service_data?.end_date;
          popupUpdates.interval_amount = billing?.service_data?.interval_amount
          popupUpdates.interval_time = billing?.service_data?.interval_time
          popupUpdates.old_time_taken = billing?.service_data?.unit
          popupUpdates.rate_per_unit = billing?.service_data?.rate_per_unit
          popupUpdates.total_amt = billing?.service_data?.total_amt
          popupUpdates.unit = billing?.service_data?.unit
          break;
      }
      return {
        ...prev,
        ...popupUpdates,
        concession_amt: billing?.service_data?.concession_amt,
        concession_percent: billing?.service_data?.concession_percent,
        concession_percent_w_r: +(+billing?.service_data?.concession_percent_w_r)?.toFixed(2),
        concession_comments: billing?.service_data?.concession_comments,
        doc_discount_amt: billing?.service_data?.doc_discount_amt,
        doc_discount_percent: billing?.service_data?.doc_discount_percent,
        doc_discount_percent_w_r: +(+billing?.service_data?.doc_discount_percent_w_r)?.toFixed(2),
        hos_discount_amt: billing?.service_data?.hos_discount_amt,
        hos_discount_percent: billing?.service_data?.hos_discount_percent,
        hos_discount_percent_w_r: +(+billing?.service_data?.hos_discount_percent_w_r)?.toFixed(2),
        doctor_percent: billing?.service_data?.doctor_percent,
        doctor_percent_w_r: +(+billing?.service_data?.doctor_percent_w_r)?.toFixed(2),
        hospital_percent: billing?.service_data?.hospital_percent,
        hospital_percent_w_r: +(+billing?.service_data?.hospital_percent_w_r)?.toFixed(2),
        unit_type: billing?.service_data?.unit_type,
        is_hospital: billing?.service_data?.is_hospital,
        service_head_id: billing?.service_data?.service_head_id,
        op_order_number: billing?.service_data?.op_order_number,
        old_time_taken: billing?.service_data?.old_time_taken
      }
    })
  }

  const getTimeDifference = (startDate, endDate) => {
    try {
      const start = new Date(startDate);
      const end = new Date(endDate);
      start.setSeconds(0, 0);
      end.setSeconds(0, 0);
      let diff = end - start;
      const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
      diff %= (1000 * 60 * 60);
      const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, '0');

      return `${hours}:${minutes}`;
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeTimeHandler = useCallback((time, key) => {
    try {
      if (!time) return;

      if (key === 'startDate') {
        if (!popupValues?.end_date) {
          setPopupValues(prev => ({
            ...prev,
            start_date: time
          }));
        } else {
          const timeDiff = getTimeDifference(time, popupValues.end_date);
          setPopupValues(prev => ({
            ...prev,
            start_date: time,
            hours: timeDiff?.split(':')[0],
            minutes: timeDiff?.split(':')[1],
          }));
        }
      }

      if (key === 'endDate') {
        if (!popupValues.start_date) {
          errorMessage('Select Start Date');
          return;
        }

        const timeDiff = getTimeDifference(popupValues.start_date, time);
        setPopupValues(prev => ({
          ...prev,
          end_date: time,
          hours: timeDiff?.split(':')[0],
          minutes: timeDiff?.split(':')[1],
        }));
      }
    } catch (error) {
      errorMessage(error.message);
    }
  }, [popupValues]);

  const ratePerUnitPopup = () => {
    let totalAmt = +popupValues.doctor_amt + (+popupValues.hospital_amt)
    return (
      <>{openPopup === 'rate' ?
        <Dialog open={openPopup === 'rate'} maxWidth='sm' fullWidth>
          <Box className='com_billing_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography fontSize={'1rem'} fontWeight={600}>Update Rate Per Unit</Typography>
              <IconButton
                onClick={() => setOpenPopup(null)}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
              </IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
              <Box component={'div'} display={'flex'} justifyContent={'space-evenly'}>
                <Typography fontSize={'1rem'} fontWeight={600}>{`Rate / Unit - ${popupValues?.rate_per_unit ? CommonValidation.formatAmount(popupValues?.rate_per_unit) : '0'}`}</Typography>
                <Typography fontSize={'1rem'} fontWeight={600}>{`Unit - ${popupValues?.unit}`}</Typography>
              </Box>
              <Box component={'div'} mt={'1rem'}>
                <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                  <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Share</Typography></Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('doctor_amt', popupValues?.doctor_amt, false, 1, `Doctor Fee (${CurrencySymbol})`)}
                  </Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('doctor_percent', popupValues?.doctor_percent_w_r, false, 1, 'Doctor Percentage (%)', true)}
                  </Grid>
                  <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Share</Typography></Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('hospital_amt', popupValues?.hospital_amt, false, 1, `Hospital Fee (${CurrencySymbol})`)}
                  </Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('hospital_percent', popupValues?.hospital_percent_w_r, false, 1, `Hospital Percentage (%)`, true)}
                  </Grid>
                  <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Total Amount</Typography></Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('total_amt', totalAmt ? CommonValidation.formatAmount(totalAmt) : '', false, 1, `Total Amount (${CurrencySymbol})`, true)}
                  </Grid>
                  <Grid xs={4.5}>
                    {popupTextBox('total_percent', '100.00', false, 1, `Total Percentage (%)`, true)}
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box m={'1rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
              <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                onClick={() => setOpenPopup(null)}
              >Close</Button>
              <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                onClick={() => {
                  onSavePopupHandler('rate')
                  setOpenPopup(null)
                }}
              >Save</Button>
            </Box>
          </Box>
        </Dialog> :
        openPopup === 'concession' ?
          <Dialog open={openPopup === 'concession'} maxWidth='sm' fullWidth>
            <Box className='com_billing_popup'>
              <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                <Typography fontSize={'1rem'} fontWeight={600}>Concession</Typography>
                <IconButton
                  onClick={() => setOpenPopup(null)}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </IconButton>
              </Box>
              <Box component={'div'} p={'0.5rem'}>
                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                  <Typography fontSize={'1rem'} fontWeight={600}>{`Bill Amount : ${CommonValidation.formatAmount(popupValues?.total_amt)}`}</Typography>
                </Box>
                <Box component={'div'} mt={'1rem'}>
                  <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Concession</Typography></Grid>
                    <Grid xs={4.5}>
                      {popupTextBox('doctor_discount_amt', popupValues?.doc_discount_amt, false, 1, `Amount (${CurrencySymbol})`, (popupValues?.is_hospital || billing?.service_data?.membership_discount_percentage))}
                    </Grid>
                    <Grid xs={4.5}>
                      {popupTextBox('doctor_discount_percent', popupValues?.doc_discount_percent_w_r, false, 1, 'Percentage (%)', (popupValues?.is_hospital || billing?.service_data?.membership_discount_percentage))}
                    </Grid>
                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Concession</Typography></Grid>
                    <Grid xs={4.5}>
                      {popupTextBox('hospital_discount_amt', popupValues?.hos_discount_amt, false, 1, `Amount (${CurrencySymbol})`, billing?.service_data?.membership_discount_percentage)}
                    </Grid>
                    <Grid xs={4.5}>
                      {popupTextBox('hospital_discount_percent', popupValues?.hos_discount_percent_w_r, false, 1, 'Percentage (%)', billing?.service_data?.membership_discount_percentage)}
                    </Grid>
                  </Grid>
                </Box>
                {popupValues?.is_hospital ? <Box><FormHelperText sx={{ color: 'red', fontSize: COMMON_STYLES.FONT_SIZE_SM, textAlign: 'center' }}>! Concession Enable Only For Hospital</FormHelperText></Box> : null}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '0.5rem' }}>
                  <Box>
                    <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Doctor Share</Typography>
                    <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_doctor_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.doc_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_doctor_amt) || 0}`}</Typography>
                  </Box>
                  <Box mr={'2rem'}>
                    <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Hosptial Share</Typography>
                    <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_hospital_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.hos_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_hospital_amt) || 0}`}</Typography>
                  </Box>
                </Box>
                <Box component={'div'} mt={'0.5rem'}>
                  {popupTextBox('concession_comments', popupValues?.concession_comments, true, 3, 'Concession Comments', (billing?.service_data?.membership_discount_percentage), '37dvw')}
                </Box>
              </Box>
              <Box m={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                  onClick={() => setOpenPopup(null)}
                >Close</Button>
                <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                  disabled={billing?.service_data?.membership_discount_percentage}
                  onClick={() => {
                    onSavePopupHandler('concession')
                    setOpenPopup(null)
                  }}
                >Save</Button>
              </Box>
            </Box>
          </Dialog> :
          <Dialog open={openPopup === 'time'} maxWidth='sm'>
            <Box className='com_billing_popup'>
              <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                <Typography fontSize={'1rem'} fontWeight={600}>Unit</Typography>
                <IconButton
                  onClick={() => setOpenPopup(null)}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </IconButton>
              </Box>
              <Box component={'div'} p={'0.5rem'}>
                <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                  <RadioGroup row
                    value={selectedRadio}
                    onChange={(e) => { setSelectedRadio(e.target.value) }}
                  >
                    <FormControlLabel value={'input'} control={<Radio size='small' />} label="Based on Input" />
                    <FormControlLabel value={'time'} control={<Radio size='small' />} label="Based on Time" />
                  </RadioGroup>
                </Box>
                <Box component={'div'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Input</Typography>
                  <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                    <TextField size='small' disabled={selectedRadio === 'time'}
                      value={popupValues?.hours}
                      onChange={(e) => { onPopupChangeHandler(e, 'hours') }}
                      label='Hours'
                      sx={{ width: '15dvw' }}
                    />
                    <TextField size='small' disabled={selectedRadio === 'time'}
                      value={popupValues?.minutes}
                      onChange={(e) => { onPopupChangeHandler(e, 'minutes') }}
                      label='Minutes'
                      sx={{ width: '15dvw', ml: '1rem' }}
                    />
                  </Box>
                </Box>
                <Box component={'div'} mt={'0.5rem'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Time</Typography>
                  <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        disabled={selectedRadio === 'input'}
                        value={popupValues?.start_date}
                        name={"datePicker"}
                        open={billing.startTimeOpen}
                        onOpen={() => { setBilling((prev) => ({ ...prev, startTimeOpen: true })) }}
                        onClose={() => { setBilling((prev) => ({ ...prev, startTimeOpen: false })) }}
                        inputFormat='DD-MM-YYYY hh:mm A'
                        label={('Start Date & Time')}
                        minDate={new Date()}
                        maxDate={new Date()}
                        onChange={(newDate) => { onChangeTimeHandler(newDate, 'startDate') }}
                        renderInput={(params) => <TextField
                          onClick={() => { setBilling((prev) => ({ ...prev, startTimeOpen: true })) }}
                          onKeyDown={(e) => { e.preventDefault() }}
                          size='small' {...params} sx={{ width: '15dvw' }}
                        />}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        disabled={selectedRadio === 'input'}
                        value={popupValues?.end_date}
                        name={"datePicker"}
                        open={billing.endTimeOpen}
                        onOpen={() => { setBilling((prev) => ({ ...prev, endTimeOpen: true })) }}
                        onClose={() => { setBilling((prev) => ({ ...prev, endTimeOpen: false })) }}
                        inputFormat='DD-MM-YYYY hh:mm A'
                        label={('Start Date & Time')}
                        minDate={new Date()}
                        maxDate={new Date()}
                        onChange={(newDate) => { onChangeTimeHandler(newDate, 'endDate') }}
                        renderInput={(params) => <TextField
                          onClick={() => { setBilling((prev) => ({ ...prev, endTimeOpen: true })) }}
                          onKeyDown={(e) => { e.preventDefault() }}
                          sx={{ ml: '1rem', width: '15dvw' }}
                          size='small' {...params}
                        />}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box component={'div'} mt={'0.5rem'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                    <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                      onClick={() => setOpenPopup(null)}
                    >Close</Button>
                    <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                      onClick={() => {
                        onSavePopupHandler('time')
                        setOpenPopup(null)
                      }}
                    >Add</Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Dialog>
      }</>
    )
  }

  const splitUp = (overallDiscount, list = null) => {
    let totalHospitalShare = 0;
    let data = list || JSON.parse(dupBillList)

    data?.forEach(item => {
      if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
        if (item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') {
          if (item.edit_discount && !item?.is_advance_adjusted && (!item.concession_amt || +item.concession_amt === 0 || item.is_overall_concession)) {
            totalHospitalShare += item.is_hospital ? (item.hospital_amt ? +item.hospital_amt : 0) : (item?.total_amt ? +item?.total_amt : 0)
          }
        } else if (item?.billing_display === 'Assorted Service Head') {
          item?.package_line?.forEach(pack => {
            if (pack.edit_discount && !item?.is_advance_adjusted && (!pack.concession_amt || +pack.concession_amt === 0 || pack.is_overall_concession)) {
              totalHospitalShare += pack.is_hospital ? (pack.hospital_amt ? +pack.hospital_amt : 0) : (pack?.total_amt ? +pack?.total_amt : 0)
            }
          })
        } else if (item?.billing_display === 'Service Name' || item?.billing_display === 'Service Head') {
          item?.package_line?.forEach(pack => {
            pack?.service_data?.forEach(service => {
              if (service.edit_discount && !item?.is_advance_adjusted && (!service.concession_amt || +service.concession_amt === 0 || service.is_overall_concession)) {
                totalHospitalShare += service.is_hospital ? (service.hospital_amt ? +service.hospital_amt : 0) : (service?.total_amt ? +service?.total_amt : 0)
              }
            })
          })
        }
      } else {
        if (item.edit_discount && !item?.is_advance_adjusted && (!item.concession_amt || +item.concession_amt === 0 || item.is_overall_concession)) {
          totalHospitalShare += item.is_hospital ? (item.hospital_amt ? +item.hospital_amt : 0) : (item?.total_amt ? +item?.total_amt : 0)
        }
      }
    })

    const result = new Array(data.length);
    const taxableAmount = data.reduce((sum, item) => sum + item.total_amt, 0);

    let TotalPayableAmount = 0

    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
        switch (item?.billing_display) {
          case 'Package Name':
          case 'Assorted Package Name':
            if ((item.concession_amt === '' || +item.concession_amt === 0 || !item.concession_amt || item?.is_overall_concession) && !item?.is_advance_adjusted && (item?.edit_discount || item?.service_head_name === "Room Charges")) {
              const isHospital = item.is_hospital;
              const maxDiscount = (item.concession_amt === '' || +item.concession_amt === 0 || !item.concession_amt || item?.is_overall_concession) ? (isHospital ? +item.hospital_amt : +item.total_amt) : 0;

              let discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? ((maxDiscount / totalHospitalShare) * (+overallDiscount || 0)) : 0;
              discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? Math.min(parseFloat(discountShare.toFixed(2)), maxDiscount) : 0;

              let newTotalAmount = parseFloat((item.sub_total_amount - discountShare).toFixed(2));

              let newDoctorShare = 0, newHospitalShare = 0, newDoctorPercent = 0, newHospitalPercent = 0;

              if (item.edit_discount && !item?.is_advance_adjusted && (!item.concession_amt || item.is_overall_concession || +item.concession_amt === 0)) {
                if (isHospital) {
                  if (item.doctor_amt) {
                    newDoctorShare = parseFloat(item.doctor_amt);
                  } else {
                    newDoctorShare = 0;
                  }
                  newHospitalShare = parseFloat((item.hospital_amt - discountShare));

                  newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                  newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                  let newTotalWithGst = parseFloat((newTotalAmount * (1 + item.gst_percent / 100)).toFixed(2));
                  let docAmt = (item.old_doctor_amt - newDoctorShare)?.toFixed(2)
                  let hosAmt = (item.old_hospital_amt - newHospitalShare)?.toFixed(2)

                  item.concession_amt = discountShare
                  item.new_doctor_amt = newDoctorShare
                  item.doctor_amt = newDoctorShare
                  item.new_hospital_amt = newHospitalShare
                  item.hospital_amt = newHospitalShare
                  item.doc_discount_amt = docAmt
                  item.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, item.old_doctor_amt)
                  item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, item.old_doctor_amt)
                  item.hos_discount_amt = hosAmt
                  item.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, item.old_hospital_amt)
                  item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, item.old_hospital_amt)
                  item.total_with_discount = newTotalAmount
                  item.service_with_gst_total_amt = newTotalWithGst
                  let gstAmt = newTotalWithGst - newTotalAmount
                  item.gst_amount = gstAmt
                  item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.igst_amount = gstAmt
                  item.taxable_amount = newTotalAmount
                  item.sub_total_amount = newTotalAmount + discountShare
                  item.net_amount = newTotalWithGst
                  TotalPayableAmount += newTotalWithGst

                } else if (item.doctor_amt && item.hospital_amt) {
                  newDoctorShare = (newTotalAmount * item.doctor_percent) / 100;
                  newHospitalShare = (newTotalAmount * item.hospital_percent) / 100;

                  let totalShare = newDoctorShare + newHospitalShare;
                  let diff = newTotalAmount - totalShare;

                  if (Math.abs(diff) > 0.009) newHospitalShare += diff;

                  newDoctorShare = parseFloat(newDoctorShare);
                  newHospitalShare = parseFloat(newHospitalShare);

                  newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                  newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                  let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent ? (+item.gst_percent / 100) : 0))).toFixed(2));
                  let docAmt = (item.old_doctor_amt - newDoctorShare)?.toFixed(2)
                  let hosAmt = (item.old_hospital_amt - newHospitalShare)?.toFixed(2)

                  item.concession_amt = discountShare
                  item.new_doctor_amt = newDoctorShare
                  item.doctor_amt = newDoctorShare
                  item.new_hospital_amt = newHospitalShare
                  item.hospital_amt = newHospitalShare
                  item.doc_discount_amt = docAmt
                  item.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, item.old_doctor_amt)
                  item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, item.old_doctor_amt)
                  item.hos_discount_amt = hosAmt
                  item.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, item.old_hospital_amt)
                  item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, item.old_hospital_amt)
                  item.total_with_discount = newTotalAmount
                  item.service_with_gst_total_amt = newTotalWithGst
                  let gstAmt = newTotalWithGst - newTotalAmount
                  item.gst_amount = gstAmt
                  item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.igst_amount = gstAmt
                  item.taxable_amount = newTotalAmount
                  item.sub_total_amount = newTotalAmount + discountShare
                  item.net_amount = newTotalWithGst
                  TotalPayableAmount += newTotalWithGst
                } else {
                  let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent ? (+item.gst_percent / 100) : 0))).toFixed(2));
                  item.concession_amt = discountShare
                  item.total_with_discount = newTotalAmount
                  item.service_with_gst_total_amt = newTotalWithGst
                  let gstAmt = newTotalWithGst - newTotalAmount
                  item.gst_amount = gstAmt
                  item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                  item.igst_amount = gstAmt
                  item.taxable_amount = newTotalAmount
                  item.sub_total_amount = newTotalAmount + discountShare
                  item.net_amount = newTotalWithGst
                  TotalPayableAmount += newTotalWithGst
                }
              }
              if (discountShare) {
                item.is_overall_concession = true
              } else {
                item.is_overall_concession = false
              }
            }
            break;
          case 'Assorted Service Head':
            if (item?.package_line?.length) {
              for (const pack of item?.package_line) {
                if ((pack.concession_amt === '' || +pack.concession_amt === 0 || !pack.concession_amt || pack?.is_overall_concession) && !item?.is_advance_adjusted && (pack?.edit_discount || pack?.service_head_name === "Room Charges")) {
                  const isHospital = pack.is_hospital;
                  const maxDiscount = (pack.concession_amt === '' || +pack.concession_amt === 0 || !pack.concession_amt || pack?.is_overall_concession) ? (isHospital ? +pack.hospital_amt : +pack.total_amt) : 0;

                  let discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? ((maxDiscount / totalHospitalShare) * (+overallDiscount || 0)) : 0;
                  discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? Math.min(parseFloat(discountShare.toFixed(2)), maxDiscount) : 0;

                  let newTotalAmount = parseFloat((pack.sub_total_amount - discountShare).toFixed(2));

                  let newDoctorShare = 0, newHospitalShare = 0, newDoctorPercent = 0, newHospitalPercent = 0;

                  if (pack.edit_discount && (!pack.concession_amt || pack.is_overall_concession || +pack.concession_amt === 0)) {
                    if (isHospital) {
                      if (pack.doctor_amt) {
                        newDoctorShare = parseFloat(pack.doctor_amt);
                      } else {
                        newDoctorShare = 0;
                      }
                      newHospitalShare = parseFloat((pack.hospital_amt - discountShare));

                      newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                      newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                      let newTotalWithGst = parseFloat((newTotalAmount * (1 + (pack.gst_percent ? (+pack.gst_percent / 100) : 0))).toFixed(2));
                      let docAmt = (pack.old_doctor_amt - newDoctorShare)?.toFixed(2)
                      let hosAmt = (pack.old_hospital_amt - newHospitalShare)?.toFixed(2)

                      pack.concession_amt = discountShare
                      pack.new_doctor_amt = newDoctorShare
                      pack.doctor_amt = newDoctorShare
                      pack.new_hospital_amt = newHospitalShare
                      pack.hospital_amt = newHospitalShare
                      pack.doc_discount_amt = docAmt
                      pack.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, pack.old_doctor_amt)
                      pack.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, pack.old_doctor_amt)
                      pack.hos_discount_amt = hosAmt
                      pack.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, pack.old_hospital_amt)
                      pack.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, pack.old_hospital_amt)
                      pack.total_with_discount = newTotalAmount
                      pack.service_with_gst_total_amt = newTotalWithGst
                      let gstAmt = newTotalWithGst - newTotalAmount
                      pack.gst_amount = gstAmt
                      pack.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.igst_amount = gstAmt
                      pack.taxable_amount = newTotalAmount
                      pack.sub_total_amount = newTotalAmount + discountShare
                      pack.net_amount = newTotalWithGst
                      TotalPayableAmount += newTotalWithGst

                    } else if (pack.doctor_amt && pack.hospital_amt) {
                      newDoctorShare = (newTotalAmount * pack.doctor_percent) / 100;
                      newHospitalShare = (newTotalAmount * pack.hospital_percent) / 100;

                      let totalShare = newDoctorShare + newHospitalShare;
                      let diff = newTotalAmount - totalShare;

                      if (Math.abs(diff) > 0.009) newHospitalShare += diff;

                      newDoctorShare = parseFloat(newDoctorShare);
                      newHospitalShare = parseFloat(newHospitalShare);

                      newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                      newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                      let newTotalWithGst = parseFloat((newTotalAmount * (1 + (pack.gst_percent ? (+pack.gst_percent / 100) : 0))).toFixed(2));
                      let docAmt = (pack.old_doctor_amt - newDoctorShare)?.toFixed(2)
                      let hosAmt = (pack.old_hospital_amt - newHospitalShare)?.toFixed(2)

                      pack.concession_amt = discountShare
                      pack.new_doctor_amt = newDoctorShare
                      pack.doctor_amt = newDoctorShare
                      pack.new_hospital_amt = newHospitalShare
                      pack.hospital_amt = newHospitalShare
                      pack.doc_discount_amt = docAmt
                      pack.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, pack.old_doctor_amt)
                      pack.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, pack.old_doctor_amt)
                      pack.hos_discount_amt = hosAmt
                      pack.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, pack.old_hospital_amt)
                      pack.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, pack.old_hospital_amt)
                      pack.total_with_discount = newTotalAmount
                      pack.service_with_gst_total_amt = newTotalWithGst
                      let gstAmt = newTotalWithGst - newTotalAmount
                      pack.gst_amount = gstAmt
                      pack.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.igst_amount = gstAmt
                      pack.taxable_amount = newTotalAmount
                      pack.sub_total_amount = newTotalAmount + discountShare
                      pack.net_amount = newTotalWithGst
                      TotalPayableAmount += newTotalWithGst
                    } else {
                      let newTotalWithGst = parseFloat((newTotalAmount * (1 + (pack.gst_percent ? (+pack.gst_percent / 100) : 0))).toFixed(2));
                      pack.concession_amt = discountShare
                      pack.total_with_discount = newTotalAmount
                      pack.service_with_gst_total_amt = newTotalWithGst
                      let gstAmt = newTotalWithGst - newTotalAmount
                      pack.gst_amount = gstAmt
                      pack.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                      pack.igst_amount = gstAmt
                      pack.taxable_amount = newTotalAmount
                      pack.sub_total_amount = newTotalAmount + discountShare
                      pack.net_amount = newTotalWithGst
                      TotalPayableAmount += newTotalWithGst
                    }
                  }
                  if (discountShare) {
                    pack.is_overall_concession = true
                  } else {
                    pack.is_overall_concession = false
                  }
                }
              }
            }
            break;
          case 'Service Head':
          case 'Service Name':
            if (item?.package_line?.length) {
              for (const pack of item?.package_line) {
                if (pack?.service_data?.length) {
                  for (const service of pack?.service_data) {
                    if ((service.concession_amt === '' || +service.concession_amt === 0 || !service.concession_amt || service?.is_overall_concession) && !item?.is_advance_adjusted && (service?.edit_discount || service?.service_head_name === "Room Charges")) {
                      const isHospital = service.is_hospital;
                      const maxDiscount = (service.concession_amt === '' || +service.concession_amt === 0 || !service.concession_amt || service?.is_overall_concession) ? (isHospital ? +service.hospital_amt : +service.total_amt) : 0;

                      let discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? ((maxDiscount / totalHospitalShare) * (+overallDiscount || 0)) : 0;
                      discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? Math.min(parseFloat(discountShare.toFixed(2)), maxDiscount) : 0;

                      let newTotalAmount = parseFloat((service.sub_total_amount - discountShare).toFixed(2));

                      let newDoctorShare = 0, newHospitalShare = 0, newDoctorPercent = 0, newHospitalPercent = 0;

                      if (service.edit_discount && (!service.concession_amt || service.is_overall_concession || +service.concession_amt === 0)) {
                        if (isHospital) {
                          if (service.doctor_amt) {
                            newDoctorShare = parseFloat(service.doctor_amt);
                          } else {
                            newDoctorShare = 0;
                          }
                          newHospitalShare = parseFloat((service.hospital_amt - discountShare));

                          newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                          newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                          let newTotalWithGst = parseFloat((newTotalAmount * (1 + (service.gst_percent ? (+service.gst_percent / 100) : 0))).toFixed(2));
                          let docAmt = (service.old_doctor_amt - newDoctorShare)?.toFixed(2)
                          let hosAmt = (service.old_hospital_amt - newHospitalShare)?.toFixed(2)

                          service.concession_amt = discountShare
                          service.new_doctor_amt = newDoctorShare
                          service.doctor_amt = newDoctorShare
                          service.new_hospital_amt = newHospitalShare
                          service.hospital_amt = newHospitalShare
                          service.doc_discount_amt = docAmt
                          service.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, service.old_doctor_amt)
                          service.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, service.old_doctor_amt)
                          service.hos_discount_amt = hosAmt
                          service.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, service.old_hospital_amt)
                          service.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, service.old_hospital_amt)
                          service.total_with_discount = newTotalAmount
                          service.service_with_gst_total_amt = newTotalWithGst
                          let gstAmt = newTotalWithGst - newTotalAmount
                          service.gst_amount = gstAmt
                          service.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.igst_amount = gstAmt
                          service.taxable_amount = newTotalAmount
                          service.sub_total_amount = newTotalAmount + discountShare
                          service.net_amount = newTotalWithGst
                          TotalPayableAmount += newTotalWithGst

                        } else if (service.doctor_amt && service.hospital_amt) {
                          newDoctorShare = (newTotalAmount * service.doctor_percent) / 100;
                          newHospitalShare = (newTotalAmount * service.hospital_percent) / 100;

                          let totalShare = newDoctorShare + newHospitalShare;
                          let diff = newTotalAmount - totalShare;

                          if (Math.abs(diff) > 0.009) newHospitalShare += diff;

                          newDoctorShare = parseFloat(newDoctorShare);
                          newHospitalShare = parseFloat(newHospitalShare);

                          newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
                          newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
                          let newTotalWithGst = parseFloat((newTotalAmount * (1 + (service.gst_percent ? (+service.gst_percent / 100) : 0))).toFixed(2));
                          let docAmt = (service.old_doctor_amt - newDoctorShare)?.toFixed(2)
                          let hosAmt = (service.old_hospital_amt - newHospitalShare)?.toFixed(2)

                          service.concession_amt = discountShare
                          service.new_doctor_amt = newDoctorShare
                          service.doctor_amt = newDoctorShare
                          service.new_hospital_amt = newHospitalShare
                          service.hospital_amt = newHospitalShare
                          service.doc_discount_amt = docAmt
                          service.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, service.old_doctor_amt)
                          service.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, service.old_doctor_amt)
                          service.hos_discount_amt = hosAmt
                          service.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, service.old_hospital_amt)
                          service.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, service.old_hospital_amt)
                          service.total_with_discount = newTotalAmount
                          service.service_with_gst_total_amt = newTotalWithGst
                          let gstAmt = newTotalWithGst - newTotalAmount
                          service.gst_amount = gstAmt
                          service.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.igst_amount = gstAmt
                          service.taxable_amount = newTotalAmount
                          service.sub_total_amount = newTotalAmount + discountShare
                          service.net_amount = newTotalWithGst
                          TotalPayableAmount += newTotalWithGst
                        } else {
                          let newTotalWithGst = parseFloat((newTotalAmount * (1 + (service.gst_percent ? (+service.gst_percent / 100) : 0))).toFixed(2));
                          service.concession_amt = discountShare
                          service.total_with_discount = newTotalAmount
                          service.service_with_gst_total_amt = newTotalWithGst
                          let gstAmt = newTotalWithGst - newTotalAmount
                          service.gst_amount = gstAmt
                          service.sgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.cgst_amount = +(gstAmt / 2)?.toFixed(2)
                          service.igst_amount = gstAmt
                          service.taxable_amount = newTotalAmount
                          service.sub_total_amount = newTotalAmount + discountShare
                          service.net_amount = newTotalWithGst
                          TotalPayableAmount += newTotalWithGst
                        }
                      }
                      if (discountShare) {
                        service.is_overall_concession = true
                      } else {
                        service.is_overall_concession = false
                      }
                    }
                  }
                }
              }
            }
            break;
        }
      } else {
        if ((item.concession_amt === '' || +item.concession_amt === 0 || !item.concession_amt || item?.is_overall_concession) && (item?.edit_discount || item?.service_head_name === "Room Charges")) {
          const isHospital = item.is_hospital;
          const maxDiscount = (item.concession_amt === '' || +item.concession_amt === 0 || !item.concession_amt || item?.is_overall_concession) ? (isHospital ? +item.hospital_amt : +item.total_amt) : 0;

          let discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? ((maxDiscount / totalHospitalShare) * (+overallDiscount || 0)) : 0;
          discountShare = (maxDiscount && totalHospitalShare && overallDiscount) ? Math.min(parseFloat(discountShare.toFixed(2)), maxDiscount) : 0;

          let newTotalAmount = parseFloat((item.sub_total_amount - discountShare).toFixed(2));

          let newDoctorShare = 0, newHospitalShare = 0, newDoctorPercent = 0, newHospitalPercent = 0;

          if (item.edit_discount && !item?.is_advance_adjusted && (!item.concession_amt || item.is_overall_concession || +item.concession_amt === 0)) {
            if (isHospital) {
              if (item.doctor_amt) {
                newDoctorShare = parseFloat(item.doctor_amt);
              } else {
                newDoctorShare = 0;
              }
              newHospitalShare = parseFloat((item.hospital_amt - discountShare));

              newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
              newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
              let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent ? (+item.gst_percent / 100) : 0))).toFixed(2));
              let docAmt = (item.old_doctor_amt - newDoctorShare)?.toFixed(2)
              let hosAmt = (item.old_hospital_amt - newHospitalShare)?.toFixed(2)

              item.concession_amt = discountShare
              item.new_doctor_amt = newDoctorShare
              item.doctor_amt = newDoctorShare
              item.new_hospital_amt = newHospitalShare
              item.hospital_amt = newHospitalShare
              item.doc_discount_amt = docAmt
              item.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, item.old_doctor_amt)
              item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, item.old_doctor_amt)
              item.hos_discount_amt = hosAmt
              item.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, item.old_hospital_amt)
              item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, item.old_hospital_amt)
              item.total_with_discount = newTotalAmount
              item.service_with_gst_total_amt = newTotalWithGst
              let gstAmt = newTotalWithGst - newTotalAmount
              item.gst_amount = gstAmt
              item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.igst_amount = gstAmt
              item.taxable_amount = newTotalAmount
              item.sub_total_amount = newTotalAmount + discountShare
              item.net_amount = newTotalWithGst
              TotalPayableAmount += newTotalWithGst

            } else if (item.doctor_amt && item.hospital_amt) {
              newDoctorShare = (newTotalAmount * item.doctor_percent) / 100;
              newHospitalShare = (newTotalAmount * item.hospital_percent) / 100;

              let totalShare = newDoctorShare + newHospitalShare;
              let diff = newTotalAmount - totalShare;

              if (Math.abs(diff) > 0.009) newHospitalShare += diff;

              newDoctorShare = parseFloat(newDoctorShare);
              newHospitalShare = parseFloat(newHospitalShare);

              newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100));
              newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100));
              let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent ? (+item.gst_percent / 100) : 0))).toFixed(2));
              let docAmt = (item.old_doctor_amt - newDoctorShare)?.toFixed(2)
              let hosAmt = (item.old_hospital_amt - newHospitalShare)?.toFixed(2)

              item.concession_amt = discountShare
              item.new_doctor_amt = newDoctorShare
              item.doctor_amt = newDoctorShare
              item.new_hospital_amt = newHospitalShare
              item.hospital_amt = newHospitalShare
              item.doc_discount_amt = docAmt
              item.doc_discount_percent = CommonValidation.getDiscountPercentage(docAmt, item.old_doctor_amt)
              item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(docAmt, item.old_doctor_amt)
              item.hos_discount_amt = hosAmt
              item.doc_discount_percent = CommonValidation.getDiscountPercentage(hosAmt, item.old_hospital_amt)
              item.doc_discount_percent_w_r = CommonValidation.getDiscountPercentageWithRound(hosAmt, item.old_hospital_amt)
              item.total_with_discount = newTotalAmount
              item.service_with_gst_total_amt = newTotalWithGst
              let gstAmt = newTotalWithGst - newTotalAmount
              item.gst_amount = gstAmt
              item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.igst_amount = gstAmt
              item.taxable_amount = newTotalAmount
              item.sub_total_amount = newTotalAmount + discountShare
              item.net_amount = newTotalWithGst
              TotalPayableAmount += newTotalWithGst
            } else {
              let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent ? (+item.gst_percent / 100) : 0))).toFixed(2));
              item.concession_amt = discountShare
              item.total_with_discount = newTotalAmount
              item.service_with_gst_total_amt = newTotalWithGst
              let gstAmt = newTotalWithGst - newTotalAmount
              item.gst_amount = gstAmt
              item.sgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.cgst_amount = +(gstAmt / 2)?.toFixed(2)
              item.igst_amount = gstAmt
              item.taxable_amount = newTotalAmount
              item.sub_total_amount = newTotalAmount + discountShare
              item.net_amount = newTotalWithGst
              TotalPayableAmount += newTotalWithGst
            }
          }
          if (discountShare) {
            item.is_overall_concession = true
          } else {
            item.is_overall_concession = false
          }
        }
      }
      result[i] = item;
    }

    return { result: result, total_payable_amount: TotalPayableAmount };
  }

  const onChangeOverallDiscountHandler = (e, key) => {
    try {
      let value = e.target.value;

      setBilling((prev) => {
        let overAll = { ...prev.overall_data };

        switch (key) {
          case 'amount':
            if ((CommonValidation.DecimalNumber(value) && +value >= 1 && +value <= +billing.overall_data?.concession_applicable) || value === '') {
              overAll.overall_discount_amt = value;
              overAll.overall_discount_percent = value ? CommonValidation.getDiscountPercentage(value, billing.overall_data.concession_applicable) : '';
              overAll.overall_discount_percent_w_r = value ? CommonValidation.getDiscountPercentageWithRound(value, billing.overall_data.concession_applicable) : '';

              let afterDisAmt = (overAll.taxable_amount + overAll.gst_amount) - (+value);
              overAll.round_off = Math.round(afterDisAmt) - afterDisAmt;
              overAll.payable_amt = Math.round(afterDisAmt);

              let splitData = splitUp(overAll.overall_discount_amt)
              setBillingList(splitData?.result);
              return { ...prev, overall_data: overAll, final_amount: splitData?.total_payable_amount };
            } else {
              return { ...prev }
            }
          case 'percentage':
            if ((CommonValidation.DecimalNumber(value) && value >= 1 && value <= 100) || value === '') {
              overAll.overall_discount_percent = value;
              overAll.overall_discount_percent_w_r = value;

              let findDisAmt = CommonValidation.getDiscountAmountWithRound(value, billing.overall_data.concession_applicable);
              overAll.overall_discount_amt = value ? findDisAmt : '';

              let afterDisAmt = (overAll.taxable_amount + overAll.gst_amount) - findDisAmt;
              overAll.round_off = Math.round(afterDisAmt) - afterDisAmt;
              overAll.payable_amt = Math.round(afterDisAmt);

              let splitData = splitUp(overAll.overall_discount_amt)
              setBillingList(splitData?.result);
              return { ...prev, overall_data: overAll, final_amount: splitData?.total_payable_amount };
            } else {
              return { ...prev }
            }
        }
      });

    } catch (error) {
      errorMessage(error.message)
    }
  }


  const renderLftContent = () => {
    // let isHaveNewOrder = billingList?.some(pkg => !pkg?.ip_order_line_id);
    // const isHaveNewOrder = billingList?.some(pkg => {
    //   if (pkg?.package_type === 'Assorted' || pkg?.package_type === 'Package') {
    //     switch (pkg?.billing_display) {
    //       case 'Assorted Package':
    //       case 'Package':
    //         return pkg?.order_line_ids?.length === 0;

    //       case 'Assorted Service Head':
    //         return pkg?.package_line?.some(pack =>
    //           pack?.order_line_ids?.length === 0
    //         );
    //       case 'Service Head':
    //       case 'Service Name':
    //         return pkg?.package_line?.some(pack =>
    //           pack?.service_data?.some(ser =>
    //             ser?.order_line_ids?.length === 0
    //           )
    //         );
    //       default:
    //         return false;
    //     }
    //   } else {
    //     return pkg?.order_line_ids?.length === 0;
    //   }
    // });
    return (
      <Box component={'div'} sx={{ backgroundColor: 'white' }}>
        <Box component={'div'} mb={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0rem 0.5rem'}>
          {billing.applyFinalConcession ?
            <Box component={'div'} display={'flex'} gap={'0.5rem'} alignItems={'center'}>
              <FormControlLabel control={<Checkbox size='small' disabled={billing?.edit_orders || requestState?.fromCancel || (requestState?.fromApprover && requestState?.status !== "Modify") || !billing.overall_data.concession_applicable} checked={billing.selectedOverall} onChange={(e) => {
                if (e.target.checked) {
                  setBilling((prev) => ({ ...prev, overallConcessionAlert: true }))
                } else {
                  setBilling((prev) => {
                    if (!e.target.checked) {
                      let overAll = { ...prev.overall_data };
                      overAll.overall_discount_percent = "";
                      overAll.overall_discount_percent_w_r = "";

                      let findDisAmt = CommonValidation.getDiscountAmountWithRound("", billing.overall_data.concession_applicable);
                      overAll.overall_discount_amt = "";

                      let afterDisAmt = (overAll.taxable_amount + overAll.gst_amount) - findDisAmt;
                      overAll.round_off = Math.round(afterDisAmt) - afterDisAmt;
                      overAll.payable_amt = Math.round(afterDisAmt);
                      let splitData = splitUp("")
                      setBillingList(splitData?.result);
                      return { ...prev, overall_data: overAll, final_amount: splitData?.total_payable_amount, selectedOverall: e.target.checked };
                    } else {
                      return { ...prev, selectedOverall: e.target.checked }
                    }
                  });
                }
              }} />} label="Overall Concession" />
              <Box component={'div'} display={'flex'} gap={'0.5rem'} alignItems={'center'}>
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'con_amt', style: { height: '4dvh' } }}
                  sx={{ width: '6dvw' }}
                  disabled={(requestState?.fromApprover && requestState?.status !== "Modify") ? true : ((billing.selectedOverall && !billing?.edit_orders && billing.overall_data.concession_applicable)) ? false : true}
                  placeholder={CurrencySymbol}
                  value={billing?.overall_data?.overall_discount_amt}
                  onChange={(e) => { onChangeOverallDiscountHandler(e, 'amount') }}
                />
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'con_per', style: { height: '4dvh' } }}
                  sx={{ width: '6dvw' }}
                  disabled={(requestState?.fromApprover && requestState?.status !== "Modify") ? true : ((billing.selectedOverall && !billing?.edit_orders && billing.overall_data.concession_applicable)) ? false : true}
                  placeholder='%'
                  value={billing?.overall_data?.overall_discount_percent_w_r}
                  onChange={(e) => { onChangeOverallDiscountHandler(e, 'percentage') }}
                />
              </Box>
              {billing?.edit_orders ? null : <FormHelperText>{`Concession Applicable : ${billing.overall_data.concession_applicable}`}</FormHelperText>}
              <Autocomplete
                size='small'
                sx={{ width: '16dvw', pt: '0.2rem' }}
                options={billing.tempPackSugg}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name ? `${option.template_name}` : option?.package_name ? `${option?.package_name ?? ""}` : `${option?.assorted_package_name ?? ""}`}
                value={billing.selected_temp_pack}
                disabled={!billing.edit_orders}
                onChange={(e, newValue) => {
                  getTemplateData(newValue)
                }}
                renderInput={(params) => <TextField
                  {...params}
                  label='Search Package'
                  disabled={!billing.edit_orders}
                  InputProps={{
                    ...params.InputProps, emed_tid: 'ser_temp_pack'
                  }}
                />}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    {...props}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                      {`${option?.template_name || option?.package_name || option?.assorted_package_name || "-"}${(option?.assorted_package_amount || option?.assorted_package_amount === 0 || option?.package_amount || option?.package_amount === 0) ? ` - ${AmountFormat(option?.assorted_package_amount || option?.package_amount || 0)}` : ""}`}
                    </Typography>
                    <Typography
                      fontSize=".8vw"
                      fontWeight="bold"
                      sx={{ width: "100%", textAlign: "left" }}
                      color={option?.template_name ? "#29B6F6"
                        : option?.package_name ? "#1E972A"
                          : option?.assorted_package_name ? "blue"
                            : "inherit"}
                    >
                      {option?.template_name ? "Template"
                        : option?.package_name ? "Package"
                          : option?.assorted_package_name ? 'Assorted'
                            : ""}
                    </Typography>
                  </Box>
                )}
              />
            </Box>
            :
            <>{showPharmacy && billing?.pharmacy_bills?.length ? <Tooltip title={'Pharmacy bills cannot be completed in the Front Office. Please proceed in Pharmacy.'} placement='top'><IconButton size='small' sx={{ marginRight: "0.75vw" }}><img src={ImagePaths.warning_info.default} style={{ width: '1.2vw', height: '1.2vw' }} alt='info' /></IconButton></Tooltip> : null}
              {billing?.pharmacy_bills?.length ? <FormControlLabel control={<Checkbox size='small' disabled={showPharmacy} checked={billing?.include_pharmacy_bills} onChange={(e) => { setBilling((prev) => ({ ...prev, include_pharmacy_bills: e.target.checked })) }} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Include Pharmacy Bills </Typography>} /> : null}
              {billing?.ot_bills?.length ? <FormControlLabel control={<Checkbox size='small' checked={billing?.include_ot_bills} onChange={(e) => { setBilling((prev) => ({ ...prev, include_ot_bills: e.target.checked })) }} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Include OT Bills </Typography>} /> : null}
              {historyData?.is_final_bill_generated ?
                <Button className='eMed_usrconf_btn' variant='contained' sx={{ textTransform: 'capitalize' }} onClick={() => { getPatientBillDetailedPrint() }}>
                  <img src={ImagePaths.Print.default} alt="print" style={{ height: "1.2vw", width: "1.2vw", marginRight: "0.5vw" }} /> Print
                </Button>
                : null}
            </>}
        </Box>
        <Box component={'div'} height={'56dvh'} border={'1px solid lightgray'} overflow={'auto'}>
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className='billing_tbl_head' width={'18%'}>Service Description</TableCell>
                {/* <TableCell className='billing_tbl_head' width={'12%'}>Order No</TableCell> */}
                <TableCell className='billing_tbl_head' width={'11%'} align='center'>Units</TableCell>
                <TableCell className='billing_tbl_head' width={'10%'} align='right'>Rate/Unit</TableCell>
                <TableCell className='billing_tbl_head' width={'10%'} align='right'>Concession</TableCell>
                <TableCell className='billing_tbl_head' width={'10%'} align='right'>{`Amt (${CurrencySymbol})`}</TableCell>
                {loginInfo?.is_gst_enabled ?
                  <><TableCell className='billing_tbl_head' width={'10%'} align='right'>GST (%)</TableCell>
                    <TableCell className='billing_tbl_head' width={'11%'} align='right'>{`Net Amt(${CurrencySymbol})`}</TableCell></> : null}
                <TableCell className='billing_tbl_head' align='center' width={'11%'}>
                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Action</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {billingList?.length > 0 ? billingList?.map((item, index) => {
                let serviceName = `${item?.service_name && item?.service_code ? `${item?.service_name} (${item?.service_code})` : item?.service_name} - ${item?.service_head_name && item?.service_head_code ? `${item?.service_head_name} (${item?.service_head_code})` : item?.service_head_name}`
                if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
                  return (
                    <TableRow key={index}>
                      <TableCell className='billing_tbl_body'>
                        {item?.package_name ? item?.package_name?.length > 30 ?
                          <Tooltip placement='top' title={item?.package_name}>
                            <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD, fontWeight: '600' }}>{item?.package_name?.slice(0, 30) + '...'}</Typography>
                          </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD, fontWeight: '600' }}>{item?.package_name}</Typography> : '-'}
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0.3rem', pr: '0rem' }}>
                                {pack?.package_service_head ? pack?.package_service_head?.length > 30 ?
                                  <Tooltip placement='top' title={pack?.package_service_head}>
                                    <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{pack?.package_service_head?.slice(0, 30) + '...'}</Typography>
                                  </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{pack?.package_service_head}</Typography> : <Box visibility={'hidden'}>{'-'}</Box>}
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  let packServiceName = item?.billing_display === 'Service Head' ? `${service?.service_name && service?.service_code ? `${service?.service_name} (${service?.service_code})` : service?.service_name}` : `${service?.service_name && service?.service_code ? `${service?.service_name} (${service?.service_code})` : service?.service_name} - ${service?.service_head_name && service?.service_head_code ? `${service?.service_head_name} (${service?.service_head_code})` : service?.service_head_name}`
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', pl: '0.3rem', pr: '0rem' }}>
                                        {packServiceName ? packServiceName?.length > 27 ?
                                          <Tooltip placement='top' title={packServiceName}>
                                            <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{packServiceName?.slice(0, 27) + '...'}</Typography>
                                          </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{packServiceName}</Typography> : '-'}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell>
                      {/* <TableCell className='billing_tbl_body'>
                        <Box visibility={'hidden'}>{'-'}</Box>
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                <Box visibility={'hidden'}>{'-'}</Box>
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  let serviceOrderNumber = service?.order_item_number
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', paddingLeft: '0rem', paddingRight: '0rem' }}>
                                        {serviceOrderNumber ? serviceOrderNumber?.length > 25 ?
                                          <Tooltip placement='top' title={serviceOrderNumber}>
                                            <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceOrderNumber?.slice(0, 25) + '...'}</Typography>
                                          </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceOrderNumber}</Typography> : '-'}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell> */}
                      <TableCell className='billing_tbl_body' align='center'>
                        <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{item?.unit || 1}</Box>
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='center'>
                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{pack?.unit || 1}</Box>
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='center'>
                                        {service?.unit || 1}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell>
                      <TableCell className='billing_tbl_body' align='right'>
                        <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(item?.rate_per_unit || '')}</Box>
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='right'>
                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(pack?.rate_per_unit || '')}</Box>
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='right'>
                                        {CommonValidation.formatAmount(service?.rate_per_unit || '')}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell>
                      <TableCell className='billing_tbl_body' align='right'>
                        <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(item?.concession_amt || '')}</Box>
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='right'>
                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(pack?.concession_amt || '')}</Box>
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} width={'5%'} align='right'>
                                        {CommonValidation.formatAmount(service?.concession_amt || '')}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell>
                      <TableCell className='billing_tbl_body' align='right'>
                        {(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? <Box>{CommonValidation.formatAmount(item?.total_with_discount || '')}</Box> : <Box visibility={'hidden'}>{'-'}</Box>}
                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                          return (
                            <TableRow key={packIndex}>
                              <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} align='right' width={'5%'}>
                                {item?.billing_display === 'Assorted Service Head' ? <Box>{CommonValidation.formatAmount(pack?.total_with_discount || '')}</Box> : <Box visibility={'hidden'}>{'-'}</Box>}
                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                  return (
                                    <TableRow key={serviceIndex}>
                                      <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }} align='right' width={'5%'}>
                                        {CommonValidation.formatAmount(service?.total_with_discount || '')}
                                      </TableCell>
                                    </TableRow>
                                  )
                                }) : null}
                              </TableCell>
                            </TableRow>
                          )
                        }) : null}
                      </TableCell>
                      {loginInfo?.is_gst_enabled ?
                        <><TableCell className='billing_tbl_body'>
                          <Box visibility={'hidden'}>{'-'}</Box>
                          {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                            return (
                              <TableRow key={packIndex}>
                                <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                  <Box visibility={'hidden'}>{'-'}</Box>
                                  {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                    let serviceGst = CommonValidation.formatAmount(service?.gst_percent || 0)
                                    return (
                                      <TableRow key={serviceIndex}>
                                        <TableCell sx={{ borderBottom: 'none', paddingLeft: '0rem', paddingRight: '0rem' }}>
                                          {serviceGst ? serviceGst?.length > 25 ?
                                            <Tooltip placement='top' title={serviceGst}>
                                              <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceGst?.slice(0, 25) + '...'}</Typography>
                                            </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceGst}</Typography> : '-'}
                                        </TableCell>
                                      </TableRow>
                                    )
                                  }) : null}
                                </TableCell>
                              </TableRow>
                            )
                          }) : null}
                        </TableCell>
                          <TableCell className='billing_tbl_body'>
                            <Box visibility={'hidden'}>{'-'}</Box>
                            {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                              return (
                                <TableRow key={packIndex}>
                                  <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                    <Box visibility={'hidden'}>{'-'}</Box>
                                    {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                      let serviceGstAmt = CommonValidation.formatAmount(service?.service_with_gst_total_amt || '')
                                      return (
                                        <TableRow key={serviceIndex}>
                                          <TableCell sx={{ borderBottom: 'none', paddingLeft: '0rem', paddingRight: '0rem' }}>
                                            {serviceGstAmt ? serviceGstAmt?.length > 25 ?
                                              <Tooltip placement='top' title={serviceGstAmt}>
                                                <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceGstAmt?.slice(0, 25) + '...'}</Typography>
                                              </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceGstAmt}</Typography> : '-'}
                                          </TableCell>
                                        </TableRow>
                                      )
                                    }) : null}
                                  </TableCell>
                                </TableRow>
                              )
                            }) : null}
                          </TableCell></> : null}
                      {(billing.edit_orders && !billing?.overall_data?.overall_discount_percent_w_r) ?
                        <TableCell className='billing_tbl_body' align='center'>
                          {(item?.is_advance_adjusted ) ? <Typography sx={{ fontSize: "0.8vw", color: 'green', fontWeight: 600, padding: "0.4vw", visibility : (item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden' }}>Advance Adjusted</Typography> : <Box display={'flex'} justifyContent={'center'} visibility={((billing.edit_orders && !item?.is_advance_adjusted && !billing?.overall_data?.overall_discount_percent_w_r)) ? 'visible' : 'hidden'}>
                            <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: (item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden' }}
                              onClick={() => { onEditHandler(item, index, null, null) }}
                            ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                            {item?.is_created_order ? null :
                              <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }} disabled={billing?.applyFinalConcession ? false : true}
                                onClick={() => {
                                  setBillingList((prev) => {
                                    const updatedBillingList = [...prev];
                                    updatedBillingList.splice(index, 1);
                                    return updatedBillingList;
                                  });
                                }}
                              ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                          </Box>}
                          {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                            return (
                              <TableRow key={packIndex}>
                                <TableCell sx={{ borderBottom: 'none', p: '0.3rem 0rem' }} align='center' width={'10.5%'}>
                                  { pack?.is_advance_adjusted ? <Typography sx={{ fontSize: "0.8vw", color: 'green', fontWeight: 600, padding: "0.4vw" }}>Advance Adjusted</Typography> : item?.is_advance_adjusted ? <Box visibility={"hidden"}>{"Not editable"}</Box> : <Box display={'flex'} justifyContent={'center'} visibility={item?.package_type === 'Package' || item?.is_advance_adjusted || (billing.edit_orders && billing?.overall_data?.overall_discount_percent_w_r) ? 'hidden' : 'visible'}>
                                    <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: (item?.billing_display === 'Assorted Service Head') ? 'visible' : 'hidden' }}
                                      onClick={() => { onEditHandler(pack, index, packIndex, null) }}
                                    ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                    {item?.is_created_order ? null : <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: item?.package_line?.length === 1 ? 'hidden' : 'visible' }}
                                      disabled={billing?.applyFinalConcession ? false : true}
                                      onClick={() => {
                                        setBillingList((prev) => {
                                          const updatedBillingList = [...prev];
                                          updatedBillingList[index]['package_line']?.splice(packIndex, 1)
                                          return updatedBillingList;
                                        });
                                      }}
                                    ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                                  </Box>}
                                  {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                    return (
                                      <TableRow key={serviceIndex}>
                                        <TableCell sx={{ borderBottom: 'none', p: '0.3rem 0rem' }} align='center' width={'10.5%'}>
                                           { service?.is_advance_adjusted ? <Typography sx={{ fontSize: "0.8vw", color: 'green', fontWeight: 600, padding: "0.4vw" }}>Advance Adjusted</Typography> : item?.is_advance_adjusted ? <Box visibility={"hidden"}>{"Not editable"}</Box> : <Box display={'flex'} justifyContent={'center'} visibility={((billing.edit_orders && !item?.is_advance_adjusted && !billing?.overall_data?.overall_discount_percent_w_r)) ? 'visible' : 'hidden'}>
                                            <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }}
                                              onClick={() => onEditHandler(service, index, packIndex, serviceIndex)}
                                            ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                            {item?.is_created_order ? null : <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: pack?.service_data?.length === 1 ? 'hidden' : 'visible' }}
                                              disabled={billing?.applyFinalConcession ? false : true}
                                              onClick={() => {
                                                setBillingList((prev) => {
                                                  const updatedBillingList = [...prev];
                                                  updatedBillingList[index]['package_line'][packIndex]['service_data']?.splice(serviceIndex, 1)
                                                  return updatedBillingList;
                                                });
                                              }}
                                            ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                                          </Box>}
                                        </TableCell>
                                      </TableRow>
                                    )
                                  }) : null}
                                </TableCell>
                              </TableRow>
                            )
                          }) : null}
                        </TableCell> : item?.is_advance_adjusted ? <TableCell>
                          <Typography sx={{ fontSize: "0.8vw", color: 'green', fontWeight: 600, padding: "0.4vw" }}>Advance Adjusted</Typography>
                        </TableCell> : <TableCell />}
                    </TableRow>
                  )
                } else {
                  return (
                    <TableRow key={index}>
                      <TableCell className='billing_tbl_body'>
                        {serviceName?.length > 30 ?
                          <Tooltip placement='top' title={serviceName}>
                            <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName?.slice(0, 30) + '...'}</Typography>
                          </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName}</Typography>}
                      </TableCell>
                      {/* <TableCell className='billing_tbl_body'>{item?.order_item_number || '-'}</TableCell> */}
                      <TableCell className='billing_tbl_body' align='center'>{item?.unit || 1}</TableCell>
                      <TableCell className='billing_tbl_body' align='right'>{CommonValidation.formatAmount(item?.rate_per_unit || '')}</TableCell>
                      <TableCell className='billing_tbl_body' align='right'>{CommonValidation.formatAmount(item?.concession_amt || '')}</TableCell>
                      <TableCell className='billing_tbl_body' align='right'>{
                        item?.service_head_name === "Room Charges" && item?.gst_percent && RoomChargeGST?.is_room_charge_gst_applicable && item?.total_with_discount > +RoomChargeGST?.room_charge_gst_limit ?
                          <div>
                            <div style={{ fontSize: "0.9vw" }}>{CommonValidation.formatAmount(item?.service_with_gst_total_amt)}</div>
                            <div style={{ fontSize: "0.8vw" }}>{(`(Include ${item?.gst_percent}% gst)`)}</div>
                          </div> :
                          CommonValidation.formatAmount(item?.total_with_discount || '')
                      }</TableCell>
                      {loginInfo?.is_gst_enabled ?
                        <><TableCell className='billing_tbl_body' align='right'>{item?.gst_percent}</TableCell>
                          <TableCell className='billing_tbl_body' align='right'>{CommonValidation.formatAmount(item?.service_with_gst_total_amt || '')}</TableCell></> : null}
                      <TableCell align='center' className='billing_tbl_body'>
                        {item?.is_advance_adjusted ?
                          <Box>
                            <Typography sx={{ fontSize: "0.8vw", color: 'green', fontWeight: 600, padding: "0.4vw" }}>Adv Adjected</Typography>
                          </Box> :
                        <Box component={'div'} visibility={(billing.edit_orders && !billing?.overall_data?.overall_discount_percent_w_r) ? 'visible' : 'hidden'}>
                          <IconButton sx={{ width: '2dvw', height: '2dvw' }}
                            onClick={() => { onEditHandler(item, index) }}
                            disabled={billing?.applyFinalConcession ? false : true}
                          ><EditIcon
                              color={'primary'}
                              sx={{ width: '1.5dvw', height: '1.5dvw' }}
                            /></IconButton>
                          {/* {item?.ip_order_line_id ? null : */}
                          {item?.is_created_order ? null :
                            <IconButton sx={{ width: '2dvw', height: '2dvw' }}
                              disabled={billing?.applyFinalConcession ? false : true}
                              onClick={() => {
                                setBillingList((prev) => {
                                  const updatedBillingList = [...prev];
                                  updatedBillingList.splice(index, 1);
                                  return updatedBillingList;
                                });
                              }}
                            ><DeleteForeverIcon
                                color={'error'}
                                sx={{ width: '1.5dvw', height: '1.5dvw' }}
                              /></IconButton>}
                        </Box>}
                      </TableCell>
                    </TableRow>
                  )
                }
              }) : <TableRow>
                
              </TableRow>}
            </TableBody>
          </Table>
          <Box sx={{ visibility: (billing.pharmacy_bills?.length && !billing?.applyFinalConcession && billing?.include_pharmacy_bills) ? "visible" : "hidden" }}>
            <Divider textAlign='left'>
              <Typography component={'p'} sx={{ marginY: "0.5vw" }} className='eMed_Service_title'>Pharmacy Bills</Typography>
            </Divider>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className='billing_tbl_head'>Bill No</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Date</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Status</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Amount</TableCell>
                  <TableCell className='billing_tbl_head'>Paid Amount</TableCell>
                  <TableCell className='billing_tbl_head'>Outstanding Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {billing.pharmacy_bills?.map((item, index) => {
                  return (
                    <TableRow key={index} sx={{ height: "5dvh" }}>
                      <TableCell className='billing_tbl_body'>{item?.invoice_number || '-'}</TableCell>
                      <TableCell className='billing_tbl_body'>{item?.invoice_date ? formatDateAndTimeMeth2(item?.invoice_date) : "-"}</TableCell>
                      <TableCell className='billing_tbl_body'>{item?.payment_status || "-"}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.net_amount || 0)}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.received_amount || 0)}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.outstanding_amount || 0)}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ visibility: (billing.ot_bills?.length && !billing?.applyFinalConcession && billing?.include_ot_bills) ? "visible" : "hidden" }}>
            <Divider textAlign='left'>
              <Typography component={'p'} sx={{ marginY: "0.5vw" }} className='eMed_Service_title'>OT Bills</Typography>
            </Divider>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className='billing_tbl_head'>Bill No</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Date</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Status</TableCell>
                  <TableCell className='billing_tbl_head'>Bill Amount</TableCell>
                  <TableCell className='billing_tbl_head'>Paid Amount</TableCell>
                  <TableCell className='billing_tbl_head'>Outstanding Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {billing.ot_bills?.map((item, index) => {
                  return (
                    <TableRow key={index} sx={{ height: "5dvh" }}>
                      <TableCell className='billing_tbl_body'>{item?.invoice_number || '-'}</TableCell>
                      <TableCell className='billing_tbl_body'>{item?.invoice_date ? formatDateAndTimeMeth2(item?.invoice_date) : "-"}</TableCell>
                      <TableCell className='billing_tbl_body'>{item?.payment_status || "-"}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.net_amount || 0)}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.received_amount || 0)}</TableCell>
                      <TableCell className='billing_tbl_body'>{AmountFormat(item?.outstanding_amount || 0)}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Box>
        </Box>
        <Box visibility={((billing?.edit_orders || requestState.fromPendingList || (requestState.fromApprover && billing.isEdit)) && !billing?.overall_data?.overall_discount_percent_w_r) ? 'visible' : 'hidden'}
          component={'div'} mt={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} pb={'0.5rem'}>
          <Autocomplete
            size='small'
            sx={{ width: '12dvw' }}
            clearIcon={false}
            options={billing.billDocSugg}
            // disabled={billing?.service_data?.ip_order_line_id}
            disabled={billing?.service_data?.is_created_order || requestState.fromApprover}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
            value={billing.selected_bill_doc}
            onChange={(e, newValue) => {
              setBilling((prev) => {
                const updatedBilling = { ...prev, selected_bill_doc: newValue };
                return updatedBilling;
              });
            }}
            renderInput={(params) => <TextField
              {...params}
              label='Bill Doctor'
              disabled={billing?.service_data?.is_created_order}
              InputProps={{
                ...params.InputProps, emed_tid: 'Bl_doc',
              }}
            />}
          />
          <Autocomplete
            size='small'
            options={billing?.wardList || []}
            getOptionLabel={(option) => option?.ward_name || ''}
            sx={{ width: '12dvw' }}
            // disabled={billing?.service_data?.ip_order_line_id}
            disabled={requestState.fromApprover || billing?.service_data?.is_created_order}
            value={billing?.selectedWard}
            onChange={(event, newValue) => {
              setBilling((prev) => ({
                ...prev,
                selectedWard: newValue,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={billing?.service_data?.ip_order_line_id}
                disabled={requestState.fromApprover || billing?.service_data?.is_created_order}
                label='Select Ward'
              />
            )}
          />
          <Autocomplete
            size='small'
            sx={{ width: '14dvw' }}
            options={billing.serviceSugg}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : `${(option?.service_head ?? option?.service_head_name) && option?.service_head_code ? `${option?.service_head ?? option?.service_head_name} (${option?.service_head_code})` : option?.service_head ?? option?.service_head_name} - ${option?.service_name && option?.service_code ? `${option?.service_name} (${option?.service_code})` : option?.service_name}`}
            value={billing.selected_service}
            // disabled={billing?.service_data?.ip_order_line_id}
            disabled={requestState.fromApprover || billing?.service_data?.is_created_order}
            onChange={(e, newValue) => {
              if (newValue) {
                onSelectServiceHandler(newValue)
              } else {
                onClearServiceData()
              }
              setsearchKey('');
            }}
            renderInput={(params) => <TextField
              {...params}
              label='Search Service'
              // disabled={billing?.service_data?.ip_order_line_id}
              disabled={billing?.service_data?.order_line_ids ? (billing?.service_data?.order_line_ids?.length === 0 ? false : true) : false}
              InputProps={{
                ...params.InputProps, emed_tid: 'ser_sear',
              }}
            />}
            onInputChange={(event, newInputValue) => {
              if (newInputValue?.length >= 3) {
                // Call your API here with the search key
                setsearchKey(newInputValue);
              }
            }}
            componentsProps={{ popper: { style: { width: '30dvw' } } }}
            renderOption={(props, item) => {
              let serviceName = `${item?.service_head && item?.service_head_code ? `${item?.service_head} (${item?.service_head_code})` : item?.service_head} `
              let serName = `${item?.service_name && item?.service_code ? `${item?.service_name} (${item?.service_code})` : item?.service_name}`
              const displayName = `${serviceName} ${serName}`
              let depart = item?.module_type === "IP_OP" ? 'IP & OP' : item?.module_type;
              return (
                <Box {...props} key={item?.id} >
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                    <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
                      {/* display Name */}
                      <Tooltip title={displayName} arrow>
                        <Typography>
                          {displayName.length > 58 ? serviceName.length > 58 ?
                            (<span
                              style={{
                                fontSize: "0.9vw",
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                              }}
                            >{`${serviceName.slice(0, 55)}...`}</span>) :
                            (<><span
                              style={{
                                fontSize: "0.9vw",
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                              }}
                            >{serviceName}</span>
                              <span
                                style={{
                                  fontSize: "0.9vw",
                                  whiteSpace: 'nowrap',
                                }}
                              >{`- ${serName.slice(0, (55 - (serviceName.length)))}...`}</span></>) :
                            (<><span
                              style={{
                                fontSize: "0.9vw",
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                              }}
                            >{serviceName}</span> -
                              <span
                                style={{
                                  fontSize: "0.9vw",
                                  whiteSpace: 'nowrap',
                                }}
                              >{serName}</span></>)
                          }
                        </Typography>
                      </Tooltip>
                    </Box>


                    {/* Department */}
                    <Tooltip title={depart} arrow>
                      <Typography
                        sx={{
                          fontSize: "0.9vw",
                          fontWeight: 600,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {depart}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Box>
              )
            }}
          />

          {billing?.service_data?.unit_type === 'Hrs' ?
            <Box component={'div'}
              border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
              display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
              <Button
                disabled={!billing?.service_data?.edit_unit || (requestState.fromApprover) || InvestigationList?.includes(billing?.selected_service?.module_type)}
                sx={{ textTransform: 'capitalize' }}
                endIcon={<AccessTimeIcon />}
                onClick={() => onOpenPopupHandler('time')}
              >{`${billing?.service_data?.unit?.length > 5 ? billing?.service_data.unit?.slice(0, 5) : billing?.service_data?.unit}`}</Button>
            </Box> :
            <Box component={'div'}
              border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
              display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
              <IconButton
                sx={{ height: '4.5dvh', width: '2dvw' }}
                disabled={+billing?.service_data?.unit === 1 || !billing?.service_data?.edit_unit || (requestState.fromApprover && billing.isEdit) || billing?.selected_service?.drug_ms_id ||  billing?.selected_service?.drug_config_id || InvestigationList?.includes(billing?.selected_service?.module_type)}
                onClick={() => onClickUnitHandler('decrease')}
              ><RemoveIcon color={(+billing?.service_data?.unit === 1 || !billing?.service_data?.edit_unit || (requestState.fromApprover && billing.isEdit) || billing?.selected_service?.drug_ms_id ||  billing?.selected_service?.drug_config_id || InvestigationList?.includes(billing?.selected_service?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
              <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>{billing?.service_data?.unit}</Typography>
              <IconButton
                disabled={!billing?.service_data?.edit_unit || (requestState.fromApprover) || billing?.selected_service?.drug_ms_id || billing?.selected_service?.drug_config_id}
                sx={{ height: '4.5dvh', width: '2dvw' }}
                onClick={() => onClickUnitHandler('increase')}
              ><AddIcon color={(!billing?.service_data?.edit_unit || (requestState.fromApprover) || billing?.selected_service?.drug_ms_id || billing?.selected_service?.drug_config_id) ? 'disabled' : 'primary'} /></IconButton>
            </Box>}

          {!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt ?
            <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
              disabled={!billing?.service_data?.edit_amount || (requestState.fromApprover)}
              endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.rate_per_unit)})`}
              onClick={() => onOpenPopupHandler('rate')}
            >Rate/Unit</Button> :
            <TextField
              disabled={(requestState.fromApprover)}
              autoComplete='off'
              size='small'
              InputProps={{ emed_tid: 'rte_unit', readOnly: !billing?.service_data?.edit_amount }}
              sx={{ width: '7dvw' }}
              label='Rate/Unit'
              value={billing?.service_data?.rate_per_unit}
              onChange={(e) => { withOutShareHandler(e, 'rate_per_unit') }}
            />}

          <Box component={'div'} display={'flex'}>
            {!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt ?
              <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                // disabled={!billing?.service_data?.edit_discount || (!billing?.service_data?.ip_order_line_id && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                disabled={!billing?.service_data?.edit_discount || (billing?.service_data?.order_line_ids?.length === 0 && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.concession_amt)})`}
                onClick={() => onOpenPopupHandler('concession')}
              >Concession</Button>
              :
              <><TextField
                // disabled={!billing?.service_data?.edit_discount || (!billing?.service_data?.ip_order_line_id && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                disabled={!billing?.service_data?.edit_discount || billing?.service_data?.membership_discount_percentage || (billing?.service_data?.order_line_ids?.length === 0 && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                autoComplete='off'
                size='small'
                InputProps={{ emed_tid: 'con_amt' }}
                sx={{ width: '7dvw' }}
                label={`Concession (${CurrencySymbol})`}
                value={billing?.service_data?.concession_amt ? billing?.service_data?.concession_amt : ""}
                onChange={(e) => { withOutShareHandler(e, 'concession_discount_amt') }}
              />
                <TextField
                  // disabled={!billing?.service_data?.edit_discount || (!billing?.service_data?.ip_order_line_id && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                  disabled={!billing?.service_data?.edit_discount || (billing?.service_data?.order_line_ids?.length === 0 && (billing?.service_data?.module_type === "LAB" || billing?.service_data?.module_type === "RADIOLOGY"))}
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'con_per' }}
                  sx={{ width: '7dvw' }}
                  label={`Concession (%)`}
                  value={billing?.service_data?.concession_percent_w_r ? billing?.service_data?.concession_percent_w_r : ""}
                  onChange={(e) => { withOutShareHandler(e, 'concession_discount_percent') }}
                /></>}
          </Box>

          <Box component={'div'}>
            <TextField
              size='small'
              sx={{ width: '7dvw' }}
              value={billing?.service_data?.total_amt ? CommonValidation.formatAmount(+billing?.service_data?.total_amt - +billing?.service_data?.concession_amt) : ''}
              InputProps={{ emed_tid: 'tlt', readOnly: true }}
              label='Total'
            />
          </Box>

          <IconButton
            disabled={billing?.selected_service === null ? true : false}
            sx={{ height: '2dvw', width: '2.5dvw' }}
            onClick={() => {
              if (billing?.selected_service?.autobilling_type === "yearly") {
                setAnnualFeeAlert(true)
              } else {
                onAddHandler()
              }
            }}
          ><AddBoxIcon sx={{ height: '2dvw', width: '2.5dvw' }} color={billing?.selected_service === null ? 'disabled' : 'primary'} /></IconButton>
        </Box>
      </Box>
    )
  }

  const cashTextBox = (key, values, label, Icon) => {
    return (
      <TextField
        size='small'
        sx={{ width: '10dvw', mt: '0.5rem' }}
        value={values}
        label={`${label} (${CurrencySymbol})`}
        onChange={(e) => onChangeHandler(e, key)}
        InputProps={{
          emed_tid: `ip_settle_${key}`,
          startAdornment: (
            <InputAdornment position="start">
              <img src={Icon} alt={label} className='eMed_action_img_small' />
            </InputAdornment>
          ),
        }}
      />
    )
  }

  const referenceTextBox = (key, values) => {
    return (
      <TextField
        size='small'
        sx={{ width: '13dvw', mt: '0.5rem', ml: '0.5rem' }}
        value={values}
        label={'Reference Number'}
        inputProps={{ maxLength: 30 }}
        onChange={(e) => onChangeHandler(e, key)}
        InputProps={{ emed_tid: key }}
      />
    )
  }

  const handleCheckBox = (e, key) => {
    try {
      let checked = e.target.checked;
      setBilling((prev) => {
        const updatedBilling = { ...prev, [key]: checked };

        let selectedCount = [updatedBilling?.isCash, updatedBilling?.isCard, updatedBilling?.isUPI, updatedBilling?.isBank, updatedBilling?.isCheque].filter(Boolean).length;

        if (selectedCount > 1) {
          updatedBilling.cash_amt = ''
          updatedBilling.card_amt = ''
          updatedBilling.upi_amt = ''
          updatedBilling.bank_amt = ''
          updatedBilling.cheque_amt = ''
        } else {
          if (updatedBilling?.isCash) {
            updatedBilling.cash_amt = updatedBilling.cash_amt || updatedBilling.final_amount - updatedBilling.advance_deducted;
          } else if (updatedBilling?.isCard) {
            updatedBilling.card_amt = updatedBilling.card_amt || updatedBilling.final_amount - updatedBilling.advance_deducted;
          } else if (updatedBilling?.isUPI) {
            updatedBilling.upi_amt = updatedBilling.upi_amt || updatedBilling.final_amount - updatedBilling.advance_deducted;
          } else if (updatedBilling?.isBank) {
            updatedBilling.bank_amt = updatedBilling.bank_amt || updatedBilling.final_amount - updatedBilling.advance_deducted;
          } else if (updatedBilling?.isCheque) {
            updatedBilling.cheque_amt = updatedBilling.cheque_amt || updatedBilling.final_amount - updatedBilling.advance_deducted;
          }
        }

        return updatedBilling;
      });
    } catch (error) {
      errorMessage(error.message);
    }
  };

  let balanceFromAdvDeduction = Number(billing?.final_amount || 0) - Number(billing?.advance_deducted || 0);
  let remainingCash = (
    Number(billing?.cash_amt || 0) +
    Number(billing?.card_amt || 0) +
    Number(billing?.upi_amt || 0) +
    Number(billing?.bank_amt || 0) +
    Number(billing?.cheque_amt || 0)
  );
  const [patientCreditAmount, setPatientCreditAmount] = useState(0)

  useEffect(() => {
    setBilling((prev) => ({
      ...prev,
      cash_amt: prev.isCash ? prev.final_amount - prev.advance_deducted : prev.cash_amt,
      card_amt: prev.isCard ? prev.final_amount - prev.advance_deducted : prev.card_amt,
      upi_amt: prev.isUPI ? prev.final_amount - prev.advance_deducted : prev.upi_amt,
      bank_amt: prev.isBank ? prev.final_amount - prev.advance_deducted : prev.bank_amt,
      cheque_amt: prev.isCheque ? prev.final_amount - prev.advance_deducted : prev.cheque_amt,
    }));
    setPatientCreditAmount(balanceFromAdvDeduction - remainingCash)
  }, [billing.advance_deducted, balanceFromAdvDeduction]); // Runs whenever advance deduction changes

  useEffect(() => {
    let newRemainingCash = (
      Number(billing?.cash_amt || 0) +
      Number(billing?.card_amt || 0) +
      Number(billing?.upi_amt || 0) +
      Number(billing?.bank_amt || 0) +
      Number(billing?.cheque_amt || 0)
    );

    let updatedCreditAmount = balanceFromAdvDeduction - newRemainingCash;

    setPatientCreditAmount(updatedCreditAmount);
  }, [billing.cash_amt, billing.card_amt, billing.upi_amt, billing.bank_amt, billing.cheque_amt]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setPatientCreditAmount(0);
  //   }, 0);
  // }, [billing.isCash, billing.isCard, billing.isUPI, billing.isBank, billing.isCheque]);

  const showCashTextBox = () => {
    return (
      <Box component={'div'}>
        <Divider textAlign='left'>
          <Typography component={'p'} className='eMed_Service_title'>Cash Receipt</Typography>
        </Divider>
        <Box component={'div'}>
          <FormControlLabel control={<Checkbox size='small' checked={billing?.isCash} onChange={(e) => handleCheckBox(e, 'isCash')} disabled={billing?.final_amount - billing?.advance_deducted !== 0 ? false : true} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L} >Cash</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={billing?.isCard} onChange={(e) => handleCheckBox(e, 'isCard')} disabled={billing?.final_amount - billing?.advance_deducted !== 0 ? false : true} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L} >Card</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={billing?.isUPI} onChange={(e) => handleCheckBox(e, 'isUPI')} disabled={billing?.final_amount - billing?.advance_deducted !== 0 ? false : true} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L} >UPI</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={billing?.isBank} onChange={(e) => handleCheckBox(e, 'isBank')} disabled={billing?.final_amount - billing?.advance_deducted !== 0 ? false : true} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L} >Bank</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={billing?.isCheque} onChange={(e) => handleCheckBox(e, 'isCheque')} disabled={billing?.final_amount - billing?.advance_deducted !== 0 ? false : true} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L} >Cheque</Typography>} />
        </Box>
        <Box component={'div'}>
          {billing?.isCash ? cashTextBox('cash_amt', billing?.cash_amt, 'Cash Amount', ImagePaths.CashIcon.default) : null}
          {billing?.isCard ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('card_amt', billing?.card_amt, 'Card Amount', ImagePaths.CardIcon.default)}
              {referenceTextBox('card_no', billing?.card_no)}
            </Box> : null}
          {billing?.isUPI ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('upi_amt', billing?.upi_amt, 'UPI Amount', ImagePaths.UPIIcon.default)}
              {referenceTextBox('upi_no', billing?.upi_no)}
            </Box> : null}
          {billing?.isBank ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('bank_amt', billing?.bank_amt, 'Bank Amount', ImagePaths.BankTransferIcon.default)}
              {referenceTextBox('bank_no', billing?.bank_no)}
            </Box> : null}
          {billing?.isCheque ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('cheque_amt', billing?.cheque_amt, 'Cheque Amount', ImagePaths.ChequeIcon.default)}
              {referenceTextBox('cheque_no', billing?.cheque_no)}
            </Box> : null}
        </Box>
      </Box>
    )
  }

  const showOutstandingTextBox = () => {
    return (
      <Box component={'div'}>
        <Box component={'div'}>
          <Divider textAlign='left'>
            <Typography component={'p'} className='eMed_Service_title'>Outstanding</Typography>
          </Divider>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1vw" }}>
            <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Patient credit amount:</Typography>
            <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={600}>
              {AmountFormat(patientCreditAmount)}
            </Typography>
          </div>
          <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <RadioGroup
              value={billing?.credit_type}
              sx={{ display: 'flex', flexDirection: 'row' }}
              onClick={(e) => {
                setBilling((prev) => {
                  return {
                    ...prev,
                    credit_type: e.target.value === prev?.credit_type ? "" : e.target.value,
                    selected_corporate_amt: "",
                    selected_insurance_amt: "",
                    co_payment_amount: "",
                    selected_patient_amt: "",
                  }
                })
              }}
            >
              {(JSON.parse(localGetItem('allow_patient_credit_bills')) || !historyData?.is_final_bill_generated) ? <FormControlLabel value={'patient'} control={<Radio size='small' />} label="Patient Credit" /> : null}
              <FormControlLabel value={"insurance"} control={<Radio size='small' />} label="Insurance Credit" />
              <FormControlLabel value={"corporate"} control={<Radio size='small' />} label="Corporate Credit" />
            </RadioGroup>
          </FormControl></Box>
        <Box component={'div'}>
          {
            billing?.credit_type === "insurance" ?
              <>
                <Autocomplete
                  size='small'
                  sx={{ width: '16dvw', pt: '0.2rem' }}
                  options={InsuranceList}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : (option?.insurance_name)}
                  value={billing.selected_insuance_company}
                  onChange={(e, newValue) => {
                    setBilling((prev) => {
                      return {
                        ...prev,
                        selected_insuance_company: newValue,
                        selected_insurance_amt: newValue ? prev?.selected_insurance_amt : "",
                        insurance_id: newValue?.insurance_id || "",
                      }
                    })
                  }}
                  renderInput={(params) => <TextField
                    {...params}
                    label='Insurance Company Name *'
                    InputProps={{
                      ...params.InputProps, emed_tid: 'ser_temp_pack'
                    }}
                  />}
                />
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'rte_unit' }}
                  sx={{ width: '16dvw', pt: '0.2rem', mt: '0.5vw' }}
                  label='Policy Number *'
                  inputProps={{ maxLength: 30 }}
                  value={billing?.selected_policy_number}
                  onChange={(e) => {
                    setBilling((prev) => {
                      return {
                        ...prev,
                        selected_policy_number: e.target.value,
                        selected_insurance_amt: e.target.value ? prev?.selected_insurance_amt : ""
                      }
                    })
                  }} />
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'rte_unit' }}
                  sx={{ width: '16dvw', pt: '0.2rem', mt: '0.5vw' }}
                  label='Credit Amount'
                  value={billing?.selected_insurance_amt}
                  disabled={!billing.selected_insuance_company || !billing?.selected_policy_number}
                  onChange={(e) => {
                    let value = e.target.value
                    if ((CommonValidation.numberOnly(value) && +value >= 1 && +value <= billing?.final_amount) || value === '') {
                      setBilling((prev) => {
                        return { ...prev, selected_insurance_amt: e.target.value }
                      })
                    }
                  }} />
              </> :
              billing?.credit_type === "corporate" ? <>
                <Autocomplete
                  size='small'
                  sx={{ width: '16dvw', pt: '0.2rem' }}
                  options={CorporateList}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : (option?.company_name)}
                  value={billing.selected_corporate_company}
                  onChange={(e, newValue) => {
                    setBilling((prev) => {
                      return {
                        ...prev,
                        selected_corporate_company: newValue,
                        selected_corporate_amt: newValue ? prev?.selected_corporate_amt : ""
                      }
                    })
                  }}
                  renderInput={(params) => <TextField
                    {...params}
                    label='Corporate Name *'
                    InputProps={{
                      ...params.InputProps, emed_tid: 'ser_temp_pack'
                    }}
                  />}
                />
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'rte_unit' }}
                  sx={{ width: '16dvw', pt: '0.2rem', mt: '0.5vw' }}
                  label='Employee ID *'
                  inputProps={{ maxLength: 30 }}
                  value={billing?.selected_employee_number}
                  onChange={(e) => {
                    setBilling((prev) => {
                      return {
                        ...prev,
                        selected_employee_number: e.target.value,
                        selected_corporate_amt: e.target.value ? prev?.selected_corporate_amt : ""
                      }
                    })
                  }} />
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'rte_unit' }}
                  sx={{ width: '16dvw', pt: '0.2rem', mt: '0.5vw' }}
                  label='Credit Amount'
                  value={billing?.selected_corporate_amt}
                  disabled={!billing.selected_corporate_company || !billing?.selected_employee_number}
                  onChange={(e) => {
                    let value = e.target.value
                    if ((CommonValidation.numberOnly(value) && +value >= 1 && +value <= billing?.final_amount) || value === '') {
                      setBilling((prev) => {
                        return { ...prev, selected_corporate_amt: e.target.value }
                      })
                    }
                  }} />
              </> : (billing?.credit_type === "patient" &&  (JSON.parse(localGetItem('allow_patient_credit_bills')) ||  !historyData?.is_final_bill_generated)) ? <>
                <TextField
                  autoComplete='off'
                  size='small'
                  InputProps={{ emed_tid: 'rte_unit' }}
                  sx={{ width: '16dvw', pt: '0.2rem' }}
                  label='Credit Amount'
                  value={billing?.selected_patient_amt}
                  onChange={(e) => {
                    let value = e.target.value
                    if ((CommonValidation.numberOnly(value) && +value >= 1 && +value <= billing?.final_amount) || value === '') {
                      setBilling((prev) => {
                        return { ...prev, selected_patient_amt: e.target.value }
                      })
                    }
                  }} />
              </> : null
          }
          
          {localGetItem('set_due_date_for_credit_billing') === 'true' ?
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={billing.creditDueOpen}
                  onOpen={() => { setBilling((prev) => ({ ...prev, creditDueOpen: true })) }}
                  onClose={() => { setBilling((prev) => ({ ...prev, creditDueOpen: false })) }}
                  value={billing?.credit_due_date}
                  name={"datePicker"}
                  label={'Credit Follow Up Date *'}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  minDate={new Date()}
                  onChange={
                    (newDate) => {
                      setBilling((prev) => ({
                        ...prev,
                        credit_due_date: newDate
                      }))
                    }}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => e.preventDefault()}
                    style={{ width: '16dvw', marginTop: '0.5vw' }}
                    size='small' {...params}
                    onClick={() => { setBilling((prev) => ({ ...prev, creditDueOpen: true })) }} />}
                />
              </LocalizationProvider>
              <IconButton size='small' onClick={() => {
                setBilling((prev) => ({ ...prev, credit_due_date: null }))
              }} >
                <CloseIcon color='primary' />
              </IconButton>
            </Box> : null}
        </Box>
      </Box>
    )
  }

  const returnOtherAmt = () => {
    let TotalAmount = (+billing?.cash_amt || 0) + (+billing?.card_amt || 0) + (+billing?.bank_amt || 0) + (+billing?.upi_amt || 0) + (+billing?.cheque_amt || 0) + (+billing?.advance_deducted || 0)
    return (TotalAmount - (+billing?.co_payment_amount || 0))
  }

  const showCoPaymentFeilds = () => {
    return (
      <Box component={'div'}>
        <Box component={'div'}>
          <Divider textAlign='left'>
            <Typography component={'p'} className='eMed_Service_title'>Co - Payment</Typography>
          </Divider>
        </Box>
        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <TextField
            autoComplete='off'
            size='small'
            InputProps={{ emed_tid: 'rte_unit' }}
            sx={{ width: '11.5dvw', pt: '0.2rem', mt: '0.5vw' }}
            label='Co-Payment Amount'
            inputProps={{ maxLength: 30 }}
            value={billing?.co_payment_amount}
            onChange={(e) => {
              let TotalAmount = (+billing?.cash_amt || 0) + (+billing?.card_amt || 0) + (+billing?.bank_amt || 0) + (+billing?.upi_amt || 0) + (+billing?.cheque_amt || 0) + (+billing?.advance_deducted || 0)
              if ((CommonValidation.numberOnly(e.target.value) && +e.target.value <= TotalAmount) || e.target.value === '') {
                setBilling((prev) => {
                  return { ...prev, co_payment_amount: e.target.value }
                })
              }
            }} />
          <TextField
            autoComplete='off'
            size='small'
            InputProps={{ emed_tid: 'rte_unit' }}
            sx={{ width: '11.5dvw', pt: '0.2rem', mt: '0.5vw' }}
            label='Insured Amount'
            value={returnOtherAmt()}
            disabled={true}
          />
        </Box>
      </Box>
    )
  }

  const concessionRiseRequest = () => {
    if (requestState?.selectedApproverId !== null) {
      setBilling((prev) => {
        setRequestState((prevstate) => ({ ...prevstate, status: "Requested" }))
        return { ...prev, postBillClicked: true }
      })
    }
    else {
      errorMessage("Kindly Select the approver")
    }
  }

  const billingCalculation = useCallback((list = billingList) => {
    try {
      let subTPA = 0; let subTASH = 0; let subTSH = 0; let subTSN = 0;
      const calData = list?.reduce((acc, element) => {
        if (element.package_type === 'Package' || element.package_type === "Assorted") {
          if (element.billing_display === 'Assorted Package Name' || element.billing_display === 'Package Name') {
            acc.sub_total += +element.sub_total_amount;
            acc.taxable_amount += element.taxable_amount;
            acc.gst_amount += element.gst_amount;
            acc.sgst_amount += element.sgst_amount;
            acc.cgst_amount += element.cgst_amount;
            acc.net_amount += element.net_amount;
            if ((element.concession_amt === '' || +element.concession_amt === 0 || element?.is_overall_concession) && !element?.is_advance_adjusted && (element?.edit_discount || element?.service_head_name === "Room Charges")) {
              acc.concession_applicable += +element.concession_applicable;
            }
            acc.payable_amt += ((+element.taxable_amount) + (+element.gst_amount));
          } else if (element.billing_display === 'Assorted Service Head') {
            element?.package_line?.forEach(pack => {
              acc.sub_total += pack.sub_total_amount;
              acc.taxable_amount += pack.taxable_amount;
              acc.gst_amount += pack.gst_amount;
              acc.sgst_amount += pack.sgst_amount;
              acc.cgst_amount += pack.cgst_amount;
              acc.net_amount += pack.net_amount;
              if ((pack.concession_amt === '' || +pack.concession_amt === 0 || pack?.is_overall_concession) && !element?.is_advance_adjusted && (pack?.edit_discount || pack?.service_head_name === "Room Charges")) {
                acc.concession_applicable += +pack.concession_applicable;
              }
              acc.payable_amt += ((+pack.taxable_amount) + (+pack.gst_amount));
            })
          } else if (element.billing_display === 'Service Head' || element.billing_display === 'Service Name') {
            element?.package_line?.forEach(pack => {
              pack?.service_data?.forEach(service => {
                acc.sub_total += service.sub_total_amount;
                acc.taxable_amount += service.taxable_amount;
                acc.gst_amount += service.gst_amount;
                acc.sgst_amount += service.sgst_amount;
                acc.cgst_amount += service.cgst_amount;
                acc.net_amount += service.net_amount;
                if ((service.concession_amt === '' || +service.concession_amt === 0 || service?.is_overall_concession) && !element?.is_advance_adjusted && (service?.edit_discount || service?.service_head_name === "Room Charges")) {
                  acc.concession_applicable += +service.concession_applicable;
                }
                acc.payable_amt += ((+service.taxable_amount) + (+service.gst_amount));
              })
            })
          }
        } else {
          acc.sub_total += +element.sub_total_amount;
          acc.taxable_amount += element.taxable_amount;
          acc.gst_amount += element.gst_amount;
          acc.sgst_amount += element.sgst_amount;
          acc.cgst_amount += element.cgst_amount;
          acc.net_amount += element.net_amount;
          if ((element.concession_amt === '' || +element.concession_amt === 0 || element?.is_overall_concession) && !element?.is_advance_adjusted && (element?.edit_discount || element?.service_head_name === "Room Charges")) {
            acc.concession_applicable += +element.concession_applicable;
          }
          acc.payable_amt += ((+element.taxable_amount) + (+element.gst_amount));
        }
        return acc;
      }, {
        sub_total: 0,
        round_off: 0, payable_amt: 0, taxable_amount: 0,
        gst_amount: 0, sgst_amount: 0, cgst_amount: 0, net_amount: 0, round_off: 0,
        concession_applicable: 0
      }) || {};
      calData.sub_total = +CommonValidation.formatAmount(calData.sub_total)
      calData.taxable_amount = +CommonValidation.formatAmount(calData.taxable_amount)
      calData.gst_amount = +CommonValidation.formatAmount(calData.gst_amount)
      calData.sgst_amount = +CommonValidation.formatAmount(calData.sgst_amount)
      calData.cgst_amount = +CommonValidation.formatAmount(calData.cgst_amount)
      calData.concession_applicable = +CommonValidation.formatAmount(calData.concession_applicable)
      calData.round_off = Math.round(calData.payable_amt) - calData.payable_amt
      calData.payable_amt = Math.round(calData.payable_amt)
      calData.net_amount = Math.round(calData.net_amount)
      if (list?.length) {
        setBilling((prev) => ({ ...prev, overall_data: { ...prev?.overall_data, ...calData } }));
      }
      return calData;
    } catch (error) {
      errorMessage(error.message);
    }
  }, [billingList]);

  useEffect(() => {
    if (billingList && billingList?.length > 0) {
      billingCalculation();
    }

    if (billingList?.length === 0) {
      setBilling((prev) => ({
        ...prev,
        overall_data: {
          ...prev.overall_data,
          sub_total: 0, overall_discount_amt: '',
          round_off: 0, payable_amt: 0, taxable_amount: 0,
          gst_amount: 0, sgst_amount: 0, cgst_amount: 0, net_amount: 0, round_off: 0,
          overall_discount_percent: '', overall_discount_percent_w_r: '', concession_applicable: 0
        }
      }))
    }
  }, [billingList, billingCalculation])

  const onChangeHandler = (e, key) => {
    try {
      let value = e.target.value
      setBilling((prev) => {
        switch (key) {
          case 'cash_amt':
          case 'card_amt':
          case 'upi_amt':
          case 'bank_amt':
          case 'cheque_amt':
            if ((CommonValidation.numberOnly(value) && +value <= billing?.final_amount) || value === '') {
              return { ...prev, [key]: value }
            } else {
              return { ...prev }
            }
          default:
            return { ...prev, [key]: value }
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }
  const rejectBill = (remarks) => {
    setRequestState((prevstate) => ({ ...prevstate, status: "Rejected", rejected_remarks: remarks }))
    setBilling((prev) => ({ ...prev, overall_data: { overall_discount_amt: "" }, postBillClicked: true, }))
    discountZero(billingList, "Rejected")
  }

  const popClose = () => {
                setAnnualFeeAlert(false)
    setRequestState((prevstate) => ({ ...prevstate, isDelete: false, rejected_remarks: '', pendingCancel: false }))
  }
  const confirmRemove = () => {
            setAnnualFeeAlert(false)
            onAddHandler()
    };

  const renderPatientCard = (item, type, labelTwo = "", labelThree) => {
    try {
      let gender = item?.patient_gender === 'm' ? 'Male' : item?.patient_gender === 'Female' ? 'F' : 'T'
      let patientName = `${item?.patient_name} ${item?.patient_age}/${gender} | ${item?.ip_number}`
      let uhidMob = `${item.patient_account_number} | ${item?.mobile_number} | ${formatDate(item?.admitted_date)}`
      let profile = item?.photo_url ? item?.photo_url : gender === 'M' ? ImagePaths.Male.default : ImagePaths.Female.default
      let borderColor = item?.patient_type === 'New Patient' ? '#F1584A' : item?.patient_type === 'Review Patient' ? '#29B6F6' : '#800080'
      let consultantName = 'Anand'
      return (
        <Box component={'div'} sx={{ backgroundColor: "white", marginLeft: '0.5vw', padding: "0.5vw", boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          {type === 'amount_card' ?
            <Box component={'div'} sx={{ width: "13vw" }}>
              <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box component={'img'} src={CurrencySymbol === '$' ? ImagePaths.Dollor.default : ImagePaths.Rupee.default} height={'2.3dvh'} width={'2.3dvw'} />
                </Box>
                <Box component={'div'}>
                  <Typography fontSize={STYLES.FONT_SIZE_LOW_3} color={Colors.grayShade}>{item}</Typography>
                  <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{labelTwo}</Typography>
                  {showPharmacy && labelThree ? <Typography fontSize={STYLES.FONT_SIZE_LOW_3} fontWeight={600}>{labelThree}</Typography> : null}
                </Box>
              </Box>
            </Box> :
            type === 'consultant' ?
              <Box component={'div'} sx={{ width: "13vw" }}>
                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                  <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box component={'img'} src={ImagePaths.Doctor_Icon.default} height={'5dvh'} width={'2.3dvw'} />
                  </Box>
                  <Box component={'div'}>
                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3} color={Colors.grayShade}>{'Consultant Name'}</Typography>
                    {consultantName ? consultantName?.length > 30 ?
                      <Tooltip placement='top' title={consultantName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName?.slice(0, 30) + '...'}</Typography></Tooltip> :
                      <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName}</Typography> : '-'}
                  </Box>
                </Box>
              </Box> :
              <Box component={'div'} sx={{ width: "24dvw" }}>
                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                  <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box component={'img'} src={profile} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${borderColor}`} />
                  </Box>
                  <Box component={'div'}>
                    {patientName ? patientName?.length > 45 ?
                      <Tooltip placement='top' title={patientName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, 45) + '...'}</Typography></Tooltip> :
                      <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}</Typography> : '-'}
                    {uhidMob ? uhidMob?.length > 55 ?
                      <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 55) + '...'}</Typography></Tooltip> :
                      <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                  </Box>
                </Box>
              </Box>}
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderPendingDraftPopup = () => {
    try {
      const order = [
        {
          field: 'order_item_number', headerName: 'Order Details', flex: 0.25,
          renderCell: (params) => {
            let tempInvoice = params?.row?.order_item_number
            return (
              <Box>
                <Typography fontSize={'0.9rem'} fontWeight={600}>{tempInvoice}</Typography>
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{convertDateTime(params?.row?.created_date)}</Typography>
              </Box>
            )
          }
        },
        {
          field: 'service_name', headerName: 'Service Name', flex: 0.3,
          renderCell: (params) => {
            let tempInvoice = params?.row?.service_name
            let PackageName = params?.row?.assorted_package_name || params?.row?.package_name
            return (
              <Box>
                {tempInvoice ? tempInvoice?.length > 32 ?
                  <Tooltip placement='top' title={tempInvoice}><Typography fontSize={'0.9rem'}>{tempInvoice?.slice(0, 30) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} >{tempInvoice}</Typography> : '-'}
                {PackageName ? PackageName?.length > 32 ?
                  <Tooltip placement='top' title={PackageName}><Typography fontSize={'0.9rem'}>{PackageName?.slice(0, 30) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={Colors.grayShade} >{PackageName}</Typography> : null}
              </Box>
            )
          }
        },
        {
          field: 'module_type', headerName: 'Module', flex: 0.15,
          renderCell: (params) => {
            return (
              <Box>{params?.row?.module_type || "-"}</Box>
            )
          }
        },
        {
          field: 'bill_doctor_name', headerName: 'Doctor Name', flex: 0.2,
          renderCell: (params) => {
            return (
              <Box>
                {params?.row?.bill_doctor_name ? params?.row?.bill_doctor_name?.length > 25 ?
                  <Tooltip placement='top' title={params?.row?.bill_doctor_name}><Typography fontSize={'0.9rem'}>{'...' + params?.row?.bill_doctor_name?.slice(0, 23)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{params?.row?.bill_doctor_name}</Typography> : '-'}
              </Box>
            )
          }
        }
      ]
      return (
        <Dialog open={billing?.openPendingPop} fullWidth maxWidth='md'>
          <Box className='com_billing_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography fontSize={'1rem'} fontWeight={600}>Pending Order</Typography>
              <IconButton
                onClick={() => {
                  setBilling((prev) => ({ ...prev, openPendingPop: false }))
                }}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
              </IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Box component={'div'}>
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>Patient Details</Typography>
                <Box component={'div'} width={'20dvw'}>
                  {renderPatientCard(PatientDetails)}
                </Box>
              </Box>
            </Box>
            <Box component={'div'} height={'60dvh'} p={'0.5rem'}>
              <DataGrid
                columns={order}
                rows={billing?.pending_orders}
                getRowId={(row) => row['id']}
                rowsPerPageOptions={[10, 20, 30]}
                loading={isLoader}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  NoRowsOverlay: () => (
                    <Box height="100%" alignItems="center" justifyContent="center">
                      {("No Records Found")}
                    </Box>
                  )
                }}
                headerHeight={40}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderRgtContent = () => {
    let HidePayment = (billing?.applyFinalConcession || billing?.pending_orders?.length || FinalBillPosted || billing?.refund_clicked || (requestState?.fromPendingList && (billing?.overall_data?.overall_discount_amt > 0 || requestState.hasConcession)) || requestState?.fromApprover)
    let userInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    let CoPayment = JSON.parse(localGetItem('co_payment_option_for_insurance')) || false
    let is_initiated = historyData?.discharge_status === 'Initiate Bill' && !historyData?.is_final_bill_generated
    let is_bill_generated = historyData?.discharge_status === 'Initiate Bill' && historyData?.is_final_bill_generated

    return (
      <Box component={'div'} overflow={'auto'}>
        <Box component={'div'} height={'64dvh'} overflow={'auto'} paddingRight={"0.5vw"}>
          <Grid container rowGap={1}>
            <Grid xs={12} p={'0.5rem'} sx={{ backgroundColor: 'white' }} rowGap={2}>
              <Box component={'div'}>
                <Box sx={{ margin: "0.5dvw", display: 'flex', justifyContent: 'center', flexDirection: "column" }}>
                  {(billing.applyFinalConcession && !userInfo?.permission_access?.common?.allow_concession && loginInfo?.is_user && (requestState?.fromApprover || requestState?.fromPendingList || (billing?.overall_data?.overall_discount_amt > 0 || requestState.hasConcession))) ?
                    <Grid xs={12}>
                      {(requestState.fromPendingList && (billing?.overall_data?.overall_discount_amt === 0 || billing?.overall_data?.overall_discount_amt === '' || !requestState.hasConcession)) ||
                        (billing?.overall_data?.overall_discount_amt == billing?.tempDisAmt && billing?.fromFinalConcession) ||
                        ((billing?.overall_data?.overall_discount_amt === 0 || billing?.overall_data?.overall_discount_amt === '' || !requestState.hasConcession) && billing?.fromFinalConcession) ? null :
                        <Box component={'div'}>
                          <Box mt={'0.5rem'} mb={'1rem'} border={'1px solid red'} display={'flex'} alignItems={'center'}>
                            <Box component={'div'} mt={'0.2rem'}><ReportGmailerrorredIcon color='error' sx={{ height: '2.5dvw', width: '2.5dvw' }} /></Box>
                            <Box component={'div'}><Typography fontSize={'0.8rem'} fontWeight={'600'} color={'red'}>The Concession has been applied to this bill.Approver need to verify the concession amount to continue</Typography></Box>
                          </Box>
                          {!requestState?.fromApprover ?
                            <Box component={'div'}>
                              <Autocomplete
                                size='small'
                                sx={{ width: '15dvw' }}
                                options={requestState?.approverList?.filter(user => user?.is_frontoffice)}
                                getOptionLabel={(option) => option?.login_user_name || ""}
                                value={
                                  requestState.selectedApprover ||
                                  requestState.approverList?.find(
                                    (user) => user.login_user_id === requestState.selectedApproverId
                                  ) || null
                                }
                                clearIcon={false}
                                onChange={(e, newValue) => {
                                  setRequestState((prev) => ({
                                    ...prev,
                                    selectedApprover: newValue,
                                    selectedApproverId: newValue?.login_user_id || null,
                                  }));
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, emed_tid: 'req_name' }}
                                    label='Select Approver *'
                                  />
                                )}
                              />
                            </Box> : null}
                          <Box component={'div'} mb={'1rem'} mt={'0.5rem'}>
                            <Typography fontSize={'0.9rem'} fontWeight={600} mb={'0.5rem'}>Remarks</Typography>
                            <TextField
                              multiline
                              maxRows={3}
                              minRows={3}
                              fullWidth
                              size='small'
                              disabled={requestState?.fromApprover}
                              value={requestState.discount_remarks}
                              placeholder='Enter Comments Here'
                              InputProps={{ emed_tid: 'req_cmts' }}
                              onChange={(e) => {
                                let value = e.target.value
                                if (value?.length <= 250 || value === '') {
                                  setRequestState((prev) => ({ ...prev, discount_remarks: value }))
                                } else {
                                  errorMessage('Allowed Only 250 Characters')
                                }
                              }}
                            />
                          </Box>
                        </Box>}
                    </Grid> : null}
                  {(billing.applyFinalConcession) ?
                    requestState?.fromApprover ?
                      requestState.modifyBill ?
                        <Box>
                          <Box component={'div'} display={'flex'}>
                            <Button variant='contained' sx={{ height: '4dvh', width: '11dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setRequestState((prevstate) => ({ ...prevstate, modifyBill: false, }))
                                setBilling((prev) => ({ ...prev, edit_orders: false,isCard:false,isBank:false,isUPI:false,isCash:false,isCheque:false,
                                  card_amt:'',card_no:'',bank_amt:'',bank_no:'',cheque_amt:'',cheque_no:'',upi_amt:'',upi_no:'',cash_amt:''
                                 }))
                              }}>Save Changes</Button>
                            <Button variant='outlined' sx={{ height: '4dvh', width: '11dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setBilling((prev) => ({ ...prev, edit_orders: false,isCard:false,isBank:false,isUPI:false,isCash:false,isCheque:false,
                                  card_amt:'',card_no:'',bank_amt:'',bank_no:'',cheque_amt:'',cheque_no:'',upi_amt:'',upi_no:'',cash_amt:'' }))
                                setRequestState((prevstate) => ({ ...prevstate, modifyBill: false }))
                                getIpOrderListData(PatientDetails?.ip_admission_id, PatientDetails, false)
                              }}>Reset and Back</Button>
                          </Box>
                        </Box> :
                        <Box component={'div'}>
                          <Box component={'div'} mb={'0.5rem'} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                            <Button variant='contained' disabled={!billing?.overall_data?.overall_discount_amt && !requestState.hasConcession} disableElevation sx={{ height: '4dvh', width: '22dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setBilling((prev) => ({ ...prev, postBillClicked: true, }))
                                setRequestState((prevstate) => ({ ...prevstate, status: "Accepted" }))
                              }}>Accept</Button>
                            {requestState?.discount_remarks && requestState?.fromApprover &&
                              <Tooltip title={`Request Remarks : ${requestState?.discount_remarks}`} placement='top' arrow>
                                <CommentIcon sx={{ fontSize: '1.5rem' }} color='primary' />
                              </Tooltip>}
                          </Box>
                          <Box component={'div'} display={'flex'}>
                            <Button variant='outlined' sx={{ height: '4dvh', width: '11dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setRequestState((prevstate) => ({ ...prevstate, status: "Modify", modifyBill: true }))
                                setBilling((prev) => ({ ...prev, edit_orders: true }))
                              }}>Modify</Button>
                            <Button variant='outlined' color='error' sx={{ height: '4dvh', width: '11.5dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setRequestState((prevstate) => ({ ...prevstate, isDelete: true, status: "Rejected" }))
                              }}>Reject</Button>
                          </Box>
                        </Box>
                      :
                      requestState?.fromPendingList && (billing?.overall_data?.overall_discount_amt > 0 || requestState.hasConcession) ?
                        <Box component={'div'}>
                          <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize', mr: '1rem' }}
                            onClick={() => {
                              history?.push({ pathname: '/HospitalBilling/PendingList', state: {} })
                            }}
                          >Back</Button>
                          <Button variant='contained' sx={{ height: '4dvh', width: '10dvw', textTransform: 'capitalize', mr: '1rem' }}
                            onClick={() => {
                              concessionRiseRequest()
                            }}
                          >Update Request</Button>
                        </Box> :
                        requestState?.fromCancel ?
                          <Box component={'div'}>
                            <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                history?.push({ pathname: '/HospitalBilling/PendingList', state: {} })
                              }}
                            >Back</Button>
                            <Button variant='contained' color="error" sx={{ height: '4dvh', width: '10dvw', textTransform: 'capitalize', mr: '1rem' }}
                              onClick={() => {
                                setBilling((prev) => {
                                  setRequestState((prevstate) => ({ ...prevstate, status: "Cancelled" }))
                                  return { ...prev, postBillClicked: true }
                                })
                              }}
                            >Request Cancel</Button>
                          </Box> :
                          (!userInfo?.permission_access?.common?.allow_concession && loginInfo?.is_user && (billing?.overall_data?.overall_discount_amt > 0 || requestState.hasConcession || (billing?.tempDisAmt != billing?.overall_data?.overall_discount_amt && billing?.overall_data?.overall_discount_amt) && billing?.fromFinalConcession && loginInfo?.is_user)) ?
                            <Box component={'div'} sx={{ display: "flex", alignItems: 'center', flexDirection: 'column' }}>
                              <Button variant='contained' sx={{ width: "20dvw", marginTop: "1vw", textTransform: 'capitalize' }}
                                onClick={() => {
                                  concessionRiseRequest()
                                }}
                              >Raise Request</Button>
                              <Button
                                disabled={billing?.postBillClicked}
                                sx={{ width: "20dvw", marginTop: "1vw", textTransform: 'capitalize' }}
                                variant='outlined'
                                onClick={() => {
                                  getIpOrderListData(PatientDetails?.ip_admission_id, PatientDetails, true)
                                  setRequestState((prevstate) => ({ ...prevstate, status: "", discount_remarks: "", selectedApprover: "", selectedApproverId: null }))
                                }}
                              >Reset & Back</Button>
                            </Box>
                            : requestState?.fromPendingList && (billing?.overall_data?.overall_discount_amt === 0 || billing?.overall_data?.overall_discount_amt === '' || !requestState.hasConcession) ?
                              <Box component={'div'}>
                                <Button
                                  sx={{ width: "20dvw", textTransform: 'capitalize' }}
                                  variant='contained'
                                  onClick={() => {
                                     setRequestState((prev) => ({ ...prev, isDelete: true, pendingCancel: true }))
                                     setBilling((prev) => ({...prev,isCard:false,isBank:false,isUPI:false,isCash:false,isCheque:false,
                                  card_amt:'',card_no:'',bank_amt:'',bank_no:'',cheque_amt:'',cheque_no:'',upi_amt:'',upi_no:'',cash_amt:''
                                 }))
                                     }}
                                >Save Changes</Button>
                              </Box> :
                              <Box sx={{ display: "flex", alignItems: 'center', flexDirection: 'column' }}>
                                <Button
                                  disabled={billing?.postBillClicked}
                                  sx={{ width: "20dvw", textTransform: 'capitalize' }}
                                  variant='contained'
                                  onClick={() => {
                                    setBilling((prev) => ({ ...prev, postBillClicked: true,isCard:false,isBank:false,isUPI:false,isCash:false,isCheque:false,
                                  card_amt:'',card_no:'',bank_amt:'',bank_no:'',cheque_amt:'',cheque_no:'',upi_amt:'',upi_no:'',cash_amt:''
                                  }))
                                  }}
                                >Save Changes</Button>
                                <Button
                                  disabled={billing?.postBillClicked}
                                  sx={{ width: "20dvw", marginTop: "1vw", textTransform: 'capitalize' }}
                                  variant='outlined'
                                  onClick={() => {
                                    setBilling((prev) => ({...prev,isCard:false,isBank:false,isUPI:false,isCash:false,isCheque:false,
                                  card_amt:'',card_no:'',bank_amt:'',bank_no:'',cheque_amt:'',cheque_no:'',upi_amt:'',upi_no:'',cash_amt:''
                                 }))
                                    getIpOrderListData(PatientDetails?.ip_admission_id, PatientDetails, true)
                                  }}
                                >Reset & Back</Button>
                                {
                                  billing?.pending_orders?.length ?
                                    <Button
                                      color='warning'
                                      variant='outlined'
                                      sx={{ width: "20dvw", marginTop: "1vw", textTransform: 'capitalize' }}
                                      startIcon={<GppMaybeIcon color='warning' />}
                                      onClick={() => {
                                        setBilling((prev) => ({ ...prev, openPendingPop: true }))
                                      }}
                                    >{`Pending Order (${billing?.pending_orders?.length})`}</Button> : null
                                }
                              </Box>
                    :
                    <Box sx={{ display: "flex", alignItems: 'center', flexDirection: 'column' }}>
                      <Box sx={{ display: "flex", alignItems: 'center', flexDirection: 'row', width: "24.5vw", justifyContent: "space-between" }}>
                        {is_bill_generated ? null : <Button sx={{ textTransform: 'capitalize', width: "12vw" }} variant='contained'
                          disabled={billing?.overall_data?.overall_discount_percent_w_r}
                          onClick={() => setBilling((prev) => ({ ...prev, applyFinalConcession: true, edit_orders: true }))}
                        >Add & Edit Orders</Button>}
                        <Button sx={{ textTransform: 'capitalize', width: is_bill_generated ? '25vw' : "12vw" }} variant='contained'
                          disabled={billing?.pending_orders?.length}
                          onClick={() => setBilling((prev) => ({ ...prev, applyFinalConcession: true, fromFinalConcession: true }))}
                        >Final Concession</Button>
                      </Box>
                      {
                        billing?.pending_orders?.length ?
                          <Button
                            color='warning'
                            variant='outlined'
                            sx={{ width: "20dvw", marginTop: "1vw", textTransform: 'capitalize' }}
                            startIcon={<GppMaybeIcon color='warning' />}
                            onClick={() => {
                              setBilling((prev) => ({ ...prev, openPendingPop: true }))
                            }}
                          >{`Pending Order (${billing?.pending_orders?.length})`}</Button> : null
                      }
                    </Box>
                  }
                </Box>

                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Sub Amount`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(billing?.total_amount)}`}</Typography>
                </Box>
                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Total Concession Amount`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(billing?.total_concession_amount)}`}</Typography>
                </Box>
                {(loginInfo?.is_gst_enabled || RoomChargeGST?.is_room_charge_gst_applicable) ? <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Total GST Amount`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(billing?.total_gst_amount)}`}</Typography>
                </Box> : null}
                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Round Off Amount`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(billing?.round_off)}`}</Typography>
                </Box>
                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Net Amount`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat((+billing?.total_amount || 0) - (+billing?.total_concession_amount || 0))}`}</Typography>
                </Box>
                {billing?.total_advance_adjusted ? <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Advance Adjusted`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(+billing?.total_advance_adjusted)}`}</Typography>
                </Box> : null}
                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`Advance Paid`}</Typography>
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_MD}>{`${AmountFormat(+PatientDetails?.advance_amount)}`}</Typography>
                </Box>
                {+PatientDetails?.advance_amount > 0 && is_bill_generated ?
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} visibility={(HidePayment) ? 'hidden' : 'visible'}>
                      <FormControlLabel control={<Checkbox size='small' checked={billing?.pay_from_advance} onChange={(e) => {
                        setBilling((prev) => {
                          return { ...prev, pay_from_advance: e.target.checked, advance_deducted: e.target.checked ? ((billing?.final_amount <= +PatientDetails?.advance_amount) ? billing?.final_amount : +PatientDetails?.advance_amount) : "" }
                        })
                      }} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Deducte from advance</Typography>} />
                      <TextField
                        autoComplete='off'
                        size='small'
                        InputProps={{ emed_tid: 'con_amt', style: { height: '4dvh' } }}
                        sx={{ width: '8dvw' }}
                        disabled={historyData?.ForCancel ? true : false}
                        placeholder={CurrencySymbol}
                        value={billing?.advance_deducted || ""}
                        onChange={(e) => {
                          let value = e.target.value
                          if ((CommonValidation.numberOnly(value) && +value >= 1 && +value <= billing?.final_amount) || value === '') {
                            setBilling((prev) => {
                              return { ...prev, advance_deducted: value }
                            })
                          }
                        }}
                      />
                    </Box> : null
                }
              </Box >
              {is_initiated && !is_bill_generated ?
                <div>
                  <hr/>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", visibility: (HidePayment) ? 'hidden' : 'visible' }}><Typography fontSize={'1rem'} fontWeight={600}>Total Receivable Amount</Typography><Typography fontSize={'1rem'} fontWeight={600}>{PatientDetails?.advance_amount ? AmountFormat((+billing?.final_amount || 0) - (+billing?.advance_deducted || 0)) : AmountFormat(0)}</Typography></div>
                </div>
                :
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", visibility: (HidePayment) ? 'hidden' : 'visible' }}><Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Total receivable amount:</Typography><Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={600}>{PatientDetails?.advance_amount ? AmountFormat((+billing?.final_amount || 0) - (+billing?.advance_deducted || 0)) : AmountFormat(0)}</Typography></div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", visibility: (HidePayment) ? 'hidden' : 'visible' }}><Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Total advance refundable amount:</Typography><Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={600}>{PatientDetails?.advance_amount ? AmountFormat((+PatientDetails?.advance_amount || 0) - (+billing?.advance_deducted || 0)) : AmountFormat(0)}</Typography></div>
                </div>
              }
            </Grid >
            {is_initiated ? null :
              <div>
                <Grid xs={12}><Box sx={{ backgroundColor: 'white', mb: '0.5rem', pl: '0.5rem', display: (HidePayment) ? 'none' : 'block' }}>{showCashTextBox()}</Box></Grid>
              </div>}
            {historyData?.is_final_bill_generated ? <Grid xs={12}><Box sx={{ backgroundColor: 'white', mb: '0.5rem', pl: '0.5rem', display: (HidePayment || !CoPayment || billing?.credit_type !== "insurance") ? 'none' : 'block' }}>{showCoPaymentFeilds()}</Box></Grid> : null}
            <Grid xs={12}><Box sx={{ backgroundColor: 'white', mb: '0.5rem', pl: '0.5rem', display: (HidePayment) ? 'none' : 'block' }}>{showOutstandingTextBox()}</Box></Grid>
          </Grid >
        </Box >
        <Box component={'div'} sx={{ justifyContent: is_initiated ? 'center' : 'flex-end', display: (HidePayment) ? 'none' : 'flex' }}>
          {/* {
            +PatientDetails?.advance_amount > 0 ?
              <Button
                size='small'
                variant='contained'
                color='error'
                sx={{ textTransform: 'capitalize', marginRight: "1vw", marginBottom: "0.5dvh" }}
                onClick={() => {
                  setBilling((prev) => {
                    return { ...prev, refund_clicked: true }
                  })

                }}
              >Refund</Button> : null
          } */}
          
          {is_bill_generated ?
            <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5vw', marginRight: '0.5vw' }}>
              <Button sx={{ textTransform: 'capitalize', width: "12.2dvw", marginBottom: "0.5dvh" }} size='small' variant='contained'
                disabled={billing?.overall_data?.overall_discount_percent_w_r}
                onClick={() => setBilling((prev) => ({ ...prev, applyFinalConcession: true, edit_orders: true }))}
              >Modify</Button>
              <Button
                size='small'
                variant='contained'
                sx={{ textTransform: 'capitalize', width: "12.2dvw", marginBottom: "0.5dvh" }}
                disabled={localGetItem('set_due_date_for_credit_billing') === 'true' ?
                  ((billing.credit_type && !billing.credit_due_date) || GivenAmount !== +billing?.final_amount)
                  : GivenAmount !== +billing?.final_amount}
                onClick={() => {
                  setBilling((prev) => {
                    return { ...prev, postBillClicked: true }
                  })
                }}
              >{'Final Settlement'}</Button>
            </div>
            :
            <Button
              size='small'
              variant='contained'
              sx={{ textTransform: 'capitalize', width: is_initiated ? '96%' : "14dvw", marginBottom: "0.5dvh" }}
              disabled={(localGetItem('set_due_date_for_credit_billing') === 'true' ?
                ((billing.credit_type && !billing.credit_due_date) || GivenAmount !== +billing?.final_amount)
                : GivenAmount !== +billing?.final_amount) || (billingList?.length <= 0 && billing?.pharmacy_bills?.length <= 0 && billing?.ot_bills?.length <= 0)}
              onClick={() => {
                setBilling((prev) => {
                  return { ...prev, postBillClicked: true, generateFinalBillClicked: is_initiated && !is_bill_generated ? true : false }
                })
              }}
            >{is_initiated && !is_bill_generated ? 'Generate Final Bill' : 'Final Settlement'}</Button>}
        </Box>
      </Box>
    )
  }

  const sendeBill = () => {
    try {
      seteBill((prev) => ({ ...prev, isEbill: true }))
      let data = {
        "patient_id": PatientDetails?.patient_id,
        "ip_bill_summary_id": billsummaryID || null,
        "ip_receipt_id": receiptID || null,
        "is_sms": true,
        "is_email": false
      }
      RestAPIService.create(data, Serviceurls.SMS_SEND).
        then((response) => {
          if (response.data.status === 'success') {
            seteBill((prev) => ({
              ...prev,
              isEbill: false,
              isSMSText: 'SMS Sent Successfully !',
              smsDis: true,
              isWhatsAppText: '',
            }))
            setMessage((prev) =>({
              ...prev,
              isSuccessMsg: true,
              isSuccessMsgText: response.data.message
            }))
          }
        }).catch((error) => {
          seteBill((prev) =>({
            ...prev,
            isEbill: false,
            isSMSText: '',
          }))
          setMessage((prev) =>({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: error.message
          }))
        })
    } catch (e) {
      seteBill((prev) =>({
        ...prev,
        isEbill: false,
        isSMSText: '',
      }))
      setMessage((prev) => ({
        ...prev,
        isErrorMsg: true,
        isErrorMsgText: e.message
      }))
    }
  }
  console.log('billing', billing)
  const sendeWhatsApp = () => {
    try {
      seteBill((prev) =>({ ...prev, isWhatsApp: true }))
      let data = {
        "patient_id": PatientDetails?.patient_id,
        "ip_bill_summary_id": billsummaryID || null,
        "ip_receipt_id": receiptID || null,
        "is_whatsapp": true,
      }
      RestAPIService.create(data, Serviceurls.WHATSAPP_SEND).
        then((response) => {
          if (response.data.status === 'success') {
            seteBill((prev) => ({
              ...prev,
              isWhatsApp: false,
              isWhatsAppText: 'SMS Sent Successfully !',
              WhatsappDis: true,
              isSMSText: '',
            }))
            setMessage((prev) => ({
              ...prev,
              isSuccessMsg: true,
              isSuccessMsgText: response.data.message
            }))
          }
        }).catch((error) => {
          seteBill((prev) => ({
            ...prev,
            isWhatsApp: false,
            isWhatsAppText: '',
          }))
          setMessage((prev) => ({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: error.message
          }))
        })
    } catch (e) {
      seteBill((prev) => ({
        ...prev,
        isWhatsApp: false,
        isWhatsAppText: '',
      }))
      setMessage((prev) => ({
        ...prev,
        isErrorMsg: true,
        isErrorMsgText: e.message
      }))
    }
  }

  return (
    <Box component={'div'} sx={{ backgroundColor: Colors?.Background }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start', mt: '0.5rem' }}>
        <Box>{renderPatientCard(PatientDetails)}</Box>
        <Box>{renderPatientCard("Advance Amount", 'amount_card', AmountFormat(+PatientDetails?.advance_amount || 0), `PH ADV : ${AmountFormat(+PatientDetails?.pharmacy_advance_amount || 0)}`)}</Box>
        <Box>{renderPatientCard("Bill Amount", 'amount_card', AmountFormat(+PatientDetails?.service_amount || 0), `Incl. PH AMT : ${AmountFormat(+PatientDetails?.pharmacy_bill_amount || 0)}`)}</Box>
        <Box sx={{ backgroundColor: "white", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '0.5vw', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: "25vw", padding: "0.1vw" }}>
          <Box sx={{ width: "50%" }}>
            <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
              Insurance Name
            </div>
            {PatientDetails?.insurance_name ? PatientDetails?.insurance_name?.length > 20 ?
              <Tooltip placement='top' title={PatientDetails?.insurance_name}>
                <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                  {PatientDetails?.insurance_name?.slice(0, 20) + '...' || '-'}
                </div></Tooltip> :
              <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                {PatientDetails?.insurance_name?.slice(0, 30) + '...' || '-'}
              </div> : '-'}
            <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
              Policy Number
            </div>
            <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
              {PatientDetails?.policy_no || '-'}
            </div>
          </Box>
          <Box sx={{ width: "50%" }}>
            <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
              TPA
            </div>
            <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
              {PatientDetails?.tpa_name || '-'}
            </div>
            <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
              Corporate
            </div>
            <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
              {PatientDetails?.employer_name || '-'}
            </div>
          </Box>
        </Box>
        <Box>
          <Button
            startIcon={<ArrowBackIosNewIcon />}
            variant='outlined'
            sx={{ textTransform: 'capitalize', marginLeft: "1vw" }}
            onClick={() => {
              history.push({ pathname: "/IPHome" })
            }}
          >
            Back to IP Home
          </Button>
        </Box>
      </Box >
      <Grid container>
        <Grid xs={8.7}>
          <Box component={'div'}
            sx={{ borderRight: '1.5px solid lightgray' }} m={'0.5rem'}>{renderLftContent()}
          </Box>
        </Grid>
        <Grid xs={3.3}>
          <Box mt={'0.5rem'}>{renderRgtContent()}</Box>
        </Grid>
      </Grid>
      {ratePerUnitPopup()}
      {renderPendingDraftPopup()}
      {annualFeeAlert ? <ConfirmPopup
        cnfTitle={'Confirmation'}
        cnfContent={"This service is configured for annual auto billing, and proceeding will start the annual period from today."}
        cnfAlertPopupClose={popClose.bind(this)}
        cnfData={confirmRemove.bind(this)}
      /> : null}
      {
        message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null
      }
      {
        message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null
      }
      {
        billing?.refund_clicked ?
          <RefundReceivePopup
            title={`Refundable Amount - ${AmountFormat(PatientDetails?.advance_amount)}`}
            AlertPopupClose={ReasonPopupClose.bind(this)}
            label={"Refundable Amount"}
            btntext={'Close'}
            btnvarient={'outlined'}
            btncolor={'error'}
            btntext1={'Refund'}
            btnvarient1={'contained'}
            MaxRefundAmount={(+PatientDetails?.advance_amount || null)}
            refundPost={postRefund.bind(this)} />
          : null
      }
      {FinalBillPosted && !billing?.refund_clicked ?
        <Dialog open={true} >
          <DialogContent sx={{ padding: "2dvw", width: '29dvw', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
            <img className="eMed_Bill_Success_animation" src={ImagePaths.SuccessAnimationGif.default} />
            <Typography fontWeight={600}>{eBill.isSMSText ? eBill.isSMSText : eBill.isWhatsAppText ? eBill.isWhatsAppText : 'Final Bill Created Successfully !'}</Typography>
          </DialogContent>
          <DialogActions>
            {+PatientDetails?.advance_amount ? <Button variant='outlined' color='error' size='small' className='eMed_Filter_Btns' onClick={() => {
              setBilling((prev) => ({ ...prev, refund_clicked: true }))
            }}>{"Refund"}</Button> : null}
            <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => { setbillsummaryID(null); setreceiptID(null); history.push({ pathname: "/IPHome" }) }}>{"Back to IP Home"}</Button>
            {allowSms && patientData?.receive_sms ? <Tooltip title={'SMS'} placement="top">
              <IconButton disabled={eBill.smsDis} size="small" sx={{ height: '2vw', marginLeft: '.5vw' }}
                onClick={() => {
                  if (!eBill.isEbill) {
                    sendeBill()
                  }
                }}>
                {eBill.isEbill ? <CircularProgress sx={{ color: '#04B7B1' }} size={20} /> : eBill.smsDis ? <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.smsicon_dis.default} alt="sms" /> : <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.smsicon.default} alt="sms" />}
              </IconButton>
            </Tooltip> 
            : null}
             {allowWhatsapp && patientData?.receive_whatsapp ? <Tooltip title={'WhatsApp'} placement="top">
                <IconButton disabled={eBill.WhatsappDis} size="small" sx={{ height: '2vw', marginLeft: '.5vw' }}
                  onClick={() => {
                    if (!eBill.isWhatsApp) {
                      sendeWhatsApp()
                    }
                  }}>
                  {eBill.isWhatsApp ? <CircularProgress sx={{ color: '#04B7B1' }} size={20} /> : eBill.WhatsappDis ? <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.whatsappicon_dis.default} alt="sms" /> : <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.whatsappicon.default} alt="sms" />}
                </IconButton>
              </Tooltip>
              : null}
          </DialogActions>
        </Dialog>
        : null}
      {billing?.overallConcessionAlert ?
        <Dialog open={true} >
          <DialogTitle id="eMed_MaxDialog_Title">{"Alert !"}</DialogTitle>
          <DialogContent sx={{ padding: "2dvw", width: '29dvw', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
            <Typography >{`Once the overall concession is given, new orders can't be added or edited further. Are you sure you want to give the concession?`}</Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => { setBilling((prev) => ({ ...prev, overallConcessionAlert: false })) }}>{"Close"}</Button>
            <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => { setBilling((prev) => ({ ...prev, overallConcessionAlert: false, selectedOverall: true })) }}>{"Ok"}</Button>
          </DialogActions>
        </Dialog>
        : null}
      {successPopup.SuccessInvoice_ID !== null ? <BillSuccessPoPUp isDirectPrint={true} finalBill={true} isCredit={successPopup.isCredit} CloseBtnText={'Close'} moduleType={"IP"} InvoiceId={historyData?.id} ClosePopUp={ClosePopUp} successTxt={successPopup?.successText} /> : null}
      {requestState?.isDelete ?
        <ReasonPopup
          title={requestState.pendingCancel ? 'Are you sure do you want to cancel the request ?' : "Are you sure you want to reject the request ?"}
          AlertPopupClose={popClose}
          label={"Enter the Cancel Reason"}
          btntext={'Cancel'}
          btnvarient={'outlined'}
          btncolor={'error'}
          btntext1={'Confirm'}
          btnvarient1={'contained'}
          note={true}
          subTitle={requestState.pendingCancel ? '*The system cancels the request if the concession amount is set to zero.' : "*If you reject a concession request, the system will generate a order reflecting the original amount, with no concession applied."}
          sendCmt={rejectBill.bind(this)} />
        : null}
      <Loader loaderOpen={isLoader} />
    </Box >
  )
}

export default IpFinalSettlement